// Original public press records, preserved from pagePress.vue.
// 2026-10-15 起：這份是 Obsidian〈吳哲宇媒體資訊中心〉（SSOT）的公開鏡像——先改 SSOT 再改這裡，規則見 docs/PRESS.md。
import { pressThumbs, pressThumbPath } from "./press-thumbs.mjs";
export const pressRecords = [
  {
    id: 277,
    title: "White Castle Announces NFT Collaboration with Doodle Labs & Media Artist, Che-Yu Wu",
    titleEn: "White Castle Announces NFT Collaboration with Doodle Labs & Media Artist, Che-Yu Wu",
    excerpt: "白色城堡（White Castle）透過 PR Newswire 發出的新聞稿原文：為慶祝品牌 100 週年，與 Doodle Labs 合作推出數位媒體藝術家吳哲宇的 5,000 件生成藝術 NFT《Sliderverse》，是第一個採用 Art Blocks 生成鑄造技術的品牌合作，部分收益撥入員工救助與獎學金。",
    excerptEn: "White Castle's original release on PR Newswire: to mark its 100th birthday, the brand partners with Doodle Labs on Sliderverse, 5,000 generative art NFTs by digital media artist Che-Yu Wu and the first brand partnership powered by Art Blocks' generative minting technology, with part of the proceeds going to team member relief and scholarship funds.",
    date: "2021/12/16",
    url: "https://www.prnewswire.com/news-releases/white-castle-announces-nft-collaboration-with-doodle-labs--media-artist-che-yu-wu-301446920.html",
    source: "PR Newswire（White Castle 新聞稿）",
    sourceEn: "PR Newswire (White Castle press release)",
    category: "press",
  },
  {
    id: 276,
    title: "讓AI讀書算犯法？著作權法未鬆綁 主權AI訓練語料僅1%來自民間…難拓展制度哪卡關？",
    titleEn: "Is Letting AI Read a Crime? With Copyright Law Unchanged, Only 1% of Sovereign AI Training Data Comes from the Private Sector. Where Is the System Stuck?",
    excerpt: "聯合新聞網轉載今周刊報導：台灣繁中 AI 語料難擴張，《著作權法》還沒處理 AI 訓練。報導從吳哲宇發起的 Taiwan.md 寫起，他說主流模型的中文語料不到 1% 是繁體，團隊已收錄 1,123 篇文章，因為怕侵權而自我設限。",
    excerptEn: "udn.com republishes Business Today's report on why Taiwan's Traditional Chinese AI corpus struggles to grow while copyright law has yet to address AI training. It opens with Taiwan.md, started by Che-Yu Wu, who says less than 1% of the Chinese data used by mainstream models is in Traditional script; the project holds 1,123 articles but limits itself for fear of infringement.",
    date: "2026/10/14",
    url: "https://udn.com/news/story/6839/9813806",
    source: "聯合新聞網（轉載自今周刊）｜陳子萱",
    sourceEn: "udn.com (from Business Today) · 陳子萱",
    category: "press",
  },
  {
    id: 275,
    title: "廣受好評！《桃園演算室》ARTOGO線上展間同步開展  實體展至10月11日　把握國慶連假親身體驗",
    titleEn: "Well Received: TAOYUAN RE:CODE Opens an ARTOGO Online Exhibition Room as the Physical Show Runs to 11 October",
    excerpt: "桃園市環保局 10 月 8 日的新聞稿，宣布《桃園演算室》累計互動破萬人次，ARTOGO 線上展間上線，實體展到 10 月 11 日。稿中寫吳哲宇的 10 公尺環狀即時生成藝術《大地與川脈的編織》把數據化成流動的水紋與地景，觀眾輸入的永續行動也進入演算。",
    excerptEn: "The Taoyuan Department of Environmental Protection's release of 8 October says TAOYUAN RE:CODE has passed ten thousand interactions and opens an ARTOGO online exhibition room, with the physical show running to 11 October. It describes Che-Yu Wu's ten-metre ring of real-time generative art, Woven Land, Woven River, turning data into flowing ripples and landscape, with visitors' sustainable actions entering the computation.",
    date: "2026/10/08",
    url: "https://tydep.tycg.gov.tw/News_Content.aspx?n=20082&s=1892812",
    source: "桃園市政府環境保護局（新聞稿）",
    sourceEn: "Taoyuan Department of Environmental Protection (press release)",
    category: "press",
  },
  {
    id: 274,
    title: "廣受好評！《桃園演算室》ARTOGO線上展間同步開展實體展至10月11日　把握國慶連假親身體驗",
    titleEn: "Well Received: TAOYUAN RE:CODE Opens an ARTOGO Online Exhibition Room, with the Physical Show Running to 11 October",
    excerpt: "墨新聞刊出台灣新聞雲報記者王俊欽的稿：桃園市環保局宣布《桃園演算室》ARTOGO 線上展間上線，互動人次已破萬，實體展到 10 月 11 日。文中寫吳哲宇的 10 公尺環狀即時生成藝術《大地與川脈的編織》，把數據化成流動的水紋與地景。",
    excerptEn: "MORE News carries a report from another local news site: the Taoyuan Environmental Protection Bureau has opened an ARTOGO online exhibition room for TAOYUAN RE:CODE after passing ten thousand interactions, with the physical show running to 11 October. It describes Che-Yu Wu's ten-metre ring of real-time generative art, Woven Land, Woven River, turning data into flowing ripples and landscape.",
    date: "2026/10/08",
    url: "https://more-news.tw/738050/",
    source: "墨新聞 MORE News（轉載自台灣新聞雲報）｜王俊欽",
    sourceEn: "MORE News (from 台灣新聞雲報) · 王俊欽",
    category: "press",
  },
  {
    id: 273,
    title: "《桃園演算室》ARTOGO線上展間同步開展　實體展至10/11把握國慶連假親身體驗",
    titleEn: "TAOYUAN RE:CODE Opens an ARTOGO Online Exhibition Room as the On-Site Show Runs to 11 October",
    excerpt: "台灣好新聞刊出桃園市環保局 10 月 8 日的新聞稿：《桃園演算室》互動人次破萬，ARTOGO 線上展間上線。稿中寫吳哲宇的 10 公尺環狀即時生成藝術《大地與川脈的編織》把數據轉成水紋與地景，觀眾輸入的永續行動也成為演算的一部分。",
    excerptEn: "Taiwan Hot News runs the Taoyuan Environmental Protection Bureau's 8 October release: TAOYUAN RE:CODE has passed ten thousand interactions and opened an ARTOGO online exhibition room; it describes Che-Yu Wu's ten-metre ring of real-time generative art, Woven Land, Woven River, as turning data into ripples and landscape, with visitors' sustainable actions becoming part of the computation.",
    date: "2026/10/08",
    url: "https://www.taiwanhot.net/news/1150483",
    source: "台灣好新聞｜葉志成",
    sourceEn: "Taiwan Hot News · 葉志成",
    category: "press",
  },
  {
    id: 272,
    title: "台灣設計展《水之道 Life Around Water》 以「水」作為閱讀桃園的線索",
    titleEn: "Life Around Water at the Taiwan Design Expo Reads Taoyuan Through Water",
    excerpt: "台灣好新聞記者依桃園市水務局短稿，介紹台灣設計展 A10《水之道》以一滴水的旅程串起桃園的地景與水循環。展場入口以流動影像與水聲描繪水的旅程，MONOLAB 吳哲宇以《Cymatics of Life》為每位觀眾即時生成水波曼陀羅。",
    excerptEn: "Working from a short release by the Taoyuan Department of Water Resources, a Taiwan Hot News reporter introduces Life Around Water (A10) at the Taiwan Design Expo, which follows a drop of water through Taoyuan's landscape and water cycle. The entrance traces water's journey in flowing images and sound, and Che-Yu Wu of MONOLAB generates a Water Ripple Mandala live for each visitor with Cymatics of Life.",
    date: "2026/10/08",
    url: "https://www.taiwanhot.net/news/1150461",
    source: "台灣好新聞｜葉志成",
    sourceEn: "Taiwan Hot News · 葉志成",
    category: "press",
  },
  {
    id: 271,
    title: "桃園水務局台灣設計展推《水之道》展覽 限量送碳吉米燉飯",
    titleEn: "Taoyuan Department of Water Resources Presents Life Around Water at the Taiwan Design Expo, with Limited Low-Carbon Rice Risotto Giveaways",
    excerpt: "桃園電子報記者黃雅蘭刊出水務局稿，介紹台灣設計展 A10《水之道》與限量贈送的碳吉米燉飯。展覽透過藝術讓水被看見與聽見，入口以流動影像描繪水的旅程，吳哲宇以《Cymatics of Life》為每位觀眾即時生成專屬的水波曼陀羅。",
    excerptEn: "Taoyuan News runs the Department of Water Resources' release on Life Around Water in hall A10 of the Taiwan Design Expo and its limited giveaways of low-carbon rice risotto. Art lets water be seen and heard: the entrance traces water's journey in flowing images, and Che-Yu Wu's Cymatics of Life generates a Water Ripple Mandala live for each visitor.",
    date: "2026/10/08",
    url: "https://tyenews.com/2026/10/1415738/",
    source: "桃園電子報｜黃雅蘭",
    sourceEn: "Taoyuan News · 黃雅蘭",
    category: "press",
  },
  {
    id: 270,
    title: "2026台灣設計展「水之道 Life Around Water」登場，走進桃園與水共生的日常",
    titleEn: "Life Around Water Opens at the Taiwan Design Expo 2026: Into Taoyuan's Everyday Life with Water",
    excerpt: "城市指南 HereNow 刊出台灣設計展提供的水之道介紹，最後一段寫 MONOLAB 吳哲宇的《Cymatics of Life》：以音流學為概念，觀眾回答與日常用水有關的問題，答案化成參數與頻率，即時演算出專屬的水波曼陀羅。每半小時曲面牆還有一次定時展演。",
    excerptEn: "The city guide HereNow runs an introduction to Life Around Water provided by the Taiwan Design Expo. Its last section covers Cymatics of Life by MONOLAB's Che-Yu Wu: built on cymatics, visitors' answers to questions about everyday water use become parameters and frequencies, computed live into a Water Ripple Mandala of their own, and every half hour the curved wall stages a timed performance.",
    date: "2026/10/07",
    url: "https://www.herenow.city/feature/2026designexpo-water/",
    source: "HereNow（資料提供：2026台灣設計展）",
    sourceEn: "HereNow (text provided by Taiwan Design Expo 2026)",
    category: "press",
  },
  {
    id: 269,
    title: "「FLOW」が映し出す、生活を支える流れと地域の未来──台灣設計展2026・桃園から考える",
    titleEn: "What 'FLOW' Reveals: The Currents That Sustain Daily Life and the Future of a Region, Seen from Taoyuan at the Taiwan Design Expo 2026",
    excerpt: "沖繩的設計創新組織 DIO 在官網發表台灣設計展觀展記，寫到《桃園演算室》時，以日文介紹環狀生成藝術作品「大地と川脈の織りなす風景」：把二氧化碳排放資料與觀眾的減碳選擇即時演算、投影出來。文中沒有寫藝術家名字。",
    excerptEn: "DIO (Design Innovation Okinawa) publishes a visit report on the Taiwan Design Expo on its website; at TAOYUAN RE:CODE it describes, under a Japanese title, the looping generative artwork Woven Land, Woven River, which computes CO2 emission data and visitors' carbon-cutting choices in real time and projects them. The artist is not named.",
    date: "2026/10/06",
    url: "https://www.dio.okinawa.jp/insights/taiwan_design_expo2026/",
    source: "DIO デザインイノベーションおきなわ（機構署名）",
    sourceEn: "DIO Design Innovation Okinawa (institutional byline)",
    category: "press",
  },
  {
    id: 268,
    title: "【編輯筆記】從末日廢墟到循環咖啡廳：一場關於人類、AI 與環境的共存演算",
    titleEn: "Editor's Notes: From Apocalyptic Ruins to a Circular Café, a Computation of How Humans, AI and the Environment Coexist",
    excerpt: "b.l!nk 編輯筆記走一遍《桃園演算室》，動態演算區寫吳哲宇的《大地與川脈的編織》：把台灣 35 年的碳排變化、產業結構與桃園減碳政策織進數位織物，觀眾用手機回答碳排問答，數據化成光點，傳入 10 公尺環形螢幕。",
    excerptEn: "b.l!nk's editor's notes walk through TAOYUAN RE:CODE. In the dynamic computing zone, Che-Yu Wu's Woven Land, Woven River weaves 35 years of Taiwan's emission changes, industrial structure and Taoyuan's reduction policies into a digital fabric; visitors answer a carbon quiz on their phones, and the data travel as points of light into a ten-metre ring screen.",
    date: "2026/09/30",
    url: "https://blink.tw/features/recode/",
    source: "b.l!nk｜徐韞涵（撰稿）",
    sourceEn: "b.l!nk · Text by 徐韞涵",
    category: "press",
  },
  {
    id: 267,
    title: "台灣設計展明登場！「桃園演算室」打造5公尺高巨型裝置 亮點搶先看",
    titleEn: "Taiwan Design Expo Opens Tomorrow: TAOYUAN RE:CODE Unveils a Five-Metre Installation",
    excerpt: "桃園電子報記者黃雅蘭在開展前一天報導《桃園演算室》三大展區，寫到「動態演算區」展出吳哲宇的即時生成藝術《大地與川脈的編織》，整合碳排資料、桃園產業排放結構、淨零政策與民眾現場輸入的減碳選擇，在環形螢幕上生成水紋與埤塘地景。",
    excerptEn: "On the eve of the opening, Taoyuan News covers the three zones of TAOYUAN RE:CODE, noting that the dynamic computation zone shows Che-Yu Wu's real-time generative work Woven Land, Woven River, which combines carbon data, Taoyuan's industrial emissions, net-zero policy and the choices visitors enter on site to generate ripples and pond landscapes on a ring of screens.",
    date: "2026/09/23",
    url: "https://tyenews.com/2026/09/1410475/",
    source: "桃園電子報｜黃雅蘭",
    sourceEn: "Taoyuan News, 黃雅蘭",
    category: "press",
  },
  {
    id: 266,
    title: "2026台灣設計展　「桃園演算室」10公尺環狀即時生成藝術、碳排負重互動吸睛",
    titleEn: "Taiwan Design Expo 2026: TAOYUAN RE:CODE Draws Crowds with a Ten-Metre Ring of Real-Time Generative Art and Carbon-Weight Interactives",
    excerpt: "台灣好報記者劉蘇梅的稿，內容同環保局新聞稿：9 月 24 日開展的《桃園演算室》分三大展區，動態演算區展出吳哲宇的《大地與川脈的編織》，整合碳排資料、桃園產業排放結構與觀眾輸入的減碳選擇，在環形螢幕上即時生成桃園地景。",
    excerptEn: "A Taiwan Hot News story, matching the Environmental Protection Bureau's release: TAOYUAN RE:CODE, opening on 24 September, has three zones, and the dynamic computing zone shows Che-Yu Wu's Woven Land, Woven River, which combines emission data, Taoyuan's industrial emission structure and visitors' choices into a Taoyuan landscape generated live on a ring screen.",
    date: "2026/09/23",
    url: "https://tw.news.yahoo.com/2026%E5%8F%B0%E7%81%A3%E8%A8%AD%E8%A8%88%E5%B1%95-%E6%A1%83%E5%9C%92%E6%BC%94%E7%AE%97%E5%AE%A4-10%E5%85%AC%E5%B0%BA%E7%92%B0%E7%8B%80%E5%8D%B3%E6%99%82%E7%94%9F%E6%88%90%E8%97%9D%E8%A1%93-%E7%A2%B3%E6%8E%92%E8%B2%A0%E9%87%8D%E4%BA%92%E5%8B%95%E5%90%B8%E7%9D%9B-115316460.html",
    source: "Yahoo 新聞（轉載自台灣好報）｜劉蘇梅",
    sourceEn: "Yahoo News Taiwan (from Taiwan Hot News) · 劉蘇梅",
    category: "press",
  },
  {
    id: 265,
    title: "「桃園演算室」10公尺環狀即時生成藝術碳排負重互動吸睛",
    titleEn: "TAOYUAN RE:CODE: A Ten-Metre Ring of Real-Time Generative Art and Carbon You Can Lift",
    excerpt: "台灣大紀元刊出桃園市環保局的展前新聞稿：《桃園演算室》在台灣設計展 A9 展區登場，「動態演算區」展出吳哲宇的即時生成藝術《大地與川脈的編織》，整合碳排資料、桃園產業排放結構、淨零政策與觀眾輸入的減碳選擇。",
    excerptEn: "The Epoch Times Taiwan runs the Taoyuan Environmental Protection Bureau's pre-opening release: TAOYUAN RE:CODE opens in hall A9 of the Taiwan Design Expo, and its dynamic computing zone shows Che-Yu Wu's real-time generative work Woven Land, Woven River, which combines emission data, Taoyuan's industrial emission structure, net-zero policy and the carbon-cutting choices visitors enter.",
    date: "2026/09/23",
    url: "https://www.epochtimes.com.tw/n514130/",
    source: "台灣大紀元｜徐乃義",
    sourceEn: "The Epoch Times Taiwan · 徐乃義",
    category: "press",
  },
  {
    id: 264,
    title: "10公尺環狀即時生成藝術、碳排負重互動吸睛 2026台灣設計展「桃園演算室」亮點吸睛",
    titleEn: "A Ten-Metre Ring of Real-Time Generative Art and Carbon-Weight Interactives Draw Crowds at TAOYUAN RE:CODE, Taiwan Design Expo 2026",
    excerpt: "亞太新聞網刊出桃園市環保局 9 月 23 日的新聞稿，介紹台灣設計展《桃園演算室》三大展區。動態演算區一段寫吳哲宇的即時生成藝術《大地與川脈的編織》，在大型環形螢幕即時生成水紋、河川與埤塘般的桃園地景。民生電子報轉載。",
    excerptEn: "Asia Pacific News runs the Taoyuan Environmental Protection Bureau's release of 23 September on the three zones of TAOYUAN RE:CODE at the Taiwan Design Expo. The dynamic computing section describes Che-Yu Wu's real-time generative work Woven Land, Woven River, generating ripples, rivers and pond-like Taoyuan landscapes on a large ring screen. Republished by Lifenews.",
    date: "2026/09/23",
    url: "https://lifenews.com.tw/585163",
    source: "民生電子報（轉載自亞太新聞網）",
    sourceEn: "Lifenews (from Asia Pacific News)",
    category: "press",
  },
  {
    id: 263,
    title: "10公尺環狀即時生成藝術、碳排負重互動吸睛  2026台灣設計展「桃園演算室」亮點吸睛",
    titleEn: "A Ten-Metre Ring of Real-Time Generative Art and Carbon Weight Stations: Highlights of TAOYUAN RE:CODE at the Taiwan Design Expo 2026",
    excerpt: "大成報記者袁慧心刊出環保局 9 月 23 日的《桃園演算室》新聞稿，寫到「動態演算區」吳哲宇的即時生成藝術《大地與川脈的編織》，把碳排資料、淨零政策與現場民眾的減碳選擇，在大型環形螢幕即時生成桃園地景。",
    excerptEn: "A local newspaper runs the Environmental Protection Bureau's 23 September release on TAOYUAN RE:CODE, describing Che-Yu Wu's real-time generative work Woven Land, Woven River in the dynamic computing zone, which turns emission data, net-zero policy and visitors' choices into a Taoyuan landscape generated live on a large ring screen.",
    date: "2026/09/23",
    url: "https://times.586.com.tw/2026/09/999504/",
    source: "大成報（媒事網）｜袁慧心",
    sourceEn: "大成報 (times.586.com.tw) · 袁慧心",
    category: "press",
  },
  {
    id: 262,
    title: "「桃園演算室」　10公尺環狀即時生成藝術、碳排負重互動吸睛",
    titleEn: "TAOYUAN RE:CODE Draws Crowds with a Ten-Metre Ring of Real-Time Generative Art and Carbon-Weight Interactives",
    excerpt: "點傳媒記者彭慧婉刊出桃園市環保局的展區稿，介紹台灣設計展 A9《桃園演算室》三大展區。動態演算區是吳哲宇的即時生成藝術《大地與川脈的編織》，把碳排資料、產業排放、淨零政策與觀眾的減碳選擇，即時生成水紋與埤塘般的地景。",
    excerptEn: "NEWS586 runs the Taoyuan Environmental Protection Bureau's text on its A9 pavilion at the Taiwan Design Expo, TAOYUAN RE:CODE. In the dynamic computing zone, Che-Yu Wu's real-time generative work Woven Land, Woven River turns emission data, industrial emissions, net-zero policy and visitors' choices into a live landscape of ripples and ponds.",
    date: "2026/09/23",
    url: "https://news.586.com.tw/2026/09/653910/",
    source: "點傳媒 NEWS586｜彭慧婉",
    sourceEn: "NEWS586 · 彭慧婉",
    category: "press",
  },
  {
    id: 261,
    title: "2026台灣設計展「桃園演算室」10公尺環狀即時生成藝術、碳排負重互動吸睛",
    titleEn: "TAOYUAN RE:CODE at the Taiwan Design Expo 2026: A Ten-Metre Ring of Real-Time Generative Art and Carbon You Can Lift",
    excerpt: "台灣新聞雲報刊出桃園市環保局的展前新聞稿，介紹 A9《桃園演算室》三大展區。「動態演算區」展出吳哲宇的即時生成藝術《大地與川脈的編織》，把碳排資料與觀眾的減碳選擇，在環形螢幕上即時生成水紋、河川與埤塘般的地景。",
    excerptEn: "A local news site runs the Taoyuan Environmental Protection Bureau's pre-opening release on the three zones of TAOYUAN RE:CODE in hall A9; in the dynamic computing zone, Che-Yu Wu's real-time generative work Woven Land, Woven River turns emission data and visitors' carbon-cutting choices into a live landscape of ripples, rivers and ponds on the ring screen.",
    date: "2026/09/23",
    url: "https://www.fclnews.com/227407/",
    source: "台灣新聞雲報｜王俊欽",
    sourceEn: "台灣新聞雲報 (fclnews.com) · 王俊欽",
    category: "press",
  },
  {
    id: 260,
    title: "台灣設計展桃園演算室 展出永續與淨零轉型議題",
    titleEn: "TAOYUAN RE:CODE at the Taiwan Design Expo Takes On Sustainability and the Net-Zero Transition",
    excerpt: "中華日報記者依桃園市環保局 9 月 23 日的說明，介紹台灣設計展 A9《桃園演算室》三大展區。動態演算區一段寫吳哲宇的即時生成藝術《大地與川脈的編織》，整合碳排資料、桃園產業排放與民眾的減碳選擇，在環形螢幕生成水紋與埤塘地景。",
    excerptEn: "Working from the Taoyuan Environmental Protection Bureau's statement of 23 September, a China Daily News reporter introduces the three zones of TAOYUAN RE:CODE (A9) at the Taiwan Design Expo. The dynamic computing section describes Che-Yu Wu's real-time generative work Woven Land, Woven River, which combines emission data, Taoyuan's industrial emissions and visitors' choices to generate ripples and pond-like landscapes on a ring screen.",
    date: "2026/09/23",
    url: "https://www.cdns.com.tw/articles/1464670",
    source: "中華日報｜陳華興",
    sourceEn: "China Daily News · 陳華興",
    category: "press",
  },
  {
    id: 259,
    title: "10公尺環狀即時生成藝術、碳排負重互動吸睛 2026台灣設計展「桃園演算室」亮點吸睛",
    titleEn: "A Ten-Metre Ring of Real-Time Generative Art and Carbon Weight Stations: Highlights of TAOYUAN RE:CODE at the Taiwan Design Expo 2026",
    excerpt: "桃園市環保局 9 月 23 日的新聞稿，預告台灣設計展 A9 展區《桃園演算室》。「動態演算區」展出吳哲宇的即時生成藝術《大地與川脈的編織》，整合碳排資料、產業排放結構、淨零政策與觀眾的減碳選擇，在環形螢幕生成水紋、河川與埤塘般的地景。",
    excerptEn: "The Taoyuan Department of Environmental Protection's release of 23 September previews TAOYUAN RE:CODE in hall A9 of the Taiwan Design Expo. Its dynamic computing zone shows Che-Yu Wu's real-time generative work Woven Land, Woven River, which combines emission data, industrial emissions, net-zero policy and visitors' choices to generate a landscape of ripples, rivers and ponds on the ring screen.",
    date: "2026/09/23",
    url: "https://tydep.tycg.gov.tw/News_Content.aspx?n=20082&s=1878479",
    source: "桃園市政府環境保護局（新聞稿）",
    sourceEn: "Taoyuan Department of Environmental Protection (press release)",
    category: "press",
  },
  {
    id: 258,
    title: "真人認證中請稍候2》當AI說錯台灣，我們失去的是什麼？從繁中語料、內容授權到「主權AI」的下一場戰爭",
    titleEn: "Verifying You Are Human, Please Wait, Part 2: What Do We Lose When AI Gets Taiwan Wrong? From Traditional Chinese Corpora and Content Licensing to the Next Battle over Sovereign AI",
    excerpt: "Openbook 閱讀誌「真人認證中請稍候」系列講座第二場的現場紀錄，吳哲宇與 Noopher AI 創辦人陳宜昌對談。他說 Taiwan.md 想做一份給人也給 AI 讀的台灣說明書，像持續生長的珊瑚礁，主張從單一真相來源走向「多元真相的單一來源」。",
    excerptEn: "Openbook's report from the second talk in its series Verifying You Are Human, Please Wait, where Che-Yu Wu speaks with the founder of Noopher AI. Wu describes Taiwan.md as a guide to Taiwan written for people and for AI alike, growing like a coral reef, and argues for moving from a single source of truth to a single source of diverse truths.",
    date: "2026/09/10",
    url: "https://www.openbook.org.tw/article/p-72897",
    source: "Openbook 閱讀誌｜陳愷昀",
    sourceEn: "Openbook · 陳愷昀",
    category: "press",
  },
  {
    id: 257,
    title: "吳哲宇｜他用一座「數位珊瑚礁」，讓全球AI重新認識台灣",
    titleEn: "Che-Yu Wu: How a 'Digital Coral Reef' Is Helping the World's AI Get to Know Taiwan",
    excerpt: "生成式 AI 年會官方部落格的演講筆記，李慕約撰文：演算藝術家吳哲宇把人生資料、生成藝術與 Taiwan.md 串成數位生命體，重新想像有記憶、有個性、會自己長大的 side project。全文限年會訂閱會員閱讀。",
    excerptEn: "A talk write-up on the official blog of the Generative AI Conference: algorithmic artist Che-Yu Wu links his life data, generative art and Taiwan.md into a digital life form, reimagining the side project as something with memory and personality that grows on its own. The full text is for conference subscribers.",
    date: "2026/08/28",
    url: "https://blog.gaiconf.com/2026/cheyu-wu-digital-life/",
    source: "生成式 AI 年會部落格｜李慕約",
    sourceEn: "Generative AI Conference blog · 李慕約",
    category: "press",
  },
  {
    id: 256,
    title: "「台北板橋馥華艾美酒店」全新開幕 感官藝術策展打造旅居新風格",
    titleEn: "Le Méridien Taipei Banqiao Opens with a Sensory Art Programme for a New Style of Stay",
    excerpt: "旅奇傳媒介紹台北板橋馥華艾美酒店開幕與館內 15 位藝術家的感官藝術策展，寫到新媒體藝術家吳哲宇的《演算詩篇：馥光子午》：演算法即時生成的影像劇場，與鋼琴、弦樂、打擊即時聯動，從宇宙初生的微光走到清晨的海洋。",
    excerptEn: "A travel media outlet introduces the opening of Le Méridien Taipei Banqiao and its sensory art programme of 15 artists, including new media artist Che-Yu Wu's Algorithmic Verses, a theatre of images generated by algorithm in real time and linked live to piano, strings and percussion, travelling from the first light of the universe to the morning sea.",
    date: "2026/08/10",
    url: "https://udn.com/news/story/7205/9674355",
    source: "聯合新聞網（轉載自旅奇傳媒）",
    sourceEn: "udn.com (from 旅奇傳媒)",
    category: "press",
  },
  {
    id: 255,
    title: "AI 連台灣地圖都畫錯！演算法藝術家吳哲宇打造台灣知識庫 Taiwan.md，搶回文化話語權",
    titleEn: "AI Even Gets Taiwan's Map Wrong: Algorithmic Artist Che-Yu Wu Builds Taiwan.md to Reclaim Cultural Voice",
    excerpt: "未來城市＠天下記者詹湘淇的專訪，從 AI 畫錯台灣地圖與繁中語料失衡寫起，再寫吳哲宇用 AI Agent 打造的開源知識庫 Taiwan.md，把六階段改寫流程整理成表，也寫到影視配樂條目被要求下架、方法論改到第九版。",
    excerptEn: "An in-depth interview by Future City that opens with AI mis-drawing Taiwan's map and the imbalance of Traditional Chinese training data, then turns to Taiwan.md, the open knowledge base Che-Yu Wu built with AI agents. It tabulates the six-stage rewrite pipeline and reports a film-score entry readers asked to take down and the methodology's ninth revision.",
    date: "2026/08/07",
    url: "https://futurecity.cw.com.tw/article/4096",
    source: "未來城市＠天下｜詹湘淇",
    sourceEn: "Future City @ CommonWealth, 詹湘淇",
    category: "interview",
  },
  {
    id: 254,
    title: "國際品牌插旗板橋馥華艾美酒店開幕 打造新北高端旅宿新指標",
    titleEn: "An International Brand Lands in Banqiao as Le Méridien Taipei Banqiao Opens, Setting a New Benchmark for Luxury Stays in New Taipei",
    excerpt: "聯合新聞網記者黃淑惠寫台北板橋馥華艾美酒店開幕。酒店以「感官藝術策展」為概念邀 15 位藝術家創作，館內也請新媒體藝術家吳哲宇打造沉浸式影像作品《演算詩篇：馥光子午》，結合即時演算、音樂與光影。",
    excerptEn: "udn.com covers the opening of Le Méridien Taipei Banqiao. Built around the idea of sensory art curation, the hotel commissioned 15 artists, and new media artist Che-Yu Wu created the immersive video work Algorithmic Verses, combining real-time algorithms, music and light.",
    date: "2026/08/02",
    url: "https://udn.com/news/story/7241/9666060",
    source: "聯合新聞網｜黃淑惠",
    sourceEn: "udn.com · 黃淑惠",
    category: "press",
  },
  {
    id: 253,
    title: "2026 DesignBIZ SUMMIT 趨勢論壇 9/3 登場！聚焦「感知，重新定義商業的尺度」，洞悉 AI 時代下的產業變局",
    titleEn: "2026 DesignBIZ SUMMIT Trend Forum Opens 3 September: 'Perception, Redefining the Scale of Business' in the AI Era",
    excerpt: "主辦方 Shopping Design 公布 9 月 3 日 DesignBIZ SUMMIT 趨勢論壇的九位講者，第一位是新媒體藝術家吳哲宇，講題「重新定義『設計感知』：AI 如何介入視覺創作與互動藝術」，將從 Taiwan.md 談如何打造 AI friendly 的科技人文環境。",
    excerptEn: "Organiser Shopping Design announces the nine speakers for the DesignBIZ SUMMIT trend forum on 3 September, opening with new media artist Che-Yu Wu on 'Redefining Design Perception: How AI Enters Visual Creation and Interactive Art', starting from Taiwan.md to discuss building an AI-friendly environment for technology and the humanities.",
    date: "2026/07/07",
    url: "https://www.shoppingdesign.com.tw/post/view/13574",
    source: "Shopping Design（主辦方）",
    sourceEn: "Shopping Design (organiser)",
    category: "press",
  },
  {
    id: 252,
    title: "WebAR 串聯全球七座城市 跨域數位藝術展《共域座標 2026》正式啟動",
    titleEn: "WebAR Links Seven Cities Worldwide as the Cross-Disciplinary Digital Art Exhibition PostTribe 2026 Launches",
    excerpt: "台北設計與藝術指導協會發起的跨國 WebAR 藝術計畫《共域座標 2026》線上啟動，6 月 27 日全球同步開幕，民眾用手機開網頁就能在街角看到作品。聯合新聞網列出的參與創作者包括吳哲宇、王秉中、周穆等，也有惠明視障者教養院。",
    excerptEn: "PostTribe 2026, a cross-border WebAR art project launched by the Taipei Art Direction & Design Association, goes live online with simultaneous openings worldwide on 27 June; anyone can open a web page on their phone to see the works on street corners. udn.com lists the participants, including Che-Yu Wu and other artists, along with the Huiming home for visually impaired children in Taichung.",
    date: "2026/06/28",
    url: "https://udn.com/news/story/7241/9592969",
    source: "聯合新聞網｜宋健生",
    sourceEn: "United Daily News (udn.com) · 宋健生",
    category: "press",
  },
  {
    id: 251,
    title: "一間以「台灣」為教材的國際學校-“Taiwan.md “  ft. 吳哲宇｜新媒體藝術家 EP60",
    titleEn: "An International School That Uses Taiwan as Its Textbook: Taiwan.md ft. Che-Yu Wu, New Media Artist, EP60",
    excerpt: "雜學校 Podcast EP60 與吳哲宇長談 Taiwan.md，長約 69 分鐘。節目介紹寫他在威尼斯被策展人問「哪裡可以真正了解台灣」時一陣語塞，於是做出 Taiwan.md，也談他花三個月讓 AI 訪問自己，把從小到大的記憶倒進知識庫。",
    excerptEn: "Episode 60 of the ZASHARE podcast is a long conversation with Che-Yu Wu about Taiwan.md, about 69 minutes. The notes say that when a curator in Venice asked him where one could really get to know Taiwan, he was lost for words, and so made Taiwan.md. He also talks about spending three months letting AI interview him and pouring a lifetime of memories into a knowledge base.",
    date: "2026/05/22",
    url: "https://www.youtube.com/watch?v=L3EkK8WxltI",
    source: "雜學校 Podcast（YouTube）｜蘇仰志（主持）",
    sourceEn: "ZASHARE Podcast (YouTube) · Hosted by 蘇仰志",
    category: "interview",
  },
  {
    id: 250,
    title: "EP341｜NFT 是炒作還是歷史？它真正的價值是什麼？feat. 新媒體藝術家 吳哲宇（下）",
    titleEn: "EP341: Are NFTs Hype or History? What Is Their Real Value? feat. New Media Artist Che-Yu Wu (Part 2)",
    excerpt: "寶博士葛如鈞主持的《寶博朋友說》第 341 集，再次邀吳哲宇談 NFT。節目說明寫到一場荒謬的抄襲事件讓他意外走進這個圈子的核心，這集聊他在 NFT 世界的過去、現在與未來，以及他怎麼重新理解「價值」。本集為上下集的下集。",
    excerptEn: "Episode 341 of the podcast hosted by Dr. Bao (Ko Ju-Chun) welcomes Che-Yu Wu back to talk about NFTs. The notes describe how an absurd plagiarism case drew him into the heart of that world, and the episode covers his past, present and future with NFTs and how he has come to rethink value. This is the second of two parts.",
    date: "2026/05/06",
    url: "https://open.firstory.me/story/cmotb5i2l0f1p01uz3ma2adz4",
    source: "寶博朋友說 Podcast｜葛如鈞（主持）",
    sourceEn: "寶博朋友說 Podcast · Hosted by 葛如鈞 (Dr. Bao)",
    category: "interview",
  },
  {
    id: 249,
    title: "【寶島有意思】從生成式藝術到Taiwan.md！吳哲宇讓台灣文化長出「數位生命體」",
    titleEn: "From Generative Art to Taiwan.md: Che-Yu Wu Grows a 'Digital Life Form' from Taiwanese Culture",
    excerpt: "賴靜嫻主持的寶島聯播網《寶島有意思》專訪。吳哲宇談在紐約求學時發現外國朋友很難從單一管道認識台灣，因此發起開源的 Taiwan.md：涵蓋人物、美食、歷史等 12 大主題，用 AI 協作與品質控管，開放大眾修改，像珊瑚礁一樣自然生長。",
    excerptEn: "A radio interview on Formosa Radio Network. Che-Yu Wu explains that as a student in New York he found friends abroad had no single place to learn about Taiwan, which led him to start the open-source Taiwan.md: 12 themes from people and food to history, written with AI and quality control, open for anyone to edit, growing like a coral reef.",
    date: "2026/05/05",
    url: "https://youtu.be/t6CLV8p2hh4",
    source: "寶島聯播網《寶島有意思》｜賴靜嫻（主持）",
    sourceEn: "寶島聯播網 · Hosted by 賴靜嫻",
    category: "interview",
  },
  {
    id: 248,
    title: "宏碁成立將滿50年 施振榮：最大貢獻為台灣培育人才",
    titleEn: "Acer Nears 50: Stan Shih Says Its Greatest Contribution Is Developing Talent for Taiwan",
    excerpt: "宏碁成立將滿 50 年，施振榮發文表示，宏碁對台灣最大的價值在培育人才。中央社記者寫到宏碁基金會早年舉辦龍騰論文獎、宏碁數位創作競賽等，培育出生成式藝術家吳哲宇、數位藝術家張亨利等人才。",
    excerptEn: "As Acer nears its 50th year, Stan Shih writes that the company's greatest value to Taiwan lies in the talent it has developed. CNA's reporter notes that the Acer Foundation's early programmes, such as a thesis award and the Acer Digital Creation contest, nurtured people including generative artist Che-Yu Wu and a digital artist.",
    date: "2026/05/01",
    url: "https://www.cna.com.tw/news/afe/202605010153.aspx",
    source: "中央社｜張建中",
    sourceEn: "Central News Agency (CNA) · 張建中",
    category: "press",
  },
  {
    id: 247,
    title: "【藝術文化】「新美花嘿噴？」展覽 繁花轉譯城市風貌",
    titleEn: "[Arts & Culture] What Happened? Exhibition Translates the City Through Flowers",
    excerpt: "自由時報記者黃政嘉報導新北市美術館新美聚場的「新美花嘿噴？」展，以設計轉譯把新北的地景、產業與文化化成符號。A3「生成之花」由吳哲宇以演算法製作即時變化的數位花海，每一刻都不一樣。展期到 8 月 16 日。",
    excerptEn: "The Liberty Times covers the What Happened? exhibition at the New Taipei City Art Museum, which uses design to turn New Taipei's landscapes, industries and culture into symbols. In room A3, Generative Flowers, Che-Yu Wu uses algorithms to make a digital sea of flowers that changes in real time, different at every moment. It runs until 16 August.",
    date: "2026/05/01",
    url: "https://art.ltn.com.tw/article/paper/1753010",
    source: "自由時報｜黃政嘉",
    sourceEn: "Liberty Times · 黃政嘉",
    category: "press",
  },
  {
    id: 246,
    title: "「新美花嘿噴？」以花轉譯城市日常　新北市美術館展出中",
    titleEn: "What Happened? Translates City Life Through Flowers at the New Taipei City Art Museum",
    excerpt: "互傳媒記者謝忠義的展覽報導（Yahoo 新聞刊出）：新北市美術館「新美花嘿噴？」展到 8 月 16 日，以「花」轉譯新北的日常。A3 展間「生成之花」由吳哲宇用演算法生成即時變化的數位花海，每一刻都不一樣，報導首圖就是這個展間。",
    excerptEn: "An exhibition report by Hoo Media, carried by Yahoo News Taiwan: What Happened? at the New Taipei City Art Museum, open until 16 August, translates everyday New Taipei through flowers. In room A3, Generative Flowers, Che-Yu Wu uses algorithms to generate a digital sea of flowers that changes from moment to moment, and the report opens with a photo of that room.",
    date: "2026/04/30",
    url: "https://tw.news.yahoo.com/%E6%96%B0%E7%BE%8E%E8%8A%B1%E5%98%BF%E5%99%B4-%E4%BB%A5%E8%8A%B1%E8%BD%89%E8%AD%AF%E5%9F%8E%E5%B8%82%E6%97%A5%E5%B8%B8-%E6%96%B0%E5%8C%97%E5%B8%82%E7%BE%8E%E8%A1%93%E9%A4%A8%E5%B1%95%E5%87%BA%E4%B8%AD-124848693.html",
    source: "Yahoo 新聞（轉載自互傳媒）｜謝忠義",
    sourceEn: "Yahoo News Taiwan (from Hoo Media) · 謝忠義",
    category: "press",
  },
  {
    id: 245,
    title: "「新美花嘿噴？」以花轉譯城市日常 新北市美術館展出中",
    titleEn: "'What Happened?': Translating City Life Through Flowers, Now on View at the New Taipei City Art Museum",
    excerpt: "經濟日報介紹新北市美術館「新美花嘿噴？」展，以花為載體轉譯新北的地景、產業與飲食記憶。A3 展區「生成之花」由新媒體藝術家吳哲宇用演算法生成即時變化的數位花海，每一刻都獨一無二。展期至 8 月 16 日。",
    excerptEn: "Economic Daily News introduces What Happened? at the New Taipei City Art Museum, which uses flowers to translate New Taipei's landscapes, industries and food memories; in zone A3, Generative Flowers, new media artist Che-Yu Wu uses algorithms to grow a digital sea of flowers that changes in real time, different at every moment. On view until 16 August.",
    date: "2026/04/30",
    url: "https://udn.com/news/story/7266/9473373",
    source: "聯合新聞網（經濟日報）｜邱琮皓",
    sourceEn: "United Daily News (udn.com), Economic Daily News · 邱琮皓",
    category: "press",
  },
  {
    id: 244,
    title: "「新美花嘿噴？」展覽 以花轉譯新北日常城市樣貌",
    titleEn: "'What Happened?' Exhibition Translates Everyday New Taipei Through Flowers",
    excerpt: "新北市美術館新美聚場的「新美花嘿噴？」展覽即日起展到 8 月 16 日，以花為載體轉譯新北日常。自由時報依新北市文化局說明，寫到 A3「生成之花」由新媒體藝術家吳哲宇以演算法生成即時變化的數位花海，每一刻都不重複。",
    excerptEn: "The exhibition 'What Happened?' runs until 16 August at the New Taipei City Art Museum's gathering space, using flowers to translate everyday life in New Taipei. Citing the city's Cultural Affairs Department, the Liberty Times writes that in room A3, Generative Flowers, new media artist Che-Yu Wu uses algorithms to generate a sea of digital flowers that changes in real time, never the same twice.",
    date: "2026/04/30",
    url: "https://news.ltn.com.tw/news/life/breakingnews/5421650",
    source: "自由時報｜黃政嘉",
    sourceEn: "Liberty Times · 黃政嘉",
    category: "press",
  },
  {
    id: 243,
    title: "EP340｜AI＋開源寫出「台灣使用說明書」，從台積電到早餐店台味全包！feat. 新媒體藝術家 吳哲宇（上）",
    titleEn: "EP340 | Writing a User Manual for Taiwan with AI and Open Source, from TSMC to Breakfast Shops, feat. New Media Artist Che-Yu Wu (Part 1)",
    excerpt: "寶博士葛如鈞主持的 Podcast《寶博朋友說》EP340 上集，長 38 分鐘。來賓吳哲宇因為常被問到「哪裡可以真正了解台灣」，推動 Taiwan.md，用 SSOT 與開源的概念為台灣寫一份 README，讓人介紹台灣時，除了台積電與珍珠奶茶還有話可說。",
    excerptEn: "Part one of episode 340 of the podcast hosted by Dr. Bao (Ko Ju-Chun), 38 minutes long. Guest Che-Yu Wu, often asked where one can really get to know Taiwan, started Taiwan.md, using a single source of truth and open source to write a README for Taiwan so that people have more to say about it than TSMC and bubble tea.",
    date: "2026/04/29",
    url: "https://podcasts.apple.com/tw/podcast/ep340-ai-%E9%96%8B%E6%BA%90%E5%AF%AB%E5%87%BA-%E5%8F%B0%E7%81%A3%E4%BD%BF%E7%94%A8%E8%AA%AA%E6%98%8E%E6%9B%B8-%E5%BE%9E%E5%8F%B0%E7%A9%8D%E9%9B%BB%E5%88%B0%E6%97%A9%E9%A4%90%E5%BA%97%E5%8F%B0%E5%91%B3%E5%85%A8%E5%8C%85-feat-%E6%96%B0%E5%AA%92%E9%AB%94%E8%97%9D%E8%A1%93%E5%AE%B6-%E5%90%B3%E5%93%B2%E5%AE%87-%E4%B8%8A/id1484923390?i=1000764210230",
    source: "寶博朋友說｜葛如鈞（寶博士，主持）",
    sourceEn: "寶博朋友說 Podcast · Hosted by 葛如鈞 (Dr. Bao)",
    category: "interview",
  },
  {
    id: 242,
    title: "Acer 50周年 施振榮：宏碁最大貢獻在為台灣培育人才",
    titleEn: "Acer at 50: Stan Shih Says Acer's Greatest Contribution Is Nurturing Talent for Taiwan",
    excerpt: "經濟日報記者吳凱中寫宏碁 50 周年，施振榮回顧宏碁培育人才的角色。文中提到宏碁基金會早年舉辦的「宏碁數位創作競賽」等活動培育出許多人才，舉例包括新媒體生成式藝術家吳哲宇與數位藝術家張亨利。",
    excerptEn: "Economic Daily News writes about Acer's 50th anniversary, with Stan Shih looking back on Acer's role in nurturing talent. The piece notes that the Acer Foundation's early programmes, including the Acer Digital Creation Competition, produced many talents, naming new media generative artist Che-Yu Wu and a digital artist as examples.",
    date: "2026/04/27",
    url: "https://money.udn.com/money/story/5612/9466935",
    source: "經濟日報｜吳凱中",
    sourceEn: "Economic Daily News · 吳凱中",
    category: "press",
  },
  {
    id: 241,
    title: "宏碁50週年 施振榮：最大貢獻在為台灣培育人才",
    titleEn: "Acer at 50: Stan Shih Says Its Greatest Contribution Is Cultivating Talent for Taiwan",
    excerpt: "聯合新聞網轉載中央社稿，施振榮談宏碁 50 週年，說最大的貢獻是為台灣培育人才。文中舉宏碁基金會辦過的龍騰論文獎、宏碁數位創作競賽等，培育出的人才包括新媒體生成式藝術家吳哲宇與數位藝術家張亨利。",
    excerptEn: "United Daily News carries a CNA story in which Stan Shih, marking Acer's 50th year, says its greatest contribution has been cultivating talent for Taiwan; among the people nurtured by the Acer Foundation's competitions, such as the Acer Digital Creation Award, it names new media generative artist Che-Yu Wu and a digital artist.",
    date: "2026/04/27",
    url: "https://udn.com/news/story/7240/9466616",
    source: "聯合新聞網（轉載自中央社）",
    sourceEn: "United Daily News (udn.com), from Central News Agency",
    category: "press",
  },
  {
    id: 240,
    title: "宏碁50週年 施振榮：最大貢獻在為台灣培育人才",
    titleEn: "Acer at 50: Stan Shih Says Its Greatest Contribution Is Developing Talent for Taiwan",
    excerpt: "宏碁集團邁入 50 週年，施振榮透過智榮基金會表示，宏碁最大的貢獻是為台灣培育人才。中央社寫到宏碁基金會早年舉辦宏碁數位創作競賽等活動，培育的人才包括新媒體生成式藝術家吳哲宇與數位藝術家張亨利。",
    excerptEn: "As Acer turns 50, Stan Shih says through the Stan Shih Foundation that the company's greatest contribution has been developing talent for Taiwan. CNA notes that the Acer Foundation's early programmes, including the Acer Digital Creation contest, nurtured people such as new media generative artist Che-Yu Wu and a digital artist.",
    date: "2026/04/27",
    url: "https://www.cna.com.tw/news/afe/202604270074.aspx",
    source: "中央社｜吳家豪",
    sourceEn: "Central News Agency (CNA) · 吳家豪",
    category: "press",
  },
  {
    id: 239,
    title: "新北市美術館延續開館周年熱潮「世界民藝俱樂部」 5/9-5/10接力登場",
    titleEn: "New Taipei City Art Museum Follows Its First Anniversary with the World Folk Art Club on 9 and 10 May",
    excerpt: "聯合報記者葉德正、王慧瑛報導新北市美術館開館周年活動，文中介紹一樓新美聚場的「新美花嘿噴？」展（4 月 25 日至 8 月 16 日），結合新媒體藝術、氣味設計與互動體驗，提到藝術家吳哲宇的演算法「花」形態。",
    excerptEn: "United Daily News covers the New Taipei City Art Museum's anniversary events, including the ground-floor exhibition What Happened? (25 April to 16 August), which combines new media art, scent design and interaction, and mentions artist Che-Yu Wu's algorithmic flower forms.",
    date: "2026/04/27",
    url: "https://udn.com/news/story/7323/9466184",
    source: "聯合新聞網（聯合報）｜葉德正、王慧瑛",
    sourceEn: "United Daily News (udn.com) · 葉德正, 王慧瑛",
    category: "press",
  },
  {
    id: 238,
    title: "新北市美術館開館周年即將登場 「流聲市集」熱鬧開逛",
    titleEn: "New Taipei City Art Museum's First Anniversary Arrives with the Flowing Sound Market",
    excerpt: "聯合新聞網記者葉德正報導新北市美術館開館周年活動。館內同期的「新美花嘿噴？」展由新北市設計中心與文化基金會規劃，邀大石曉規、當若科技藝術、集刻互動媒體與新媒體藝術家吳哲宇等團隊，以「花」為載體做設計轉譯。",
    excerptEn: "udn.com covers the New Taipei City Art Museum's first anniversary. The concurrent exhibition What Happened?, planned by the New Taipei City Design Center and Cultural Foundation, invites Akinori Oishi, two media art studios, new media artist Che-Yu Wu and others to translate the city through design, using flowers as the medium.",
    date: "2026/04/22",
    url: "https://udn.com/news/story/7323/9457925",
    source: "聯合新聞網｜葉德正",
    sourceEn: "udn.com · 葉德正",
    category: "press",
  },
  {
    id: 237,
    title: "慶新北美術館開館1週年 週末音樂市集煙火秀嗨翻三鶯",
    titleEn: "New Taipei City Art Museum Marks Its First Anniversary with a Weekend of Music, Markets and Fireworks in Sanying",
    excerpt: "自由時報預告新北市美術館開館一週年的週末活動，文末寫一樓新美聚場推出「新美花嘿噴？」展覽，展期 4 月 25 日至 8 月 16 日，邀大石曉規、當若科技藝術 iF+、集刻互動媒體與新媒藝術家吳哲宇等團隊，以花為載體做設計轉譯。",
    excerptEn: "The Liberty Times previews the New Taipei City Art Museum's first-anniversary weekend, closing with the ground-floor exhibition What Happened?, from 25 April to 16 August, in which teams including Akinori Oishi, iF+ and new media artist Che-Yu Wu translate design through flowers.",
    date: "2026/04/22",
    url: "https://art.ltn.com.tw/article/breakingnews/5411997",
    source: "自由時報｜賴筱桐",
    sourceEn: "Liberty Times · 賴筱桐",
    category: "press",
  },
  {
    id: 236,
    title: "科學人／好用又危險！讓龍蝦管電腦產值高又省時 專家：守好最後一條線",
    titleEn: "Scientific American Taiwan: Useful and Dangerous. Letting the 'Lobster' Run Your Computer Saves Time, but Experts Say Hold the Last Line",
    excerpt: "科學人談 AI 代理工具 OpenClaw（暱稱龍蝦）的用處與風險，舉吳哲宇為例：他把人生片段放進 Obsidian 筆記再接上龍蝦，養出名叫 Muse 的數位分身，能產出官網、履歷與研究申請書，在 Discord 說一聲就部署網站。",
    excerptEn: "Scientific American Taiwan looks at the uses and risks of OpenClaw, an AI agent nicknamed the lobster, citing Che-Yu Wu: he put pieces of his life into Obsidian notes and connected them to the agent to raise a digital double called Muse, which produces his website, CV and research applications and deploys his site when he asks on Discord.",
    date: "2026/04/09",
    url: "https://udn.com/news/story/6904/9431182",
    source: "聯合新聞網（轉載自科學人）｜李慕約",
    sourceEn: "udn.com (from Scientific American Taiwan) · 李慕約",
    category: "press",
  },
  {
    id: 235,
    title: "創立Taiwan.md的吳哲宇是誰？10位突破框架的藝術家，從日常淬鍊台灣的故事",
    titleEn: "Who Is Che-Yu Wu, Founder of Taiwan.md? Ten Artists Breaking the Frame and Distilling Taiwan's Stories from Everyday Life",
    excerpt: "公視+《觀點同不同》介紹十位用自己的方式說台灣故事的藝術家，第一位是吳哲宇。文中寫他自稱理工直男，把寫程式當成寫詩，提到代表作《靈魂魚》與 2026 年 3 月發起的 Taiwan.md，說他用策展的方式向世界介紹台灣。",
    excerptEn: "PTS+ profiles ten artists who tell Taiwan's stories in their own ways, starting with Che-Yu Wu. It notes that he calls himself a typical engineering guy who treats writing code like writing poetry, mentions his signature work SoulFish and the Taiwan.md project he launched in March 2026, and describes it as a curated way of introducing Taiwan to the world.",
    date: "2026/04/02",
    url: "https://issues.ptsplus.tv/articles/12655/",
    source: "公視+《觀點同不同》｜張雅雯",
    sourceEn: "PTS+ · 張雅雯 (Isa Chang)",
    category: "press",
  },
  {
    id: 234,
    title: "你敢讓龍蝦控制你的電腦嗎？好用，又危險",
    titleEn: "Would You Let the Lobster Run Your Computer? Useful, and Dangerous",
    excerpt: "科學人「AI先行」專欄，李慕約談能操控電腦的 AI Agent OpenClaw（龍蝦）。文中寫生成式 AI 年會三月小聚邀四人分享用法，第一位是吳哲宇：他把人生片段放進 Obsidian、接上龍蝦，養出叫 Muse 的數位分身，能生成官網、履歷與申請書。",
    excerptEn: "Scientific American Taiwan's AI First column looks at OpenClaw, the computer-controlling AI agent nicknamed the lobster. Of four speakers at a March Generative AI meetup, the first is Che-Yu Wu, who put pieces of his life into Obsidian and connected the lobster to raise a digital double called Muse that produces his website, CV and applications.",
    date: "2026/04/01",
    url: "https://www.scitw.cc/posts/Agent-First-290",
    source: "科學人｜李慕約（AI先行專欄）",
    sourceEn: "Scientific American Taiwan · 李慕約 (AI First column)",
    category: "press",
  },
  {
    id: 233,
    title: "A Knowledge Base for Taiwan",
    titleEn: "A Knowledge Base for Taiwan",
    excerpt: "Lingua Sinica 報導吳哲宇 3 月 18 日上線的 Taiwan.md：從構想到網站只花一天，名稱取自 Markdown 的 .md 副檔名，套用軟體工程「唯一真相來源」的概念。上線一週有超過 100 個國家的訪客，已有 960 多頁、四種語言。",
    excerptEn: "Lingua Sinica reports on Taiwan.md, launched by Che-Yu Wu on 18 March: it went from idea to live site in a single day, takes its name from the Markdown file extension, and applies the software idea of a single source of truth; in its first week it drew visitors from over 100 countries and now runs to 960-plus pages in four languages.",
    date: "2026/03/24",
    url: "https://lingua-sinica.org/a-knowledge-base-for-taiwan/",
    source: "Lingua Sinica｜Mark Chiu",
    sourceEn: "Lingua Sinica · Mark Chiu",
    category: "press",
  },
  {
    id: 232,
    title: "把台灣開源！新媒體藝術家推taiwan.md 讓世界讀懂台灣",
    titleEn: "Open-Sourcing Taiwan: A New Media Artist Launches taiwan.md So the World Can Understand Taiwan",
    excerpt: "FTNN 新聞網根據吳哲宇的臉書貼文報導 taiwan.md：他曾在國際場合被問「哪裡可以認識台灣」答不出來，於是用 Markdown 與 .md 網域建站，讓 AI 抓得到台灣觀點。上線一小時就有紐約訪客，專案放上 GitHub 開放投稿。",
    excerptEn: "Drawing on Che-Yu Wu's Facebook post, FTNN reports on taiwan.md: asked abroad where one could learn about Taiwan, he had no answer, so he built a site on Markdown with a .md domain so that AI can find a Taiwanese perspective. Its first visitor, from New York, arrived within an hour, and the project is open for contributions on GitHub.",
    date: "2026/03/22",
    url: "https://tw.news.yahoo.com/%E6%8A%8A%E5%8F%B0%E7%81%A3%E9%96%8B%E6%BA%90-%E6%96%B0%E5%AA%92%E9%AB%94%E8%97%9D%E8%A1%93%E5%AE%B6%E6%8E%A8taiwan-md-%E8%AE%93%E4%B8%96%E7%95%8C%E8%AE%80%E6%87%82%E5%8F%B0%E7%81%A3-094300117.html",
    source: "Yahoo 新聞（轉載自 FTNN 新聞網）｜蔡曉容",
    sourceEn: "Yahoo News (from FTNN) · 蔡曉容",
    category: "press",
  },
  {
    id: 231,
    title: "早安世界》城鎮韌性演習4月啟動納11縣市　與漢光高度連結",
    titleEn: "Good Morning World: Urban Resilience Drills Start in April Across 11 Cities and Counties, Closely Tied to Han Kuang",
    excerpt: "中央社《早安世界》3 月 20 日的新聞摘要，其中一則摘錄 Taiwan.md：吳哲宇打造的開源台灣知識庫涵蓋 12 個面向、累計超過百篇文章，從半導體產業寫到早餐店阿姨。摘要引他的話，說越往外走，越發現我們的家其實很美好。",
    excerptEn: "CNA's Good Morning World digest for 20 March includes an item on Taiwan.md: Che-Yu Wu's open-source knowledge base about Taiwan covers 12 areas and more than a hundred articles, from the semiconductor industry to breakfast-shop aunties. It quotes him saying that the farther he travels, the more he finds that home is beautiful.",
    date: "2026/03/20",
    url: "https://www.cna.com.tw/news/ahel/202603205001.aspx",
    source: "中央社《早安世界》",
    sourceEn: "CNA, Good Morning World",
    category: "press",
  },
  {
    id: 230,
    title: "從台積電到早餐店阿姨　Taiwan.md知識庫AI時代下說台灣故事",
    titleEn: "From TSMC to the Breakfast Shop Auntie: The Taiwan.md Knowledge Base Tells Taiwan's Story in the AI Era",
    excerpt: "中央社介紹吳哲宇發起的台灣知識庫 Taiwan.md：以 Markdown 寫成、方便 AI 理解，開放所有人投稿，涵蓋 12 個面向、上百篇文章，從半導體到早餐店阿姨都有。他說 AI 的回答取決於讀過什麼，台灣人自己寫的內容會讓答案帶有台灣的觀點。",
    excerptEn: "CNA introduces Taiwan.md, the Taiwan knowledge base started by Che-Yu Wu: written in Markdown so AI can read it easily and open to contributions from anyone, it spans 12 subject areas and more than a hundred articles, from semiconductors to the breakfast-shop auntie. What AI answers depends on what it has read, he says, so content written by Taiwanese people carries a Taiwanese perspective into the answers.",
    date: "2026/03/19",
    url: "https://www.cna.com.tw/news/ait/202603195002.aspx",
    source: "中央社",
    sourceEn: "Central News Agency (CNA)",
    category: "press",
  },
  {
    id: 229,
    title: "策展島嶼的深度敘事",
    titleEn: "A Deep Narrative for a Curated Island",
    excerpt: "吳哲宇署名投書，寫 Taiwan.md 的起點：威尼斯雙年展酒會上被問哪裡能真正認識台灣，他答不出來。3 月 17 日晚上他買下 taiwan.md 網域，24 小時內和 AI Agent 團隊上線，以繁體中文為唯一真相來源，用 CC BY-SA 4.0 開源。",
    excerptEn: "An op-ed signed by Che-Yu Wu on how Taiwan.md began: at a Venice Biennale reception he was asked where one could really learn about Taiwan and had no answer; on the night of 17 March he bought the taiwan.md domain, launched it within 24 hours with a team of AI agents, using Traditional Chinese as the single source of truth and releasing it under CC BY-SA 4.0.",
    date: "2026/03/19",
    url: "https://tw.news.yahoo.com/%E7%AD%96%E5%B1%95%E5%B3%B6%E5%B6%BC%E7%9A%84%E6%B7%B1%E5%BA%A6%E6%95%98%E4%BA%8B-221000314.html",
    source: "Yahoo 新聞（轉載自上報）｜吳哲宇（投書）",
    sourceEn: "Yahoo News (from Up Media) · Op-ed by Che-Yu Wu",
    category: "press",
  },
  {
    id: 228,
    title: "把台灣開源！taiwan.md：AI 回答的時代，讓國家用 README 的方式介紹自己",
    titleEn: "Open-Sourcing Taiwan: taiwan.md Lets a Country Introduce Itself Like a README in the Age of AI Answers",
    excerpt: "INSIDE 介紹吳哲宇發起的 taiwan.md：取 Markdown 副檔名與摩爾多瓦國碼的雙關，替台灣寫一份人類與 AI 都讀得懂的 README，以 CC BY-SA 4.0 開源，分成歷史、地理、文化、美食等面向，文末附他的臉書貼文。",
    excerptEn: "INSIDE introduces taiwan.md, started by Che-Yu Wu: a pun on the Markdown file extension and Moldova's country domain, it writes Taiwan a README that both people and AI can read, open-sourced under CC BY-SA 4.0 and organised into history, geography, culture, food and more, with his Facebook post appended.",
    date: "2026/03/18",
    url: "https://www.inside.com.tw/article/40877-taiwan-md",
    source: "INSIDE",
    sourceEn: "INSIDE",
    category: "press",
  },
  {
    id: 227,
    title: "在AI時代搶回「台灣主體」敘事權！新媒體藝術家吳哲宇發起「taiwan.md」實驗   「早餐店阿姨」到「便利商店」皆成觀點",
    titleEn: "Reclaiming Taiwan's Own Narrative in the AI Era: New Media Artist Che-Yu Wu Launches the taiwan.md Experiment, from Breakfast-Shop Aunties to Convenience Stores",
    excerpt: "自由時報記者董柏廷報導吳哲宇在臉書公布 taiwan.md 計畫：買下網域、建立開源知識庫，用 SSOT 的概念為台灣寫一份 README，涵蓋歷史、地理、美食、便利商店文化等 12 個面向。他說在 AI 時代，掌握結構化內容就掌握了敘事權。",
    excerptEn: "The Liberty Times reports on the taiwan.md project Che-Yu Wu announced on Facebook: he bought the domain and built an open-source knowledge base that applies the idea of a single source of truth to write a README for Taiwan, covering 12 areas from history and geography to food and convenience store culture. He says that in the AI era, whoever holds structured content holds the narrative.",
    date: "2026/03/18",
    url: "https://art.ltn.com.tw/article/breakingnews/5374934",
    source: "自由時報｜董柏廷",
    sourceEn: "Liberty Times · 董柏廷",
    category: "press",
  },
  {
    id: 226,
    title: "春節咖啡走春體驗！星巴克讓藝術不只在杯中，更存在於空間與每一次對話裡",
    titleEn: "A Lunar New Year Coffee Outing: Starbucks Puts Art in the Space and the Conversation, Not Only in the Cup",
    excerpt: "遠見行銷部為星巴克製作的廣編，宣傳春節期間星巴克典藏 DREAM PLAZA 台北的門市導覽，也介紹新推出的藝術設計 T 恤，第一款來自吳哲宇的數位藝術作品《咖啡幻夢》，描繪一段穿越台灣山岳與海洋的探索旅程。",
    excerptEn: "An advertorial produced by Global Views' marketing department for Starbucks, promoting Lunar New Year tours of Starbucks Reserve Dream Plaza Taipei and its new art T-shirts, the first of which comes from Che-Yu Wu's digital work The Coffee Dreamscape, a journey of exploration across Taiwan's mountains and sea.",
    date: "2026/02/11",
    url: "https://www.gvm.com.tw/article/128020",
    source: "遠見雜誌｜遠見行銷部（星巴克廣告）",
    sourceEn: "Global Views Monthly · Marketing department (Starbucks advertorial)",
    category: "press",
  },
  {
    id: 225,
    title: "《數據裡的詩意 藝術的無限想像 - 吳哲宇》Ep.267 藝次元宇宙",
    titleEn: "The Poetry in Data, the Infinite Imagination of Art: Che-Yu Wu, Ep. 267 of Metaverse",
    excerpt: "朱全斌主持的人間衛視《藝次元宇宙》第 267 集專訪。吳哲宇從小學寫程式做遊戲講起，談紐約轉向新媒體藝術、每天一件作品的練習如何長出《靈魂魚》與《花的靈魂》、NFT 帶來的起伏，以及現場彈鋼琴讓音波即時影響影像的演奏會。",
    excerptEn: "Episode 267 of BLTV's Metaverse. Che-Yu Wu starts with writing games as a child, then talks about turning to new media art in New York, how a daily practice of one work a day grew into SoulFish and The Soul of Flowers, the ups and downs NFTs brought, and concerts where his live piano playing shapes the images in real time.",
    date: "2026/01/13",
    url: "https://www.youtube.com/watch?v=vK2PVtoRRLg",
    source: "人間衛視《藝次元宇宙》｜朱全斌（主持）",
    sourceEn: "BLTV, Metaverse · Hosted by 朱全斌",
    category: "interview",
  },
  {
    id: 224,
    title: "備戰「鹽夏不夜埕」 中山大學跨域學程引爆科技藝術創作力",
    titleEn: "Gearing Up for Yancheng Summer Nights: NSYSU's Interdisciplinary Programme Sparks Creative Work in Art and Technology",
    excerpt: "國立中山大學新聞寫人文暨科技跨領域學程的大二必修課，為「2026 鹽夏不夜埕—花轟」成果展辦兩場工作坊：林書瑜教 Arduino，吳哲宇帶學生用 TouchDesigner 的節點式編程，做出隨音樂與數據即時變化的動態畫面。",
    excerptEn: "National Sun Yat-sen University reports on a required second-year course in its humanities and technology programme, which held two workshops ahead of the 2026 Yancheng Summer Nights showcase: another instructor taught Arduino, and Che-Yu Wu led students through node-based programming in TouchDesigner to make images that change live with music and data.",
    date: "2026/03/26",
    url: "https://engage.nsysu.edu.tw/news/%E5%82%99%E6%88%B0%E3%80%8C%E9%B9%BD%E5%A4%8F%E4%B8%8D%E5%A4%9C%E5%9F%95%E3%80%8D/",
    source: "國立中山大學社會實踐網",
    sourceEn: "National Sun Yat-sen University, Social Engagement",
    category: "press",
  },
  {
    id: 223,
    title: "突破線上課程低完課率，引領 4,300 名學生走入程式設計！",
    titleEn: "Beating Low Completion Rates in Online Courses: Leading 4,300 Students into Programming",
    excerpt: "INSIDE 經授權轉載群眾觀點的文章，作者郭丞哲寫當時 22 歲的吳哲宇：第一門網頁課帶近 3,000 位同學入門，第二門集資課上線一天湧入 500 人支持。文中談他以視覺動畫切入讓學習者先有成就感，並開設贊助者社團提高完課率。",
    excerptEn: "INSIDE reprints, with permission, a CrowdWatch piece profiling 22-year-old Che-Yu Wu: his first web course brought nearly 3,000 students in, and his second crowdfunded course drew 500 backers on its first day. It describes how he starts from visual animation so learners feel a sense of achievement, and how a backers' group raises completion rates.",
    date: "2017/06/16",
    url: "https://www.inside.com.tw/article/9629-how-to-create-successful-online-curriculum-fund-raising-plan",
    source: "INSIDE（轉載自群眾觀點）｜郭丞哲",
    sourceEn: "INSIDE (reprinted from 群眾觀點) · 郭丞哲",
    category: "press",
  },
  {
    id: 222,
    title: "文化部指導科文双融與双融域共同主辦的「AMBI ARTECH HUB 未來之藝」紀柏豪與吳哲宇用AI與靈魂對話的未來藝術",
    titleEn: "AMBI ARTECH HUB Future of Art, Co-Organised by AMBI with Ministry of Culture Guidance: Che-Yu Wu and a Fellow Artist on Art That Talks with the Soul Through AI",
    excerpt: "品傳媒總編應瑋漢寫 10 月 31 日在双融域開幕的「AMBI ARTECH HUB 未來之藝」，展出紀柏豪與吳哲宇的作品。吳哲宇的跨感官演出《Symphony of Fragments》讓觀眾「變成數據」，以演算法重組成幾何靈魂，進入虛擬樂團一起演奏。",
    excerptEn: "Pinnews's editor-in-chief writes about AMBI ARTECH HUB: Future of Art, which opened at AMBI SPACE ONE on 31 October with work by Che-Yu Wu and one other artist. Wu's cross-sensory performance Symphony of Fragments turns visitors into data, reassembled by algorithm into geometric souls that join a virtual orchestra.",
    date: "2025/11/01",
    url: "https://n.yam.com/Article/20251101531449",
    source: "蕃新聞（轉載自品傳媒）｜應瑋漢",
    sourceEn: "yam News (from Pinnews) · 應瑋漢",
    category: "press",
  },
  {
    id: 221,
    title: "2025TTXC INNOVATIONS　展現文策院扶植成果",
    titleEn: "2025 TTXC INNOVATIONS Shows the Results of TAICCA's Support Programmes",
    excerpt: "三立新聞報導台灣文化科技大會在高雄駁二的 INNOVATIONS 展區，介紹《瓶中的永恆花園》。吳哲宇說他做了一個數位生態系，輸出訊號給扭曲的譜面，音樂家演奏後音樂回頭影響生態系。觀眾也能用雨滴果實、非洲鼓參與。",
    excerptEn: "SET News reports from TAICCA's INNOVATIONS zone at the Taiwan Culture and Technology Expo at Pier-2 in Kaohsiung, featuring The Eternal Garden in a Bottle. Che-Yu Wu says he built a digital ecosystem that sends signals to a distorted score; the musicians play it and the music feeds back into the ecosystem, and visitors can join in with raindrop fruits and an African drum.",
    date: "2025/10/22",
    url: "https://www.setn.com/news/1739270",
    source: "三立新聞網｜黃啟超、古高樹、朱雅霆",
    sourceEn: "SET News · 黃啟超, 古高樹, 朱雅霆",
    category: "press",
  },
  {
    id: 220,
    title: "全台最大星巴克在台北DREAM PLAZA！到首間星巴克旗艦店來場五感的咖啡探索之旅",
    titleEn: "Taiwan's Largest Starbucks at Taipei Dream Plaza: A Five-Sense Coffee Journey at the First Starbucks Flagship",
    excerpt: "微笑台灣「活動大聲公」刊出星巴克提供的 DREAM PLAZA 旗艦店介紹，寫到門市內十件藝術作品橫跨數位生成藝術、金屬雕塑、手工彩繪與編織裝置，列出的第一件是《咖啡幻夢》。文中沒有寫各件作品的藝術家。",
    excerptEn: "Smile Taiwan's events column runs Starbucks' introduction to its Dream Plaza flagship, noting ten artworks in the store spanning generative digital art, metal sculpture, hand painting and woven installation; the first listed is The Coffee Dreamscape. The piece does not name the artist of each work.",
    date: "2025/08/02",
    url: "https://smiletaiwan.cw.com.tw/article/8365",
    source: "微笑台灣（天下雜誌）｜資料來源：星巴克",
    sourceEn: "Smile Taiwan (CommonWealth), source: Starbucks",
    category: "press",
  },
  {
    id: 219,
    title: "Starbucks Unveils Its Largest Flagship Store In Taiwan: A Coffee Lover’s Dream In Xinyi District",
    titleEn: "Starbucks Unveils Its Largest Flagship Store In Taiwan: A Coffee Lover’s Dream In Xinyi District",
    excerpt: "咖啡產業媒體 Coffee Geography 報導星巴克在台北信義區開出台灣最大的旗艦店，寫到門市以「自然與創新的和諧」為主題，展出 Eszter Chen、Labay Eyong 等藝術家的金工、編織與數位作品。吳哲宇的英文名在文中拼作 Che-Ye Wu。",
    excerptEn: "Coffee Geography reports on Starbucks opening its largest Taiwan flagship in Taipei's Xinyi District, themed Harmony of Nature & Innovation, with metalwork, woven art and digital displays by artists including Eszter Chen, Labay Eyong and Che-Yu Wu, whose name the article spells Che-Ye Wu.",
    date: "2025/07/30",
    url: "https://coffeegeography.com/2025/07/30/starbucks-unveils-its-largest-flagship-store-in-taiwan/",
    source: "Coffee Geography｜D. L. Gemeda",
    sourceEn: "Coffee Geography Magazine · D. L. Gemeda",
    category: "press",
  },
  {
    id: 218,
    title: "全台首間「星巴克旗艦店」在 DREAM PLAZA！5 大特色吧台、山林意象座席等亮點一次看",
    titleEn: "Taiwan's First Starbucks Flagship Opens at Dream Plaza: Five Signature Bars, Mountain-Inspired Seating and More",
    excerpt: "Shopping Design 整理星巴克 DREAM PLAZA 旗艦店的五大亮點，第四點「10 件多媒體藝術裝置」以自然、永續與創新為核心，涵蓋數位生成藝術、金屬雕塑與編織裝置，作品清單第一件是《咖啡幻夢》。",
    excerptEn: "Shopping Design rounds up five highlights of the Starbucks flagship at Dream Plaza. The fourth, ten multimedia art installations built around nature, sustainability and innovation, spans digital generative art, metal sculpture and woven installation, and its list of works opens with The Coffee Dreamscape.",
    date: "2025/07/28",
    url: "https://www.shoppingdesign.com.tw/post/view/12356",
    source: "Shopping Design｜張妤瑄（文字整理）",
    sourceEn: "Shopping Design · Compiled by 張妤瑄",
    category: "press",
  },
  {
    id: 217,
    title: "Introducing STARBUCKS RESERVE DREAM PLAZA TAIPEI: A Flagship of Flavor and Innovation",
    titleEn: "Introducing STARBUCKS RESERVE DREAM PLAZA TAIPEI: A Flagship of Flavor and Innovation",
    excerpt: "星巴克亞洲官方新聞站介紹台灣最大旗艦店 DREAM PLAZA：近 2,000 平方公尺、亞太最大的 Greener Store，店內以「Harmony of Nature & Innovation」為題展出藝術作品，藝術家名單列出吳哲宇（拼成 Che-Ye Wu）。",
    excerptEn: "Starbucks' official Asia news site introduces Dream Plaza, its largest flagship in Taiwan: close to 2,000 square metres and the largest Greener Store in Asia Pacific, with artworks on the theme Harmony of Nature & Innovation by artists including Che-Yu Wu, spelled Che-Ye Wu.",
    date: "2025/07/25",
    url: "https://stories.starbucks.com/asia/stories/2025/introducing-starbucks-reserve-dream-plaza-taipei-a-flagship-of-flavor-and-innovation/",
    source: "Starbucks Stories Asia（星巴克官方）｜Yoonah Kang",
    sourceEn: "Starbucks Stories Asia (Starbucks official) · Yoonah Kang",
    category: "press",
  },
  {
    id: 216,
    title: "星巴克典藏 DREAM PLAZA 台北開幕！五大特色吧檯匠心打造 融合咖啡體驗與空間美學",
    titleEn: "Starbucks Reserve DREAM PLAZA Taipei Opens: Five Signature Bars Combining Coffee and Spatial Design",
    excerpt: "玩美Daily 刊出星巴克典藏 DREAM PLAZA 台北的開幕新聞稿，介紹五大特色吧檯與藝術長廊。藝術一段列出門市十件作品，第一件是《咖啡幻夢》，也寫到門市中央的生成藝術裝置以動態影像讚頌自然與土地，沒有寫出藝術家名字。",
    excerptEn: "Wanmei Daily runs Starbucks' opening press release for Starbucks Reserve DREAM PLAZA Taipei, covering its five signature bars and gallery wall. The art section lists ten works in the store, starting with The Coffee Dreamscape, and describes the generative installation at its centre celebrating nature and the land in moving images; no artists are named.",
    date: "2025/07/25",
    url: "https://ruimeiimc.com/星巴克-dream_plaza/",
    source: "玩美Daily｜lu megan",
    sourceEn: "玩美Daily · lu megan",
    category: "press",
  },
  {
    id: 215,
    title: "全台首間星巴克旗艦店！「星巴克典藏 DREAM PLAZA 台北」7/25開幕，匯聚5大特色吧檯打造絕美空間",
    titleEn: "Taiwan's First Starbucks Flagship: Starbucks Reserve DREAM PLAZA Taipei Opens on 25 July with Five Signature Bars",
    excerpt: "TRAVELER Luxe 旅人誌介紹 7 月 25 日開幕的星巴克典藏 DREAM PLAZA 台北，文中寫門市中央配置生成藝術裝置，以動態影像讚頌自然與土地，九位國際藝術家的作品清單裡列有《咖啡幻夢》，沒有寫出作者名字。",
    excerptEn: "TRAVELER Luxe introduces Starbucks Reserve DREAM PLAZA Taipei, opening on 25 July. It describes a generative art installation at the centre of the store whose moving images celebrate nature and the land, and lists The Coffee Dreamscape among the works by nine international artists, without naming the artist.",
    date: "2025/07/25",
    url: "https://www.travelerluxe.com/article/desc/250011765",
    source: "TRAVELER Luxe 旅人誌",
    sourceEn: "TRAVELER Luxe",
    category: "press",
  },
  {
    id: 214,
    title: "Dream Plaza星巴克10大亮點！吧檯24小時、戶外席看台北101…江振誠米其林餐怎麼預約？",
    titleEn: "Ten Highlights of Starbucks at Dream Plaza: A 24-Hour Bar, Outdoor Seats Facing Taipei 101, and How to Book André Chiang's Michelin Menu",
    excerpt: "今周刊記者彭蕙珍整理星巴克典藏 DREAM PLAZA 台北門市的十大亮點。第二個亮點寫門市邀請 9 位國際藝術家、共 10 件作品，橫跨數位生成藝術、金屬雕塑與編織裝置，作品清單裡有《咖啡幻夢》。",
    excerptEn: "Business Today lists ten highlights of the Starbucks Reserve Dream Plaza Taipei store. The second notes that the store invited nine international artists for ten works spanning digital generative art, metal sculpture and woven installation, with The Coffee Dreamscape among them.",
    date: "2025/07/25",
    url: "https://www.businesstoday.com.tw/article/category/183030/post/202507250019/",
    source: "今周刊｜彭蕙珍",
    sourceEn: "Business Today · 彭蕙珍",
    category: "press",
  },
  {
    id: 213,
    title: "星巴克典藏 台北DREAM PLAZA 7/25開幕 導入5大創新吧檯＋9件藝術作品 亮點曝光",
    titleEn: "Starbucks Reserve Dream Plaza Taipei Opens 25 July with Five New Bars and Nine Artworks",
    excerpt: "台灣英文新聞介紹 7 月 25 日開幕的星巴克典藏台北 DREAM PLAZA：九位國際藝術家合作十件作品，列出的第一件是《咖啡幻夢》，其餘還有《閃耀女神》《立體風味》等。文中沒有寫各件作品的藝術家。",
    excerptEn: "Taiwan News introduces Starbucks Reserve Dream Plaza Taipei, opening 25 July: nine international artists contributed ten works, the first listed being The Coffee Dreamscape; the article does not name the artist of each work.",
    date: "2025/07/25",
    url: "https://www.taiwannews.com.tw/zh/news/6163993",
    source: "台灣英文新聞｜朱明珠",
    sourceEn: "Taiwan News · 朱明珠",
    category: "press",
  },
  {
    id: 212,
    title: "名廚江振誠設計菜單、首間調酒吧檯、預約制體驗！星巴克 Dream Plaza 典藏門市 8 大亮點一次看",
    titleEn: "A Menu by Chef André Chiang, the First Mixology Bar and Reservations: Eight Highlights of the Starbucks Reserve Dream Plaza Store",
    excerpt: "Tatler Asia 整理星巴克 Dream Plaza 典藏門市的八個亮點，其中一項寫門市九件藝術作品：最受注目的是以 AI 生成技術打造的互動藝術牆《咖啡幻夢》，畫面會依店內人流與室外天氣變化更新，文中附記者拍的牆面照片。",
    excerptEn: "Tatler Asia lists eight highlights of the Starbucks Reserve Dream Plaza store. One covers its nine artworks, the most talked-about being The Coffee Dreamscape, an interactive wall the article describes as AI-generated, whose image changes with foot traffic in the store and the weather outside, shown in the reporter's own photo.",
    date: "2025/07/23",
    url: "https://www.tatlerasia.com/dining/food/tatler-dream-plaza-taipei-zh-hant",
    source: "Tatler Asia｜Alec Zhan",
    sourceEn: "Tatler Asia · Alec Zhan",
    category: "press",
  },
  {
    id: 211,
    title: "讓客廳更聰明！全新透明真無線「LG SIGNATURE OLED T」智慧顯示器與多款 LG OLED、QNED、二代閨蜜機搭載 webOS 25 升級開賣",
    titleEn: "A Smarter Living Room: LG's Transparent Wireless SIGNATURE OLED T and New OLED, QNED and StanbyME 2 Models with webOS 25 Go on Sale",
    excerpt: "Yahoo 新聞轉載 3C 部落格俏媽咪玩3C 的 LG 新品文：LG 以「超越視界，透見無限」為主題，攜手吳哲宇舉辦影音新品發表會，引進透明真無線 OLED T。吳哲宇在文中說，演算法生成的數位生命在顯示器上自然呼吸，螢幕成了藝術的媒介。",
    excerptEn: "Yahoo News reprints an LG launch post from a tech blog: under the theme Beyond Vision, LG holds its AV launch with Che-Yu Wu and brings the transparent wireless OLED T to Taiwan. Wu says in the piece that algorithmically generated digital life breathes naturally on the display, making the screen a medium for art.",
    date: "2025/07/06",
    url: "https://tw.news.yahoo.com/%E8%AE%93%E5%AE%A2%E5%BB%B3%E6%9B%B4%E8%81%B0%E6%98%8E-%E5%85%A8%E6%96%B0%E9%80%8F%E6%98%8E%E7%9C%9F%E7%84%A1%E7%B7%9A-lg-signature-oled-185318494.html",
    source: "Yahoo 新聞（轉載自俏媽咪玩3C）",
    sourceEn: "Yahoo News (reprinted from 俏媽咪玩3C)",
    category: "press",
  },
  {
    id: 210,
    title: "LG 最新娛樂影音新品齊發　全球首款透明OLED電視震撼登台",
    titleEn: "LG Launches Its Latest Entertainment Line-Up as the World's First Transparent OLED TV Arrives in Taiwan",
    excerpt: "台灣英文新聞記者劉怡均報導 LG 以「超越視界，透見無限」為題，攜手新媒體藝術家吳哲宇舉辦娛樂影音新品發表會，宣布全球首款透明真無線 4K OLED「LG SIGNATURE OLED T」引進台灣。其餘篇幅介紹 OLED evo、QNED 新品與 webOS 25 的 AI 功能。",
    excerptEn: "Taiwan News covers LG's entertainment launch, themed Beyond Vision, Seeing Infinity and held with new media artist Che-Yu Wu, where LG announced the arrival in Taiwan of the LG SIGNATURE OLED T, the world's first transparent wireless 4K OLED. The rest of the report covers the OLED evo and QNED ranges and the AI features of webOS 25.",
    date: "2025/07/03",
    url: "https://taiwannews.com.tw/zh/news/6147848",
    source: "台灣英文新聞｜劉怡均",
    sourceEn: "Taiwan News (Chinese edition) · 劉怡均",
    category: "press",
  },
  {
    id: 209,
    title: "全球首款透明真無線4K OLED 顯示器登台！　LG今年新品同場加映",
    titleEn: "The World's First Transparent, Truly Wireless 4K OLED Arrives in Taiwan, Alongside LG's New Lineup",
    excerpt: "太報報導 LG 以「超越視界，透見無限」為主題，攜手新媒體藝術家吳哲宇，宣布引進透明真無線 4K OLED 顯示器 LG SIGNATURE OLED T。其餘篇幅介紹同場發表的 OLED evo、QNED evo 等新品。",
    excerptEn: "Taisounds reports that LG, working with new media artist Che-Yu Wu under the theme 'Beyond Vision, Into Infinity', announced the arrival in Taiwan of the transparent, truly wireless 4K OLED display LG SIGNATURE OLED T; the rest of the story covers the OLED evo, QNED evo and other products launched alongside it.",
    date: "2025/07/02",
    url: "https://tw.news.yahoo.com/%E5%85%A8%E7%90%83%E9%A6%96%E6%AC%BE%E9%80%8F%E6%98%8E%E7%9C%9F%E7%84%A1%E7%B7%9A4k-oled-%E9%A1%AF%E7%A4%BA%E5%99%A8%E7%99%BB%E5%8F%B0-lg%E4%BB%8A%E5%B9%B4%E6%96%B0%E5%93%81%E5%90%8C%E5%A0%B4%E5%8A%A0%E6%98%A0-091114404.html",
    source: "Yahoo 新聞（轉載自太報）｜陳俐妏",
    sourceEn: "Yahoo News (from Taisounds) · 陳俐妏",
    category: "press",
  },
  {
    id: 208,
    title: "星巴克典藏 DREAM PLAZA 7月 25 日盛大開幕! 攜手國際名廚江振誠打造精緻餐點",
    titleEn: "Starbucks Reserve DREAM PLAZA Opens on 25 July, with Dishes Created with Chef André Chiang",
    excerpt: "House Voice 刊出星巴克典藏 DREAM PLAZA 的開幕新聞稿，介紹各式吧檯與江振誠套餐。藝術一段列出門市十件作品，第一件是《咖啡幻夢》，也寫到門市中央的生成藝術裝置以動態影像讚頌自然與土地，沒有寫出藝術家名字。",
    excerptEn: "House Voice runs Starbucks' opening press release for the Starbucks Reserve DREAM PLAZA store, covering its bars and André Chiang's set menu. The art section lists ten works in the store, starting with The Coffee Dreamscape, and describes the generative installation at its centre celebrating nature and the land in moving images; no artists are named.",
    date: "2025/07/24",
    url: "https://www.housevoice.tw/blog/detail/blog380",
    source: "House Voice",
    sourceEn: "House Voice",
    category: "press",
  },
  {
    id: 207,
    title: "【EP17】當程式碼變成畫筆！生成藝術如何打破創作界限？ft.吳哲宇",
    titleEn: "[EP17] When Code Becomes a Paintbrush: How Generative Art Breaks the Limits of Creation, ft. Che-Yu Wu",
    excerpt: "吳若權主持的 Podcast《這題我不會》EP17，長 26 分鐘。節目介紹寫吳哲宇分享把創作轉成可演算系統的方法，談生成藝術與傳統創作的差異、NFT 如何讓數位藝術有稀缺性，也預告他即將推出的沉浸式鋼琴演出。",
    excerptEn: "Episode 17 of a Taiwanese podcast, 26 minutes long. The notes say Che-Yu Wu shares how he turns creation into a computable system, discusses how generative art differs from traditional practice and how NFTs give digital art scarcity, and previews his upcoming immersive piano performance.",
    date: "2025/05/20",
    url: "https://podcasts.apple.com/tw/podcast/id1803542841?i=1000709070490",
    source: "這題我不會｜吳若權（主持）",
    sourceEn: "這題我不會 Podcast · Hosted by 吳若權",
    category: "interview",
  },
  {
    id: 206,
    title: "LG OLED限定展覽「永恆花境」於Diamond Towers震撼登場",
    titleEn: "LG OLED's Limited Exhibition Eternal Flower Realm Opens at Diamond Towers",
    excerpt: "JazzNews 刊出 LG 新聞稿：LG 攜手生成式藝術家吳哲宇在新光三越 Diamond Towers 推出沉浸式展覽「永恆花境」，用演算法生成花瓣的綻放與飄零，搭配 OLED evo M4、G4、無限鏡牆與水波紋投影，現場打卡可換吳哲宇作品小卡。",
    excerptEn: "JazzNews runs LG's press release: LG and generative artist Che-Yu Wu open the immersive exhibition Eternal Flower Realm at Shin Kong Mitsukoshi Diamond Towers, where algorithms generate petals blooming and falling across OLED evo M4 and G4 screens, an infinity mirror wall and rippling projections. Visitors who post from the show receive a card printed with one of Wu's works.",
    date: "2024/12/20",
    url: "https://jazznews.com.tw/lg-oled-diamond-towers/",
    source: "JazzNews（LG 新聞稿）",
    sourceEn: "JazzNews (LG press release)",
    category: "press",
  },
  {
    id: 205,
    title: "LG及吳哲宇打造限定展覽　Diamond Towers感受沉浸式數位花田",
    titleEn: "LG and Che-Yu Wu Create a Limited Exhibition: An Immersive Digital Flower Field at Diamond Towers",
    excerpt: "台灣英文新聞寫 LG OLED 攜手生成式藝術家吳哲宇，在新光三越 Diamond Towers 推出沉浸式展覽「永恆花境」：以演算法生成花瓣的綻放與飄零，透過 OLED evo M4、G4 的拼接與無限鏡牆呈現，展至 2025 年 1 月 2 日。",
    excerptEn: "Taiwan News reports that LG OLED and generative artist Che-Yu Wu opened the immersive exhibition Eternal Floral Realm at Shin Kong Mitsukoshi Diamond Towers: petals generated by algorithm bloom and fall across tiled OLED evo M4 and G4 screens and an infinity mirror wall, on view until 2 January 2025.",
    date: "2024/12/17",
    url: "https://www.taiwannews.com.tw/zh/news/5994464",
    source: "台灣英文新聞｜劉怡均",
    sourceEn: "Taiwan News · 劉怡均",
    category: "press",
  },
  {
    id: 204,
    title: "LG OLED 限定展覽於 Diamond Towers 震撼登場",
    titleEn: "LG OLED Limited Exhibition Opens at Diamond Towers",
    excerpt: "LG 台灣官方新聞稿寫到，LG OLED 攜手生成式藝術家吳哲宇，在新光三越 Diamond Towers 推出沉浸式展覽「永恆花境」，以演算法生成花瓣的綻放與飄零，搭配 OLED 電視與無限鏡牆，現場發文可換《彼岸花》《靈魂魚》等作品小卡。",
    excerptEn: "LG Taiwan's official press release says LG OLED has teamed up with generative artist Che-Yu Wu on an immersive exhibition, Eternal Floral Realm, at Shin Kong Mitsukoshi Diamond Towers, with algorithmically generated petals blooming and falling across OLED screens and an infinity mirror wall; visitors who post on social media receive a card printed with works such as The Flower of the Other Shore and SoulFish.",
    date: "2024/12/16",
    url: "https://www.lg.com/tw/about-lg/press-and-media/oled-exhibition-diamond-tower-20241216/",
    source: "LG 台灣（官方新聞稿）",
    sourceEn: "LG Taiwan (official press release)",
    category: "press",
  },
  {
    id: 203,
    title: "藝術家 吳哲宇-【花的靈魂】",
    titleEn: "Artist Che-Yu Wu: The Soul of Flowers",
    excerpt: "2024 桃園科技藝術節 TAxT 官方頻道的藝術家介紹短片，長約 1 分 40 秒。片中以字卡提問，請吳哲宇談作品《花的靈魂》的創作理念與想呈現的視覺感受，他提到想繪製出一種花境花田的感覺。",
    excerptEn: "A short artist film, about one minute forty, on the official channel of the 2024 Taoyuan Art x Technology Festival (TAxT). On-screen questions ask Che-Yu Wu about the idea behind The Soul of Flowers and the visual feeling he wants to create, and he speaks of drawing the sense of a field of flowers.",
    date: "2024/09/22",
    url: "https://www.youtube.com/watch?v=NIFFMXL8DBw",
    source: "TAxT 桃園科技藝術節（YouTube）",
    sourceEn: "Taoyuan Art x Technology Festival (YouTube)",
    category: "press",
  },
  {
    id: 202,
    title: "Acer 創辦人施振榮將現身 ABS2024！跨世代碰撞NFT藝術家吳哲宇，大談AI、科技與藝術的奇點",
    titleEn: "Acer Founder Stan Shih at ABS 2024: A Cross-Generational Conversation with NFT Artist Che-Yu Wu on AI, Technology and the Art Singularity",
    excerpt: "動區動趨預告 ABS 亞洲區塊鏈高峰會（8 月 6 日至 8 日，南港展覽館 2 館）上施振榮與吳哲宇的跨世代對談，並介紹吳哲宇：作品以演算法為核心，團隊進駐 TempoX，曾獲選 2023 年區塊鏈影響力人物，文中也引他說 NFT 能把演算法包在作品裡與收藏者互動。",
    excerptEn: "BlockTempo previews a cross-generational conversation between Stan Shih and Che-Yu Wu at the Asia Blockchain Summit, 6 to 8 August at Nangang Exhibition Center Hall 2. It introduces Wu, whose work centres on algorithms, whose team is based at TempoX and who was named a 2023 blockchain influencer, and quotes him saying NFTs can wrap an algorithm inside a work to interact with collectors.",
    date: "2024/07/11",
    url: "https://www.blocktempo.com/cross-generational-abs-dialogue-acer-founder-stan-artist-chih-yu-wu/",
    source: "動區動趨｜AC",
    sourceEn: "BlockTempo · AC",
    category: "press",
  },
  {
    id: 201,
    title: "公視26周年與NHK合製《神木之森》臺灣山林新綠阿里山林鐵8K超高畫質獻映國人",
    titleEn: "For Its 26th Anniversary, PTS Screens the NHK Co-production on the Alishan Forest Railway in 8K",
    excerpt: "公視新聞稿寫 26 周年在兩廳院廣場舉辦《神木之森》8K 特映會，超過兩千人到場。李哲藝領軍的灣聲樂團搭配生成式藝術家吳哲宇，做了一場聲影交融的演出，公廣集團董事長胡元輝說「讓大家吸收滿滿的文化芬多精」。",
    excerptEn: "A PTS press release describes the 8K premiere of the documentary on the Alishan Forest Railway, co-produced with NHK, held at the National Theater and Concert Hall plaza for PTS's 26th anniversary and attended by more than 2,000 people; OneSong Orchestra, led by Che-Yi Lee, performed with generative artist Che-Yu Wu in a fusion of sound and image, which the PTS chair said gave everyone a dose of cultural fresh air.",
    date: "2024/06/30",
    url: "https://www.pts.org.tw/zh_tw/pr/latestnews/%E5%85%AC%E8%A6%9626%E5%91%A8%E5%B9%B4%E8%88%87NHK%E5%90%88%E8%A3%BD%E3%80%8A%E7%A5%9E%E6%9C%A8%E4%B9%8B%E6%A3%AE%E3%80%8B%E8%87%BA%E7%81%A3%E5%B1%B1%E6%9E%97%E6%96%B0%E7%B6%A0%E9%98%BF%E9%87%8C%E5%B1%B1%E6%9E%97%E9%90%B58K%E8%B6%85%E9%AB%98%E7%95%AB%E8%B3%AA%E7%8D%BB%E6%98%A0%E5%9C%8B%E4%BA%BA-80173297",
    source: "公共電視（新聞稿）",
    sourceEn: "Public Television Service (press release)",
    category: "press",
  },
  {
    id: 200,
    title: "玉山攜手公視與日本NHK 讓世界看見阿里山森林鐵道之美",
    titleEn: "E.SUN Joins PTS and Japan's NHK to Show the World the Beauty of the Alishan Forest Railway",
    excerpt: "經濟日報商情版報導玉山金融業獨家贊助公視與日本 NHK 合製的 8K 紀錄片《神木之森：阿里山森林鐵道紀行》，文中提到公視 6 月 29 日在兩廳院藝文廣場辦戶外特映會，邀灣聲樂團與新媒體藝術家吳哲宇跨界合作演出。",
    excerptEn: "A piece in the Economic Daily News' commercial section on E.SUN's exclusive sponsorship of the 8K documentary Forest of Sacred Trees: A Journey on the Alishan Forest Railway, co-produced by PTS and Japan's NHK. It mentions an outdoor screening at the National Theater and Concert Hall plaza on 29 June, with OneSong Orchestra and new media artist Che-Yu Wu performing together.",
    date: "2024/06/28",
    url: "https://web.archive.org/web/20240708062445/https://money.udn.com/money/story/6722/8060623",
    source: "經濟日報｜蔡穎青",
    sourceEn: "Economic Daily News · 蔡穎青",
    category: "press",
  },
  {
    id: 199,
    title: "Algorithm as Paint Brush: Taiwanese Generative Artist Che-Yu Wu - Art Attack Ep1",
    titleEn: "Algorithm as Paint Brush: Taiwanese Generative Artist Che-Yu Wu - Art Attack Ep1",
    excerpt: "TaiwanPlus 紀錄節目《Art Attack》第一集的官網節目頁，片長 13 分 30 秒。節目介紹寫吳哲宇不決定每一筆畫，而是寫數學方程式生成隨時變化的影像，也把演算法用在依和弦演化的器樂系統，看他怎麼跨在理性與感性之間。",
    excerptEn: "The TaiwanPlus page for episode one of the documentary series Art Attack, 13 minutes 30 seconds long. The synopsis says Che-Yu Wu does not dictate each brushstroke but writes mathematical equations that generate ever-changing images, applies the same algorithmic approach to instrumental systems that evolve within chords, and straddles rationality and sensibility.",
    date: "2024/06/21",
    url: "https://www.taiwanplus.com/shows/documentary/arts/335/art-attack/s1/240614014/algorithm-as-paint-brush-taiwanese-generative-artist-che-yu-wu",
    source: "TaiwanPlus《Art Attack》",
    sourceEn: "TaiwanPlus, Art Attack",
    category: "press",
  },
  {
    id: 198,
    title: "「神木之森：阿里山森林鐵道紀行」首映會",
    titleEn: "Premiere Screening of Forest of Sacred Trees: Alishan Forest Railway",
    excerpt: "公視之友的會員活動頁：公視與 NHK 合製的 8K 紀錄片《神木之森：阿里山森林鐵道紀行》6 月 29 日在兩廳院藝文廣場辦戶外星空首映會，邀李哲藝帶領的灣聲樂團與新媒體生成藝術家吳哲宇一起演出。",
    excerptEn: "An event page for PTS Friends members: the 8K documentary Forest of Sacred Trees: Alishan Forest Railway, co-produced by PTS and NHK, premieres outdoors at the National Theater and Concert Hall plaza on 29 June, with performances by OneSong Orchestra, led by Che-Yi Lee, and new media generative artist Che-Yu Wu.",
    date: "2024",
    url: "https://web.archive.org/web/20240625203518/https://friends.pts.org.tw/action_detail.php?id=575",
    source: "公視之友（公共電視）",
    sourceEn: "PTS Friends (Public Television Service)",
    category: "press",
  },
  {
    id: 197,
    title: "EP112 NFT臺灣之光！ 創作盜用風波反成爆紅關鍵 feat. 生成式藝術家 吳哲宇",
    titleEn: "EP112 Taiwan's NFT Star: How a Plagiarism Scandal Became the Key to Fame, feat. Generative Artist Che-Yu Wu",
    excerpt: "楊錦聰主持的《轉吧！創夢大叔》第 112 集 YouTube 版。吳哲宇談生成式藝術和 AI 生圖的差別在於作品本體是演算的程式碼，也談 NFT 被盜用反而帶來粉絲、被叫作「海火腿之父」，以及有了能好好生活的錢之後，重新問自己為什麼要創作。",
    excerptEn: "The YouTube edition of episode 112 of the Zhuan Ba podcast. Che-Yu Wu explains that what separates generative art from AI image-making is that the work itself is the code; he also talks about how the theft of his NFT work won him fans and the nickname 'father of the Sea Ham', and how, once he had enough money to live on, he had to ask himself again why he makes art.",
    date: "2024/03/27",
    url: "https://www.youtube.com/watch?v=gU_Xzmo70Fs",
    source: "轉吧！創夢大叔（YouTube）｜楊錦聰（主持）",
    sourceEn: "轉吧！創夢大叔 (YouTube) · Hosted by 楊錦聰",
    category: "interview",
  },
  {
    id: 196,
    title: "EP.172 隨影響力增值的捐款憑證 NFT ft. FAB DAO 發起人黃豆泥",
    titleEn: "EP.172: Donation-Receipt NFTs That Grow in Value with Impact, ft. the Founder of FAB DAO",
    excerpt: "區塊勢 Podcast 第 172 集訪問黃豆泥，談把捐款憑證做成 NFT。節目說明寫到他與吳哲宇共同成立公益 NFT 自治組織 FAB DAO，本集也談 FAB DAO 與百岳計畫怎麼運作、平方募資法，以及捐款憑證為何能隨影響力增值。",
    excerptEn: "Episode 172 of the Blocktrend podcast talks with one of FAB DAO's founders about turning donation receipts into NFTs. The show notes say he co-founded FAB DAO, a nonprofit NFT organisation, with Che-Yu Wu, and the episode covers how FAB DAO and Project % work, quadratic funding, and why a donation receipt can gain value as its impact grows.",
    date: "2022/08/03",
    url: "https://www.youtube.com/watch?v=FutGSrXJIno",
    source: "區塊勢 Podcast（YouTube）",
    sourceEn: "Blocktrend Podcast (YouTube)",
    category: "press",
  },
  {
    id: 195,
    title: "EP.150 賣授權是失策，純創作的 NFT 更搶手 ft. 新媒體藝術家吳哲宇",
    titleEn: "EP.150 Selling Licences Was a Mistake: Purely Artistic NFTs Are in Higher Demand, ft. New Media Artist Che-Yu Wu",
    excerpt: "區塊勢 EP150 的 YouTube 版。吳哲宇談疫情時開始一天一創作，在交大學長鼓勵下把 OpenProcessing 的作品鑄成 NFT，起初用賣授權的心態，經過一連串風波才轉向純創作，也介紹 FAB DAO 如何媒合非營利組織與創作者。",
    excerptEn: "The YouTube upload of Blocktrend EP150. Che-Yu Wu talks about starting a work-a-day project during the pandemic, minting his OpenProcessing pieces as NFTs at the urging of an NCTU senior, first treating them as licence sales and turning to pure art only after a series of controversies, and explains how FAB DAO matches non-profits with creators.",
    date: "2024/03/25",
    url: "https://www.youtube.com/watch?v=XV_zXj2FSnI",
    source: "區塊勢（YouTube 版）",
    sourceEn: "Blocktrend (YouTube)",
    category: "interview",
  },
  {
    id: 194,
    title: "宜蘭映像節邀日港台藝術家參展　用 5G 與 AI 打造「光影幻境」",
    titleEn: "Yilan Image Festival Gathers Artists from Japan, Hong Kong and Taiwan to Build Realm of Light and Shadow with 5G and AI",
    excerpt: "上報記者邱家琳介紹宜蘭映像節《光影幻境》四大展區。第二區「幻遊之林」裡，吳哲宇以演算法描繪互動科技藝術作品《靈魂魚》，同區還有吳克軍用心率與肢體數據轉成圖像的《Zendo》。展期到 2024 年 1 月 23 日。",
    excerptEn: "Up Media walks through the four zones of the Yilan Image Festival's Realm of Light and Shadow. In the second, Forest of Wandering, Che-Yu Wu draws the interactive work SoulFish with algorithms, alongside another artist's Zendo, which turns heart rate and body movement data into images. The festival runs until 23 January 2024.",
    date: "2024/01/07",
    url: "https://www.upmedia.mg/tw/lifestyle/culture/191910",
    source: "上報｜邱家琳",
    sourceEn: "Up Media · 邱家琳",
    category: "press",
  },
  {
    id: 193,
    title: "榜單出爐！台灣區塊鏈《最有影響力的30人》: 2024 市場預測、Web3 趨勢分析",
    titleEn: "The List Is Out: Taiwan Blockchain's 30 Most Influential People, with 2024 Market Predictions and Web3 Trends",
    excerpt: "動區動趨公布 2023 年台灣區塊鏈產業影響力榜單，吳哲宇以墨雨設計創辦人身分入選，並寫下他的 2024 預測：區塊鏈會繼續成為藝術媒介，生成式藝術的程式碼上鏈後，作品從靜態展示變成有動態生命的實體。",
    excerptEn: "BlockTempo publishes its 2023 list of the most influential people in Taiwan's blockchain industry, with Che-Yu Wu named as founder of Monoame Design and contributing his 2024 forecast: blockchain will keep serving as an artistic medium, and once generative art's code is on chain, works move from static display to entities with a dynamic life.",
    date: "2024/01/01",
    url: "https://www.blocktempo.com/taiwanese-blockchain-influencers-predictions-for-2024/",
    source: "動區動趨 BlockTempo｜Joe",
    sourceEn: "BlockTempo · Joe",
    category: "press",
  },
  {
    id: 192,
    title: "「2023映像節：光影幻境」｜透過5G科技與藝術文化交織｜打造聲光影觀展體驗｜呈現數位藝術和新媒體藝術等",
    titleEn: "Digi-Fi 2023: Light and Shadow Wonderland, Weaving 5G Technology with Art and Culture into an Experience of Sound, Light and Image",
    excerpt: "Art-Tech Talks 整理宜蘭 2023 映像節的四個章節，第二章「幻遊之林」一段介紹吳哲宇的《靈魂魚》：以演算法描繪的靈魂魚在數位海洋中游動，文中形容牠們在虛與實的縫隙間描繪生命的詩篇。",
    excerptEn: "Art-Tech Talks walks through the four chapters of Digi-Fi 2023 in Yilan. In the second, the Wandering Forest, a section introduces Che-Yu Wu's SoulFish: soul fish drawn by algorithm swim through a digital ocean, which the text describes as sketching a poem of life in the gap between the virtual and the real.",
    date: "2023/12/28",
    url: "https://web.archive.org/web/20240227031559/https://arttechtalks.com/digi-fi-2023/",
    source: "Art-Tech Talks",
    sourceEn: "Art-Tech Talks",
    category: "press",
  },
  {
    id: 191,
    title: "宜蘭映像節《光影幻境》4展區免費看！巨型光雕秀、紙藝森林超唯美",
    titleEn: "Yilan Image Festival's Four Zones Free to Visit: A Giant Projection Show and a Paper Forest",
    excerpt: "ETtoday 旅遊雲記者彭懷玉介紹 2023 宜蘭映像節四大展區，第二章節「幻遊之林」寫到吳哲宇的互動式科技藝術《靈魂魚》，讓人彷彿走進一片紙藝森林、感受生物悠遊身旁。展期到 2024 年 1 月 23 日，免費參觀。",
    excerptEn: "ETtoday Travel introduces the four zones of the 2023 Yilan Image Festival. The second chapter, Wandering Forest, features Che-Yu Wu's interactive work SoulFish, like stepping into a paper forest with creatures swimming past. The show runs to 23 January 2024 and is free.",
    date: "2023/12/25",
    url: "https://travel.ettoday.net/article/2650195.htm",
    source: "ETtoday 旅遊雲｜彭懷玉",
    sourceEn: "ETtoday Travel · 彭懷玉",
    category: "press",
  },
  {
    id: 190,
    title: "2023宜蘭映像節《光影幻境》4大必看亮點一次看，巨型光雕秀帶你一同穿梭虛實！",
    titleEn: "Four Highlights of Realm of Light and Shadow at the 2023 Yilan Image Festival, with a Giant Projection-Mapping Show Between the Real and the Virtual",
    excerpt: "美麗佳人介紹第七屆宜蘭映像節《光影幻境》的四個章節，第二章節「幻遊之林」寫到吳哲宇的互動科技藝術《靈魂魚》，和吳克軍的《Zendo》一起帶觀眾走進一片紙藝森林。展期從 12 月 23 日起一個月。",
    excerptEn: "Marie Claire introduces the four chapters of Realm of Light and Shadow, the seventh Yilan Image Festival. Its second chapter, Forest of Wandering, features Che-Yu Wu's interactive work SoulFish, which with another artist's Zendo leads visitors into a forest of paper art. The festival runs for a month from 23 December.",
    date: "2023/12/22",
    url: "https://www.marieclaire.com.tw/lifestyle/art/76782",
    source: "美麗佳人｜美麗佳人編輯部",
    sourceEn: "Marie Claire Taiwan · Editorial team",
    category: "press",
  },
  {
    id: 189,
    title: "值得一逛！宜蘭2023映像節《光影幻境》正式登場：帶領觀者體驗穿梭虛實、5G科技藝術的無限可能！",
    titleEn: "Worth a Visit: Yilan's 2023 Image Festival 'Illusion of Light and Shadow' Opens, Moving Between the Real and the Virtual Through 5G Art",
    excerpt: "LINE TODAY 轉載 GQ 的映像節介紹，寫第七屆映像節以《光影幻境》為題、首度導入 5G。第二章節「幻遊之林」展出臺灣演算生成藝術家吳哲宇的互動式科技藝術《靈魂魚》與吳克軍的《Zendo》。",
    excerptEn: "LINE TODAY republishes GQ's guide to the festival, now in its seventh year under the theme Illusion of Light and Shadow and using 5G for the first time; its second chapter, Forest of Wandering, shows Taiwanese algorithmic artist Che-Yu Wu's interactive work SoulFish alongside another artist's Zendo.",
    date: "2023/12/21",
    url: "https://today.line.me/tw/v2/article/7N59QxP",
    source: "LINE TODAY（轉載自 GQ）｜Stephen Chen",
    sourceEn: "LINE TODAY (from GQ Taiwan) · Stephen Chen",
    category: "press",
  },
  {
    id: 188,
    title: "新年最夢幻的視覺藝術盛宴──2023映像節《光影幻境》邀請穿梭虛擬與現實 共創山海與星光",
    titleEn: "The Most Dreamlike Visual Art Feast of the New Year: Digi-Fi 2023, Light and Shadow Wonderland, Invites You Between the Virtual and the Real",
    excerpt: "Vogue 介紹宜蘭中興文創園區的 2023 映像節《光影幻境》，展期 2023 年 12 月 23 日至隔年 1 月 23 日。第二展區寫到吳哲宇的《靈魂魚》，引導觀眾穿過光影構成的山林，尋找屬於自己的靈魂魚，作品以 5G 即時演算生成。",
    excerptEn: "Vogue introduces Digi-Fi 2023, Light and Shadow Wonderland, at the Zhongxing Cultural and Creative Park in Yilan, running from 23 December 2023 to 23 January. In the second zone, Che-Yu Wu's SoulFish guides visitors through a forest made of light to find a soul fish of their own, generated in real time over 5G.",
    date: "2023/12/21",
    url: "https://www.vogue.com.tw/special/digi-fi-2023",
    source: "Vogue Taiwan｜Bella Wang",
    sourceEn: "Vogue Taiwan · Bella Wang",
    category: "press",
  },
  {
    id: 187,
    title: "宜蘭最美映像節《光影幻境》　中興文創園區揭開序幕",
    titleEn: "Yilan's Image Festival, Illusions of Light and Shadow, Opens at Zhongxing Cultural and Creative Park",
    excerpt: "宜蘭縣政府在中央社《好生活》地方亮點發布的映像節稿：2023 映像節以《光影幻境》為主題，12 月 23 日在中興文創園區登場，「幻遊之林」展出吳哲宇的互動式科技藝術《靈魂魚》，觀眾伸手互動後，屬於自己的靈魂魚就會出現。",
    excerptEn: "A Yilan County Government release on CNA's Howlife local page: the 2023 Image Festival, themed Illusions of Light and Shadow, opens on 23 December at Zhongxing Cultural and Creative Park, and its Wandering Forest shows Che-Yu Wu's interactive work SoulFish, where reaching out to it brings up a fish of one's own.",
    date: "2023/12/20",
    url: "https://howlife.cna.com.tw/local/20231220S009.aspx",
    source: "中央社 好生活（宜蘭縣政府稿）",
    sourceEn: "CNA Howlife (Yilan County Government release)",
    category: "press",
  },
  {
    id: 186,
    title: "首度導入5G科技　2023映像節帶您悠遊《光影幻境》",
    titleEn: "Bringing in 5G for the First Time, the 2023 Yilan Image Festival Invites You into Realm of Light and Shadow",
    excerpt: "民生頭條記者陳木隆的宜蘭映像節報導（Yahoo 奇摩新聞刊出）：2023 映像節《光影幻境》12 月 23 日起在中興文創園區展出，第二章節「幻遊之林」有台灣 AI 生成藝術家吳哲宇的互動科技藝術《靈魂魚》，吳哲宇也出席縣長林姿妙率隊的暖場宣傳。",
    excerptEn: "A report on the Yilan Image Festival from a local news site, carried by Yahoo News Taiwan: the 2023 edition, Realm of Light and Shadow, opens at the Chung Hsing Cultural and Creative Park on 23 December, and its second chapter, Forest of Wandering, includes SoulFish, an interactive work by Taiwanese AI generative artist Che-Yu Wu, who also joins the warm-up event led by the county magistrate.",
    date: "2023/12/20",
    url: "https://tw.news.yahoo.com/首度導入5g科技-2023映像節帶您悠遊-光影幻境-103701333.html",
    source: "Yahoo 奇摩新聞（轉載自民生頭條）｜陳木隆",
    sourceEn: "Yahoo News Taiwan (from 民生頭條) · 陳木隆",
    category: "press",
  },
  {
    id: 185,
    title: "2023映像節「光影幻境」5G打造4大展區 23日宜蘭登場",
    titleEn: "Yilan's 2023 Image Festival 'Illusion of Light and Shadow' Opens on the 23rd with Four 5G-Powered Zones",
    excerpt: "工商時報報導宜蘭縣政府主辦的 2023 映像節 12 月 23 日在中興文創園區登場，首度導入 5G。第二章節「幻遊之林」展出台灣 AI 生成藝術家吳哲宇的互動式科技藝術《靈魂魚》與吳克軍的《Zendo》，場景是一片紙藝森林。",
    excerptEn: "Commercial Times reports that Yilan County's 2023 Image Festival opens on 23 December at Zhongxing Cultural and Creative Park, using 5G for the first time; its second chapter, Forest of Wandering, shows Taiwanese AI generative artist Che-Yu Wu's interactive work SoulFish alongside another artist's Zendo in a forest made of paper.",
    date: "2023/12/20",
    url: "https://www.ctee.com.tw/news/20231220701406-431401",
    source: "工商時報｜吳佩蓉",
    sourceEn: "Commercial Times · 吳佩蓉",
    category: "press",
  },
  {
    id: 184,
    title: "2023 台灣設計 BEST100 名單公佈！100 件無懼未知、勇敢突破的精彩案例、團隊一次揭曉",
    titleEn: "Taiwan Design BEST100 2023 Announced: 100 Fearless, Boundary-Breaking Projects and Teams",
    excerpt: "Shopping Design 公布 2023 台灣設計 BEST100 名單，以「破框世代」為題、分十個獎項。吳哲宇在双融域的《萬物公式》數位生命演化之旅，列入「年度概念展演活動」，入選短評寫「演算萬物之源，每一刻都是新生樣態」。",
    excerptEn: "Shopping Design announces its Taiwan Design BEST100 for 2023, themed 'Breaking the Frame' and divided into ten categories. Che-Yu Wu's The Great Equation: A Digital Life Journey at AMBI SPACE ONE is listed under Concept Exhibitions and Events of the Year, with the line 'computing the source of all things, every moment a new form of life'.",
    date: "2023/12/05",
    url: "https://www.shoppingdesign.com.tw/post/view/9726",
    source: "Shopping Design",
    sourceEn: "Shopping Design",
    category: "press",
  },
  {
    id: 183,
    title: "12/15 Friday Night 開講！走進方序中、登曼波、吳哲宇、the MEDIAN 的破框歷險｜BEST100 年度講座派對",
    titleEn: "Friday Night Talks on 15 December: Into the Frame-Breaking Adventures of Manbo Key, Che-Yu Wu, the MEDIAN and Others | BEST100 Annual Talk Party",
    excerpt: "Shopping Design 公告第二屆 BEST100 讀者講座派對（12 月 15 日），六位年度得主各講一章，第六章「突破」由吳哲宇主講，題目問在未知裡往前走的原動力是什麼。頁面附上他的簡介：台灣當代新媒體藝術家，作品以演算法為靈魂。",
    excerptEn: "Shopping Design announces its second BEST100 readers' talk party on 15 December, with six of the year's honourees each taking a chapter. Che-Yu Wu leads the sixth, Breakthrough, which asks what keeps one moving forward into the unknown, and the page includes his bio: a contemporary Taiwanese new media artist whose works have algorithms as their soul.",
    date: "2023/11/30",
    url: "https://www.shoppingdesign.com.tw/post/view/9705",
    source: "Shopping Design",
    sourceEn: "Shopping Design",
    category: "press",
  },
  {
    id: 182,
    title: "Music and art created by algorithms -- Wu Che-yu’s generative art exhibition｜Taiwan News",
    titleEn: "Music and art created by algorithms -- Wu Che-yu’s generative art exhibition｜Taiwan News",
    excerpt: "民視英語新聞記者 Stephany Yang 到《萬物公式》展場，拍吳哲宇彈電鋼琴、牆上作品隨音樂變化。他說寫程式像寫詩，展出的 13 件作品整合自三年來三、四百件習作，花了六個月成形，也說想和時尚產業合作。",
    excerptEn: "Formosa English News reporter Stephany Yang visits The Great Equation and films Che-Yu Wu at the electric piano as the works on the walls shift with the music. Writing code is like writing poems, he says. The 13 works draw on three to four hundred pieces made over three years and took six months to bring together, and he hopes to work with the fashion industry.",
    date: "2023/10/12",
    url: "https://www.youtube.com/watch?v=ci7wbxXTaFU",
    source: "Formosa English News（民視英語新聞）｜Stephany Yang",
    sourceEn: "Formosa English News (FTV) · Stephany Yang",
    category: "press",
  },
  {
    id: 181,
    title: "超脫市場的NFT之光，生成式藝術家吳哲宇個展《萬物公式》在數碼中茁生",
    titleEn: "An NFT Light Beyond the Market: Generative Artist Che-Yu Wu's Solo Exhibition The Great Equation Grows from Code",
    excerpt: "動區動趨走進《萬物公式》，依無機篇、有機篇、生命篇三個章節寫展覽，提到作品「百岳」與「靈魂之海」。記者也訪問吳哲宇，他說 NFT 能把數位藝術做成不可篡改的作品，也能把演算法包在裡面和收藏者互動。",
    excerptEn: "BlockTempo walks through The Great Equation chapter by chapter, from Inorganic and Organic to Life, mentioning the works Project % and Soul Sea; the reporter also talked with Che-Yu Wu, who says NFTs can make digital art tamper-proof and can wrap an algorithm inside that interacts with the collector.",
    date: "2023/10/04",
    url: "https://www.blocktempo.com/the-great-equation-che-yu-wu/",
    source: "動區動趨 BlockTempo｜AC",
    sourceEn: "BlockTempo · AC",
    category: "press",
  },
  {
    id: 180,
    title: "New York-based Taiwanese artist launches digital art universe at Taipei 101",
    titleEn: "New York-based Taiwanese artist launches digital art universe at Taipei 101",
    excerpt: "台灣英文新聞報導吳哲宇 10 月 4 日在台北 101 双融域開幕的第二次個展《萬物公式》，寫到所有影像與聲音即時運算，並結合觀眾的位置訊號。報導也提到他從國中起四度拿下宏碁數位創作獎首獎，因此受到施振榮注意。",
    excerptEn: "Taiwan News reports on Che-Yu Wu's second solo exhibition, The Great Equation, opening on 4 October at AMBI SPACE ONE in Taipei 101, where all images and sound are computed in real time and combined with visitors' positioning signals. It also notes that he caught Stan Shih's attention after winning first place four times at Acer's Digital Creation contest from junior high onward.",
    date: "2023/10/04",
    url: "https://www.taiwannews.com.tw/en/news/5013263",
    source: "Taiwan News",
    sourceEn: "Taiwan News",
    category: "press",
  },
  {
    id: 179,
    title: "【藝術文化】吳哲宇「萬物公式」 展演數位藝術生命力",
    titleEn: "[Arts & Culture] Che-Yu Wu's The Great Equation Shows the Vitality of Digital Art",
    excerpt: "自由時報記者董柏廷報導《萬物公式》記者會：吳哲宇精選 13 件生成式作品，分無機、有機、生命三篇章，24 分鐘的影音從宇宙虛空走到深海。他說一直在追求浪漫跟理性的極限，展期另有他與電子音樂家 KIVA 的雙人即興場。",
    excerptEn: "The Liberty Times covers the press event for The Great Equation: Che-Yu Wu selects 13 generative works in three chapters, inorganic, organic and life, for a 24-minute audiovisual journey from cosmic void to the deep sea. He says he has always pursued the limits of romance and reason, and the run includes improvised duets with electronic musician KIVA.",
    date: "2023/10/03",
    url: "https://art.ltn.com.tw/article/paper/1607874",
    source: "自由時報｜董柏廷",
    sourceEn: "Liberty Times · 董柏廷",
    category: "press",
  },
  {
    id: 178,
    title: "藝術家吳哲宇個展 數位基因重生之旅躍展場",
    titleEn: "Artist Che-Yu Wu's Solo Exhibition Brings a Journey of Digital Genes to the Gallery",
    excerpt: "華視新聞網刊出中央社記者王寶兒的稿：吳哲宇個展《萬物公式－數位生命演化之旅》拆解重構他的「數位生命」系列，結合古典與現代電音，10 月 4 日起在双融域 AMBI SPACE ONE 展出，他也會在單人表演場現場即興演奏。",
    excerptEn: "CTS News carries a CNA story: Che-Yu Wu's solo exhibition The Great Equation: A Digital Life Journey takes apart and rebuilds his Digital Life series with classical and modern electronic music, opening at AMBI SPACE ONE on 4 October, and he will improvise live in solo performance sessions.",
    date: "2023/10/02",
    url: "https://news.cts.com.tw/cna/life/202310/202310022234802.html",
    source: "華視新聞網（轉載自中央社）｜王寶兒",
    sourceEn: "CTS News (from CNA) · 王寶兒",
    category: "press",
  },
  {
    id: 177,
    title: "NFT泡沫？施振榮、吳哲宇續看好台數位藝術",
    titleEn: "An NFT Bubble? Stan Shih and Che-Yu Wu Remain Optimistic About Taiwan's Digital Art",
    excerpt: "新唐人亞太台報導施振榮力邀吳哲宇舉辦的展覽週一開幕。吳哲宇說現場影像與聲音都是即時演算，融合觀眾的定位訊號與音樂訊號。談到 NFT 市場，他認為要等投機風氣消退、基礎建設完備，市場才會再活絡。",
    excerptEn: "NTD Asia Pacific reports on the Monday opening of the exhibition Stan Shih invited Che-Yu Wu to hold. Wu says all the images and sound on site are computed in real time, merging visitors' positioning signals with the music; on the NFT market, he thinks it will revive once speculation fades and the infrastructure matures.",
    date: "2023/10/02",
    url: "https://www.youtube.com/watch?v=ESExL7y9KU4",
    source: "新唐人亞太台｜王冠霖、曾馨旻",
    sourceEn: "NTD Asia Pacific · 王冠霖, 曾馨旻",
    category: "press",
  },
  {
    id: 176,
    title: "探索數位生命演化 吳哲宇《萬物公式》双融域登場",
    titleEn: "Exploring the Evolution of Digital Life: Che-Yu Wu's The Great Equation Opens at AMBI SPACE ONE",
    excerpt: "人間福報報導吳哲宇 10 月 4 至 16 日在双融域的《萬物公式》，13 件作品分無機、有機、生命三章，影像與聲音全部即時演算，並接上感應觀眾位置的雷達訊號。他以《靈魂之海》為例，說同一套演算法能生成數百萬種魚。",
    excerptEn: "Merit Times reports on Che-Yu Wu's The Great Equation at AMBI SPACE ONE from 4 to 16 October: 13 works in three chapters, inorganic, organic and life, with all images and sound computed in real time and linked to radar that senses where visitors stand. Using SoulSea as an example, he says a single algorithm can generate millions of kinds of fish.",
    date: "2023/10/02",
    url: "https://www.merit-times.com.tw/NewsPage.aspx?unid=861343",
    source: "人間福報｜曹麗蕙",
    sourceEn: "Merit Times · 曹麗蕙",
    category: "press",
  },
  {
    id: 175,
    title: "藝術家吳哲宇個展 數位基因重生之旅躍展場",
    titleEn: "Artist Che-Yu Wu's Solo Show Brings a Journey of Digital Genes Reborn into the Gallery",
    excerpt: "經濟日報刊出中央社記者王寶兒的稿：吳哲宇個展《萬物公式》10 月 4 日起在双融域展出，拆解重構他的「數位生命」系列，結合古典與電音譜曲，另有單人即興演奏場。科文双融董事長施振榮在記者會贈出 500 張票給大專院校。",
    excerptEn: "Economic Daily News runs a CNA story: Che-Yu Wu's solo show The Great Equation opens at AMBI SPACE ONE on 4 October, taking apart and rebuilding his Digital Life series with music mixing classical and electronic, plus solo improvised performances. At the press event, chairman Stan Shih gives 500 tickets to universities.",
    date: "2023/10/02",
    url: "https://web.archive.org/web/20231011205843/https://money.udn.com/money/story/7307/7479043",
    source: "經濟日報（轉載自中央社）｜王寶兒",
    sourceEn: "Economic Daily News (reprinted from CNA) · 王寶兒",
    category: "press",
  },
  {
    id: 174,
    title: "科文双融引領科技藝術創新促進產學合作 創造文化科技跨域人才的商業應用典範",
    titleEn: "AMBI Leads Tech-Art Innovation and Industry–Academia Partnerships, Setting a Commercial Model for Cross-Disciplinary Culture-Tech Talent",
    excerpt: "星光娛樂流行網部落格刊出科文双融的新聞稿：吳哲宇的《萬物公式》數位生命演化之旅 10 月 4 日至 16 日在双融域 AMBI SPACE ONE 展出，精選 13 件生成式藝術作品，以 12 幕場景演出 24 分鐘。記者會上施振榮代表致贈 500 張票券給大學。",
    excerptEn: "The Estarlight blog runs a press release from AMBI: Che-Yu Wu's The Great Equation: A Digital Life Journey shows at AMBI SPACE ONE from 4 to 16 October, built from 13 selected generative works and performed as 12 scenes over 24 minutes. At the press event, Stan Shih presents 500 tickets to universities.",
    date: "2023/10/02",
    url: "https://www.estarlight.idv.tw/2023/10/blog-post.html",
    source: "星光娛樂流行網（科文双融新聞稿）",
    sourceEn: "Estarlight (press release from 科文双融)",
    category: "press",
  },
  {
    id: 173,
    title: "Inspired by Shade Green Metallic",
    titleEn: "Inspired by Shade Green Metallic",
    excerpt: "保時捷台灣官網「Dreamer Stories」以金屬魅影綠車色寫吳哲宇：電機系畢業後沒進科學園區，赴紐約念整合數位媒體。NFT 作品 Strange Robots 遭盜用反讓他受到關注，之後創作 Soul Sea 與 Pochis 系列。",
    excerptEn: "Porsche Taiwan's Dreamer Stories pairs the Shade Green Metallic paint colour with Che-Yu Wu: after electrical engineering he turned down a science-park job to study integrated digital media in New York; the theft of his NFT work Strange Robots brought him attention, and he went on to make Soul Sea and the Pochis series.",
    date: "2023",
    url: "https://www.porsche.com/taiwan/zh-tw/aboutporsche/dreamer-stories/cheyuwu75/",
    source: "Porsche Taiwan（品牌官網 Dreamer Stories）",
    sourceEn: "Porsche Taiwan (brand site, Dreamer Stories)",
    category: "press",
  },
  {
    id: 172,
    title: "灣聲首登北流 交響風跨界致敬美麗台灣",
    titleEn: "OneSong Orchestra Makes Its Debut at the Taipei Music Center, Paying Tribute to Taiwan Across Genres",
    excerpt: "灣聲樂團在台北流行音樂中心演出三場「台瘋音樂會」，由李哲藝指揮，結合流行音樂、大螢幕影像與虛擬人鄧麗君。自由時報寫到每個段落都融入台灣元素，觀眾可以看到新銳藝術家吳哲宇的視覺藝術、許芳宜的舞影。",
    excerptEn: "OneSong Orchestra performs three Crazy for Taiwan concerts at the Taipei Music Center, conducted by Che-Yi Lee and combining pop music, large-screen visuals and a virtual Teresa Teng. The Liberty Times notes that every section carries Taiwanese elements, where audiences could see the visual art of emerging artist Che-Yu Wu and the dance of Fang-Yi Sheu.",
    date: "2023/08/26",
    url: "https://art.ltn.com.tw/article/breakingnews/4408248",
    source: "自由時報｜凌美雪",
    sourceEn: "Liberty Times · 凌美雪",
    category: "press",
  },
  {
    id: 171,
    title: "灣聲樂團北流首演出 「臺瘋音樂會」奏出台灣情",
    titleEn: "OneSong Orchestra Plays the Taipei Music Center for the First Time with a Concert of Taiwanese Feeling",
    excerpt: "中央社記者趙靜瑜報導灣聲樂團首度登上台北流行音樂中心的「臺瘋音樂會」，音樂會加入人聲歌手與浮空投影，影像部分包括新銳藝術家吳哲宇的視覺藝術、許芳宜的舞影與馮業輝的縮時攝影。",
    excerptEn: "CNA reports on OneSong Orchestra's first concert at the Taipei Music Center, which adds singers and floating projections. The visuals include work by emerging artist Che-Yu Wu, dance footage of Fang-Yi Sheu and a photographer's time-lapse images.",
    date: "2023/08/26",
    url: "https://www.cna.com.tw/news/acul/202308260051.aspx",
    source: "中央社｜趙靜瑜",
    sourceEn: "Central News Agency · 趙靜瑜",
    category: "press",
  },
  {
    id: 170,
    title: "Unbound — Interview & Artist Feature",
    titleEn: "Unbound — Interview & Artist Feature",
    excerpt: "Unit London 為群展〈Unbound: Ecology in the Age of Machines〉寫的展覽介紹，七位參展藝術家之一是吳哲宇。文中寫他的 Ruin Series 以粒子與細胞通訊模擬重新想像時間流逝，讓人想到起伏的山丘、海浪與光波。頁面也列出他的 Ecological Fusion 作品。",
    excerptEn: "Unit London's introduction to the group exhibition Unbound: Ecology in the Age of Machines, with Che-Yu Wu among seven artists. It describes his Ruin Series as reimagining the passage of time through particle and cellular communication simulations, evoking rolling hills, ocean swells and light waves. The page also lists works from his Ecological Fusion series.",
    date: "2023/08/09",
    url: "https://unitlondon.com/voices/unbound/",
    source: "Unit London",
    sourceEn: "Unit London",
    category: "press",
  },
  {
    id: 169,
    title: "【藝術文化】灣聲樂團首登北流 多元跨界聚焦台灣流行樂",
    titleEn: "[Arts & Culture] OneSong Orchestra Makes Its Taipei Music Center Debut with a Cross-Genre Focus on Taiwanese Pop",
    excerpt: "自由時報預告灣聲樂團 8 月 26、27 日在台北流行音樂中心的「台瘋音樂會」，寫灣聲曾在 9 號專輯與生成藝術家吳哲宇合作 MV。這次音樂會也會在寬 20 多公尺的巨型 LED 螢幕上播放吳哲宇等人的代表作品。",
    excerptEn: "The Liberty Times previews OneSong Orchestra's concerts at the Taipei Music Center on 26 and 27 August, noting the orchestra worked with generative artist Che-Yu Wu on a music video for its ninth album; the concerts would also show representative works by Wu and others on a giant LED screen more than 20 metres wide.",
    date: "2023/07/14",
    url: "https://art.ltn.com.tw/article/paper/1593679",
    source: "自由時報｜凌美雪",
    sourceEn: "Liberty Times · 凌美雪",
    category: "press",
  },
  {
    id: 168,
    title: "台灣之光！年僅28歲登上全球數位藝壇，台灣墨雨互動設計執行長吳哲宇不怕被AI取代，反而發起「把自己取代計劃」？",
    titleEn: "Pride of Taiwan: At 28 and on the Global Digital Art Stage, Monoame Interactive CEO Che-Yu Wu Is Not Afraid of Being Replaced by AI. Instead He Started a 'Replace Myself' Project",
    excerpt: "Tatler Asia Gen.T 專訪 28 歲的吳哲宇，從建中、交大電機寫到紐約大學與 Strange Robots 程式碼被盜用。他談生成式藝術把意念寫成規則，也說明用 AutoGPT 發起的「把自己取代計劃」，以及記錄每件事動機的「尋光計畫」。",
    excerptEn: "Tatler Asia's Gen.T interviews 28-year-old Che-Yu Wu, following him from Jianguo High School and electrical engineering at NCTU to NYU and the copying of his Strange Robots code. He describes generative art as writing an intention into rules, and explains his 'Replace Myself' project built with AutoGPT and his 'Seeking Light' project of recording the motive behind everything he does.",
    date: "2023/05/21",
    url: "https://www.tatlerasia.com/gen-t/innovation/che-yu-wu-interview-gent-zh-hsnt",
    source: "Tatler Asia（Gen.T）｜Zoe Hsu",
    sourceEn: "Tatler Asia (Gen.T) · Zoe Hsu",
    category: "interview",
  },
  {
    id: 167,
    title: "FAB DAO重磅推出「百岳計畫」NFT系列，將公益、文化、藝術聚合在一起",
    titleEn: "FAB DAO Launches the Project % NFT Series, Bringing Together Charity, Culture and Art",
    excerpt: "NFT 網路新聞以自動播報形式轉貼 FAB DAO 的《百岳計畫》介紹：六位生成藝術家共創 10101 座山岳 NFT，以鑄造與分售為 FAB DAO 籌措營運與公益基金，並寫到 FAB DAO 由發起人黃豆泥、吳哲宇啟動這項公益 NFT 募資專案。",
    excerptEn: "NFT Web News reposts FAB DAO's introduction to Project % in an automated audio-news format: six generative artists create 10,101 mountain NFTs whose minting and sales fund FAB DAO's operations and charitable purchases, and FAB DAO's fundraising project was started by its two initiators, one of them Che-Yu Wu.",
    date: "2023/05/19",
    url: "https://nft.org.tw/?p=20219",
    source: "NFT 網路新聞（轉載自 FAB DAO）",
    sourceEn: "NFT Web News (reprinted from FAB DAO)",
    category: "press",
  },
  {
    id: 166,
    title: "【塊轉Web3】迷因也能做公益！區塊鏈的「iPhone時刻」何時到來？專訪FAB DAO創辦人黃豆泥",
    titleEn: "Block Shift Web3: Memes Can Do Good Too. When Will Blockchain Have Its iPhone Moment? An Interview with the Founder of FAB DAO",
    excerpt: "數位時代 Web3+ 直播節目「塊轉Web3」的重點整理，主持人葉向林訪問 FAB DAO 共同創辦人黃豆泥。他說《百岳計畫》讓藝術家用程式碼畫畫、收藏者購買，已募到兩百多萬元存在加密貨幣金庫，持有者也能投票決定這筆錢怎麼用。",
    excerptEn: "A recap of Business Next's Web3+ livestream Block Shift Web3, in which the host talks with a FAB DAO co-founder. Project %, he says, has artists paint with code for collectors to buy; it has raised more than two million, held in a crypto treasury, and holders can vote on how the money is spent.",
    date: "2023/03/23",
    url: "https://www.bnext.com.tw/article/86086/fabdao-nft-podcast",
    source: "數位時代｜邵元婷",
    sourceEn: "Business Next · 邵元婷",
    category: "press",
  },
  {
    id: 165,
    title: "【圖解】捐錢的人決定錢怎麼花！區塊鏈如何量化影響力，讓公益不再只是購買「贖罪券」？",
    titleEn: "[Explainer] Donors Decide How the Money Is Spent: How Blockchain Quantifies Impact So Giving Is No Longer Buying 'Indulgences'",
    excerpt: "數位時代以 FAB DAO 為例談區塊鏈公益，訪問共同創辦人劉育名與公關長馮立玟。文中提到正在進行的《百岳計畫 Project %》是台灣最大的公益 NFT 群募，由共同創辦人吳哲宇與多名藝術家創作，募款作為 DAO 的初始營運資本。",
    excerptEn: "Business Next looks at blockchain philanthropy through FAB DAO, interviewing one of its co-founders and its PR lead; it notes that the ongoing Project %, Taiwan's largest charity NFT crowdfunding, was created by co-founder Che-Yu Wu with several artists, and that the funds raised become the DAO's initial operating capital.",
    date: "2023/03/21",
    url: "https://www.bnext.com.tw/article/85940/fab-dao-nft",
    source: "數位時代｜邵元婷",
    sourceEn: "Business Next · 邵元婷",
    category: "press",
  },
  {
    id: 164,
    title: "An Interview with Che-Yu Wu on his Latest Collection with FOUNDO",
    titleEn: "An Interview with Che-Yu Wu on his Latest Collection with FOUNDO",
    excerpt: "數位藝術品牌 FOUNDO 在自家 Medium 刊出的訪談。吳哲宇說明 Sea Ham（Sail-o-bot）源自他的 Strange Robots，曾被未經授權改作，後來社群認回原作者。與 FOUNDO 的新系列用高飽和色彩與簡化配件，把 Sea Ham 做成符號與實體收藏。",
    excerptEn: "An interview published by the digital-art brand FOUNDO on its own Medium. Che-Yu Wu explains that Sea Ham (Sail-o-bot) grew out of his Strange Robots, was adapted without permission, and was later credited back to him by the community. The new collection with FOUNDO uses bright, saturated colours and simplified accessories to turn Sea Ham into a symbol and a physical collectible.",
    date: "2023/03/15",
    url: "https://medium.com/@foundoworld/an-interview-with-che-yu-wu-on-his-latest-collection-with-foundo-8301ba797495",
    source: "FOUNDO（Medium）",
    sourceEn: "FOUNDO (Medium)",
    category: "interview",
  },
  {
    id: 163,
    title: "馬來西亞攝影師捕捉台灣之美  沉浸式展6月登場",
    titleEn: "Malaysian Photographer Captures Taiwan's Beauty in an Immersive Show Opening in June",
    excerpt: "中央社記者王寶兒報導双融域的藝術家跨域連線記者會，主軸是馬來西亞攝影師馮業輝的縮時攝影展。文末提到江賢二、許文融、吳哲宇今年也將在双融域推出個展，以生成藝術見長的吳哲宇會利用空間特性翻玩不同視覺變化。",
    excerptEn: "CNA covers a press event at AMBI SPACE ONE centred on a Malaysian photographer's time-lapse exhibition. The story closes by noting that Paul Chiang, Che-Yu Wu and one other artist will each hold solo shows there this year, with Wu, known for generative art, using the space to play with shifting visuals.",
    date: "2023/01/30",
    url: "https://www.cna.com.tw/news/acul/202301300101.aspx",
    source: "中央社｜王寶兒",
    sourceEn: "Central News Agency · 王寶兒",
    category: "press",
  },
  {
    id: 162,
    title: "2022台灣區塊鏈影響力人物榜 #NFT 領域",
    titleEn: "Taiwan's 2022 Blockchain Influencers: NFT",
    excerpt: "動區動趨「2022 台灣區塊鏈影響力人物榜」NFT 領域收錄 FAB DAO 共同創辦人黃豆泥，介紹寫到他發起台灣最大的公益 NFT 募資專案《百岳計畫》Project %，集結跨域組織與個人，把 NFT 和公益、藝術、文化接在一起。",
    excerptEn: "BlockTempo's list of Taiwan's 2022 blockchain influencers in NFTs includes a FAB DAO co-founder, whose entry describes Project %, the largest charity NFT fundraiser in Taiwan, which he started to bring organisations and individuals together and connect NFTs with charity, art and culture.",
    date: "2023/01/02",
    url: "https://www.blocktempo.com/taiwanese-blockchain-influencers-predictions-for-2023-nft/",
    source: "動區動趨｜Joe",
    sourceEn: "BlockTempo · Joe",
    category: "press",
  },
  {
    id: 161,
    title: "Che-Yu Wu - The Soul",
    titleEn: "Che-Yu Wu - The Soul",
    excerpt: "Unit London 在《The Soul》發售頁附上訪談：吳哲宇說作品靈感來自 Olafur Eliasson 2003 年的〈The Weather Project〉與 2022 年 Solana Breakpoint 大會的視覺，像一隻漂浮的巨眼望向虛空。他也說最常用 p5.js 寫程式。",
    excerptEn: "Unit London's release page for The Soul includes an interview: Che-Yu Wu says the work was inspired by Olafur Eliasson's The Weather Project from 2003 and the visual identity of the 2022 Solana Breakpoint conference, resembling an immense floating eye staring into the void; he also names p5.js as his favourite way to code.",
    date: "2023/02/28",
    url: "https://unitlondon.com/exhibitions/che-yu-wu-the-soul/",
    source: "Unit London",
    sourceEn: "Unit London",
    category: "interview",
  },
  {
    id: 160,
    title: "EP30｜編輯部臨時動議｜林茲電子藝術節與NFT的距離｜FAB DAO「百岳計畫」 到底在爬什麼山？──feat.黃豆泥",
    titleEn: "EP30: An Editorial Motion: How Far Is Ars Electronica from NFTs? What Mountain Is FAB DAO's Project % Climbing? feat. a FAB DAO Contributor",
    excerpt: "典藏 ARTouch 的 Podcast《ARTbience 藝術環境音》第 30 集，張玉音邀 FAB DAO 貢獻者黃豆泥，談文策院與林茲電子藝術中心合製的《百岳計畫》在藝術節展出，以及加密貨幣與公益、NFT 熊市後的 Web3。",
    excerptEn: "Episode 30 of ARTouch's podcast ARTbience, in which the host talks with a FAB DAO contributor about Project %, co-produced by the Taiwan Creative Content Agency and Ars Electronica and shown at the festival, about cryptocurrency and charity, and about Web3 after the NFT bear market.",
    date: "2022/10/17",
    url: "https://artouch.com/podcast/episode/ep30",
    source: "典藏ARTouch《ARTbience 藝術環境音》｜張玉音（主持）",
    sourceEn: "ARTouch, ARTbience Podcast · Hosted by 張玉音",
    category: "press",
  },
  {
    id: 159,
    title: "麥當勞首度跨足生成藝術  推NFT級愛心雲端捐",
    titleEn: "McDonald's Moves into Generative Art for the First Time with NFT-Grade Cloud Donation Barcodes",
    excerpt: "中央社記者余曉涵引述台灣麥當勞新聞稿：麥當勞首度跨足生成藝術，與吳哲宇合作推出「愛心特快車」等 3 個系列共 15 款「愛心雲端捐」個性潮圖，結合麥當勞叔叔之家慈善基金會的發票捐贈條碼，可從官網下載。",
    excerptEn: "CNA cites a McDonald's Taiwan press release: in its first move into generative art, McDonald's works with Che-Yu Wu on 15 designs in three series for its cloud invoice donation barcode, linked to the Ronald McDonald House Charities and downloadable from its website.",
    date: "2022/11/23",
    url: "https://www.cna.com.tw/news/ahel/202211230133.aspx",
    source: "中央社｜余曉涵",
    sourceEn: "Central News Agency · 余曉涵",
    category: "press",
  },
  {
    id: 158,
    title: "文策院院長李明哲、林茲電子藝術節總監 Martin Honzik談未來內容發展關鍵字： 跨域共創 X 以人為本",
    titleEn: "TAICCA President Lee Ming-Che and Ars Electronica Festival Director Martin Honzik on the Keywords for Future Content: Cross-Disciplinary Co-Creation and People First",
    excerpt: "INSIDE 刊出的廣編專訪，文策院院長李明哲與林茲電子藝術節總監 Martin Honzik 談跨域共創。文中寫文策院首度與林茲電子藝術中心合辦台灣專場，展出 FAB DAO 發起的《百岳計畫》：NFT 成為捐款收據，持有者共同決定公益資金怎麼用。",
    excerptEn: "A sponsored interview in INSIDE with TAICCA president Lee Ming-Che and Ars Electronica Festival director Martin Honzik on cross-disciplinary co-creation. It notes TAICCA's first Taiwan programme co-organised with the Ars Electronica Center, which showed FAB DAO's Project %: the NFTs serve as donation receipts, and holders decide together how the charity funds are spent.",
    date: "2022/11/17",
    url: "https://www.inside.com.tw/article/29690-tccf",
    source: "INSIDE（廣編企劃）",
    sourceEn: "INSIDE (sponsored)",
    category: "press",
  },
  {
    id: 157,
    title: "【藝術文化】2022 TCCF 創意內容大會 未來內容展接軌國際",
    titleEn: "[Arts & Culture] The 2022 TCCF Future Content Showcase Connects with the World",
    excerpt: "自由時報介紹 2022 TCCF「未來內容展」的 19 組作品，寫《百岳計畫》由 FAB DAO 邀五位生成式藝術家王連晟、王新仁、林逸文、林經堯和吳哲宇，以台灣山稜線為素材創作，以 NFT 販售，收益作為台灣生態保護的公益款項。",
    excerptEn: "The Liberty Times introduces the 19 works at the 2022 TCCF Future Content Showcase, describing Project % as FAB DAO inviting five generative artists, among them Che-Yu Wu and Aluan Wang, to create from Taiwan's mountain ridgelines, sold as NFTs with proceeds going to conservation in Taiwan.",
    date: "2022/11/12",
    url: "https://art.ltn.com.tw/article/paper/1550989",
    source: "自由時報｜凃盈如",
    sourceEn: "Liberty Times · 凃盈如",
    category: "press",
  },
  {
    id: 156,
    title: "2022 TCCF 未來內容展多國專家深度對談 對接國際最新文化科技產業趨勢",
    titleEn: "Experts from Several Countries in Depth at the 2022 TCCF Future Content Exhibition, Connecting with the Latest International Trends in Cultural Technology",
    excerpt: "文策院發布、刊在中央社訊息平台的 TCCF 未來內容展新聞稿，以《百岳計畫》當合製例子：FAB DAO 邀王連晟、王新仁、林逸文、林經堯和吳哲宇，以臺灣山稜線生成百座山巒，以 NFT 形式販售，收益作為生態保護的公益款項。",
    excerptEn: "A Taiwan Creative Content Agency press release on the TCCF Future Content exhibition, carried on CNA's press release platform, cites Project % as a co-production: FAB DAO invited Che-Yu Wu, Aluan Wang and three other artists to generate a hundred of Taiwan's mountains from its ridgelines, sold as NFTs with proceeds going to conservation.",
    date: "2022/11/10",
    url: "https://www.cna.com.tw/postwrite/chi/328683",
    source: "中央社訊息平台｜文化內容策進院",
    sourceEn: "CNA press release platform · Taiwan Creative Content Agency",
    category: "press",
  },
  {
    id: 155,
    title: "【藝術文化】2022 TCCF創意內容大會 未來內容展松菸開跑",
    titleEn: "[Arts & Culture] TCCF 2022 Future Content Exhibition Opens at Songshan Cultural and Creative Park",
    excerpt: "自由時報記者凃盈如報導 2022 TCCF 未來內容展在松山文創園區開展，文策院以「擴增宇宙運算中」為主軸集結 19 件沉浸式節目。報導列舉的代表作品包括文策院與林茲電子藝術中心合製支持、FAB DAO 開創的《百岳計畫》。",
    excerptEn: "The Liberty Times reports on the opening of the TCCF 2022 Future Content Exhibition at Songshan Cultural and Creative Park, where TAICCA gathers 19 immersive programmes. The highlights listed include Project %, started by FAB DAO with support from TAICCA's co-production programme with Ars Electronica.",
    date: "2022/11/06",
    url: "https://art.ltn.com.tw/article/paper/1549822",
    source: "自由時報｜凃盈如",
    sourceEn: "Liberty Times · 凃盈如",
    category: "press",
  },
  {
    id: 154,
    title: "登入元宇宙！2022 TCCF 未來內容展以故事力帶你搞懂 Web3.0",
    titleEn: "Log In to the Metaverse: The 2022 TCCF Future Content Exhibition Explains Web3.0 Through Storytelling",
    excerpt: "INSIDE 刊出的 TCCF 未來內容展廣編（文：設計發浪），在「未來造夢場運算中」區介紹 FAB DAO 發起的《百岳計畫》：邀吳哲宇、林逸文、王連晟、林經堯、王新仁五位生成藝術家，以台灣山岳為題創造一萬座山岳 NFT，再由黃新編碼合成展示。",
    excerptEn: "A sponsored feature on the TCCF Future Content Exhibition in INSIDE introduces FAB DAO's Project % in the Dreamscape Processing zone: five generative artists, among them Che-Yu Wu and Aluan Wang, take Taiwan's mountains as their subject to create 10,000 mountain NFTs, which another contributor coded together for display.",
    date: "2022/11/04",
    url: "https://www.inside.com.tw/article/29560-TCCFDESIGNSURFING",
    source: "INSIDE｜設計發浪（廣編企劃）",
    sourceEn: "INSIDE · 設計發浪 (sponsored)",
    category: "press",
  },
  {
    id: 153,
    title: "TCCF創意內容大會未來內容展開幕 19跨域節目展現科技力",
    titleEn: "TCCF Future Content Showcase Opens with 19 Cross-Disciplinary Programmes Showing the Power of Technology",
    excerpt: "NOWnews 報導 2022 TCCF 創意內容大會「未來內容展」在松山文創園區開展，集結 19 項沉浸式節目。文策院點名的代表作品裡，第一件就是文策院與林茲電子藝術中心合製支持、FAB DAO 開創的《百岳計畫》。",
    excerptEn: "NOWnews reports on the opening of the Future Content Showcase at the 2022 TCCF in Songshan Cultural and Creative Park, gathering 19 immersive programmes; the first of the highlights TAICCA names is Project %, initiated by FAB DAO with co-production support from TAICCA and Ars Electronica.",
    date: "2022/11/03",
    url: "https://www.nownews.com/news/5963738",
    source: "NOWnews 今日新聞｜李琦瑋",
    sourceEn: "NOWnews · 李琦瑋",
    category: "press",
  },
  {
    id: 152,
    title: "「從疫情時代進入元宇宙時代」新科技如何提升台灣文化",
    titleEn: "From the Pandemic Era to the Metaverse Era: How New Technology Can Lift Taiwanese Culture",
    excerpt: "文策院在 VERSE 刊登的廣編，介紹 TCCF 未來內容展四件作品。《百岳計畫》一段由 FAB DAO 的黃豆泥說明：七月市場低點發行，仍有四百多人參與、募得三百多萬元，九成收益投入公益。文末註明參與藝術家包括吳哲宇。",
    excerptEn: "A sponsored feature placed in VERSE by the Taiwan Creative Content Agency on four works at the TCCF Future Content exhibition. In the Project % section, a member of FAB DAO explains that it launched in July at the market's low yet drew over 400 participants and more than NT$3 million, with 90 per cent of proceeds going to charity. A footnote lists the participating artists, including Che-Yu Wu.",
    date: "2022/11/02",
    url: "https://www.verse.com.tw/article/future-processing",
    source: "VERSE｜文化內容策進院（廣告）",
    sourceEn: "VERSE · Taiwan Creative Content Agency (sponsored)",
    category: "press",
  },
  {
    id: 151,
    title: "UNIT-ON-CHAIN: Zach Lieberman & Che-Yu Wu on Finding Poetry in Creative Coding",
    titleEn: "UNIT-ON-CHAIN: Zach Lieberman & Che-Yu Wu on Finding Poetry in Creative Coding",
    excerpt: "倫敦畫廊 Unit London 的 Podcast《Unit-on-Chain》第一季第四集，吳哲宇與 Zach Lieberman 對談創意程式。他談疫情期間開始密集創作、台北 101 個展裡觀眾被包圍的感受、受印象派啟發的粒子作品，也想透過教學與分享程式碼讓台灣社群更容易入門。",
    excerptEn: "Episode four of Unit-on-Chain, the podcast of London gallery Unit London, pairs Che-Yu Wu with Zach Lieberman on creative coding. Wu talks about creating intensively since the pandemic, how audiences felt surrounded at his Taipei 101 solo show, his particle work inspired by Impressionism, and making the practice easier to enter in Taiwan by teaching and sharing code.",
    date: "2022/10/21",
    url: "https://unitlondon.com/2022-10-21/unit-on-chain-zach-lieberman-che-yu-wu-on-finding-poetry-in-creative-coding/",
    source: "Unit London《Unit-on-Chain》",
    sourceEn: "Unit London, Unit-on-Chain",
    category: "interview",
  },
  {
    id: 150,
    title: "資本社會的代幣模型如何走向「公益」：FAB DAO《百岳計畫》的未來社會行動",
    titleEn: "How to Drive Tokenomics towards Philanthropy in a Capitalist Society: FAB DAO's Project % and Its Future Social Action",
    excerpt: "典藏 ARTouch 張玉音專訪 FAB DAO 核心貢獻者黃豆泥，談文策院與林茲電子藝術中心合製、在林茲電子藝術節台灣專場展出的《百岳計畫》：一萬張生成藝術 NFT，由王新仁、林經堯、王連晟、林逸文、吳哲宇五位藝術家創作，再由黃新整合。",
    excerptEn: "ARTouch interviews a FAB DAO core contributor about Project %, co-produced by TAICCA and the Ars Electronica Center and shown in the Taiwan programme at Ars Electronica: 10,000 generative art NFTs by five artists, among them Aluan Wang and Che-Yu Wu, brought together by another contributor.",
    date: "2022/10/18",
    url: "https://artouch.com/art-market/content-84864.html",
    source: "典藏ARTouch｜張玉音",
    sourceEn: "ARTouch · 張玉音 (Yu-Yin Chang)",
    category: "press",
  },
  {
    id: 149,
    title: "Che-Yu Wu",
    titleEn: "Che-Yu Wu",
    excerpt: "Contemporary Art Curator Magazine 在「Faces of the Peace Art Prize」單元刊出吳哲宇的藝術家簡介：以紐約為基地的數位藝術家，從數學、音樂與現代藝術取材。簡介列出 fxhash 上的 SoulSea、SoulFish 系列，以及 FAB DAO 的《百岳計畫》。",
    excerptEn: "Contemporary Art Curator Magazine publishes an artist profile of Che-Yu Wu in its Faces of the Peace Art Prize section: a New York-based digital artist drawing on maths, music and modern art, whose notable projects include the SoulSea and SoulFish series on fxhash and FAB DAO's Project %.",
    date: "2022/10/18",
    url: "https://www.contemporaryartcuratormagazine.com/faces-of-the-peace/che-yu-wu",
    source: "Contemporary Art Curator Magazine",
    sourceEn: "Contemporary Art Curator Magazine",
    category: "press",
  },
  {
    id: 148,
    title: "Welcome to Planet B and The Festival of Political Correctness",
    titleEn: "Welcome to Planet B and The Festival of Political Correctness",
    excerpt: "FAB DAO 成員黃豆泥（黃彥霖）在數位荒原寫林茲電子藝術節觀察，從局外人角度談藝術節對東亞政治認同的表態。引言列出參展的台灣藝術家，包括《百岳計畫》的吳哲宇等六人，文中也附百岳計畫的演出照。",
    excerptEn: "A FAB DAO member writes for No Man's Land on Ars Electronica from an outsider's view, including the festival's positions on political identity in East Asia. The introduction lists the Taiwanese artists who took part, among them the six of Project % including Che-Yu Wu, and the article includes a photo of the Project % performance.",
    date: "2022/09/17",
    url: "https://www.heath.tw/nml-article/welcome-to-planet-b-and-the-festival-of-political-correctness/",
    source: "數位荒原｜黃彥霖",
    sourceEn: "No Man's Land · 黃彥霖",
    category: "press",
  },
  {
    id: 147,
    title: "2022林茲電子藝術節（一） ｜ NFT 在林茲",
    titleEn: "Ars Electronica 2022 (Part 1) | NFTs in Linz",
    excerpt: "FAB DAO 創辦人黃豆泥在 Matters 寫 2022 林茲電子藝術節，記《百岳計畫》（Project %）是當屆四件 NFT 作品之一，談這個計畫的去中心治理與非營利實踐，以及歐洲策展人怎麼看 NFT。文中沒有點名個別藝術家。",
    excerptEn: "FAB DAO's founder writes on Matters about Ars Electronica 2022, noting that Project % was one of only four NFT works in the festival, and discusses its decentralised governance and non-profit practice as well as how European curators view NFTs. The piece does not name individual artists.",
    date: "2022/09/16",
    url: "https://matters.town/a/7jgm82ymx4i1",
    source: "Matters｜黃豆泥",
    sourceEn: "Matters · 黃豆泥",
    category: "press",
  },
  {
    id: 146,
    title: "FAB DAO｜支持百岳計畫 Project % 鑄造百岳 參與區塊鏈 打造 WEB3 元宇宙",
    titleEn: "FAB DAO: Support Project %, Mint a Peak, Join the Blockchain and Build the Web3 Metaverse",
    excerpt: "方格子作者雙寶老爹在理財專欄介紹《百岳計畫》Project %：六位生成藝術家共創 10,101 座山岳 NFT，是黃豆泥、吳哲宇發起的公益 NFT 募資專案。文章也一步步示範用小狐狸錢包在官網鑄造，一張 0.025 ETH。",
    excerptEn: "In a personal finance column on vocus, a blogger introduces Project %: 10,101 mountain NFTs created by six generative artists, a charity NFT fundraiser started by Che-Yu Wu and a fellow FAB DAO founder. The post also walks through minting on the official site with a MetaMask wallet, at 0.025 ETH each.",
    date: "2022/09/03",
    url: "https://vocus.cc/article/65e6dd99fd8978000127f4be",
    source: "方格子 vocus｜雙寶老爹",
    sourceEn: "vocus · 雙寶老爹",
    category: "press",
  },
  {
    id: 145,
    title: "2022 林茲電子藝術節臺灣作品持續發熱 文策院與大會首度合辦臺灣專場 探索科技創新文化內容",
    titleEn: "Taiwanese Works Stay Hot at Ars Electronica 2022 as TAICCA and the Festival Co-host a Taiwan Showcase for the First Time",
    excerpt: "文策院新聞稿宣布與林茲電子藝術中心首度合辦臺灣專場，展出《百岳計畫》等作品。稿中寫《百岳計畫》由 FAB DAO 邀王連晟、王新仁、林逸文、林經堯和吳哲宇，以臺灣山稜線為素材、程式碼為畫筆，以 NFT 形式募資。",
    excerptEn: "A TAICCA press release announces its first Taiwan showcase co-hosted with Ars Electronica, featuring Project % among other works. It describes Project % as FAB DAO inviting Che-Yu Wu, Aluan Wang and three other artists to draw Taiwan's mountain ridgelines in code, sold as NFTs to raise funds.",
    date: "2022/08/26",
    url: "https://taicca.tw/article/f068670d",
    source: "文化內容策進院（新聞稿）",
    sourceEn: "Taiwan Creative Content Agency (press release)",
    category: "press",
  },
  {
    id: 144,
    title: "2022林茲電子藝術節台灣作品發光 台灣專場首登場",
    titleEn: "Taiwanese Works Shine at Ars Electronica 2022 as the First Taiwan Showcase Opens",
    excerpt: "自由時報報導 2022 林茲電子藝術節首度辦台灣專場，展出《百岳計畫》《藍眼淚》《沙盒》。《百岳計畫》由 FAB DAO 邀王連晟、王新仁、林逸文、林經堯與吳哲宇，以台灣山稜線為素材、程式碼為畫筆，以 NFT 形式販售。",
    excerptEn: "The Liberty Times reports that Ars Electronica 2022 holds its first Taiwan showcase, with Project %, Blue Tears and Sandbox. For Project %, FAB DAO invited Che-Yu Wu, Aluan Wang and three other artists to draw Taiwan's ridgelines with code, sold as NFTs.",
    date: "2022/08/27",
    url: "https://art.ltn.com.tw/article/breakingnews/4038807",
    source: "自由時報｜凃盈如",
    sourceEn: "Liberty Times · 凃盈如",
    category: "press",
  },
  {
    id: 143,
    title: "2022 林茲電子藝術節 文策院與大會首度合辦台灣專場",
    titleEn: "Ars Electronica 2022: TAICCA and the Festival Co-Host a Taiwan Showcase for the First Time",
    excerpt: "央廣報導文策院首度與林茲電子藝術中心合辦 2022 林茲電子藝術節台灣專場，展出合製作品《百岳計畫》：FAB DAO 邀請王連晟、王新仁、林逸文、林經堯與吳哲宇，以程式碼描繪百座台灣山巒，並以 NFT 販售支持公益團體。",
    excerptEn: "RTI reports that TAICCA and Ars Electronica co-host a Taiwan showcase at the 2022 festival for the first time, featuring their co-produced Project %: FAB DAO invited Wang Lien-Cheng, Wang Hsin-Jen, Lin Yi-Wen, Lin Ching-Yao and Che-Yu Wu to draw a hundred Taiwanese mountains in code, sold as NFTs to support non-profits.",
    date: "2022/08/26",
    url: "https://web.archive.org/web/20221016084739/https://www.rti.org.tw/news/view/id/2142719",
    source: "中央廣播電臺 Rti｜江昭倫",
    sourceEn: "Radio Taiwan International · 江昭倫",
    category: "press",
  },
  {
    id: 142,
    title: "TAICCA: Futuritive Art and Social Activism",
    titleEn: "TAICCA: Futuritive Art and Social Activism",
    excerpt: "Ars Electronica 部落格訪問文策院（TAICCA），談雙方共同委託的《百岳計畫》（Project Percentage）：作品在林茲電子藝術節 Kepler's Gardens 主題展展出，集結五位台灣藝術家、一萬件生成藝術 NFT，捐款匯入加密貨幣公益基金，也在 Deep Space 8K 放映。",
    excerptEn: "The Ars Electronica blog interviews TAICCA about Project Percentage, which the two co-commissioned: shown in the Theme Exhibition at Kepler's Gardens during the festival, it brings together five Taiwanese artists and 10,000 generative art NFTs whose proceeds are pooled into a public crypto fund, and it also screens in Deep Space 8K.",
    date: "2022/08/19",
    url: "https://ars.electronica.art/aeblog/en/2022/08/19/taicca/",
    source: "Ars Electronica Blog｜Amelie Steininger",
    sourceEn: "Ars Electronica Blog · Amelie Steininger",
    category: "press",
  },
  {
    id: 141,
    title: "能夠永存善意的NFT：FAB DAO - 百岳計畫 Project %",
    titleEn: "NFTs That Keep Goodwill Forever: FAB DAO's Project %",
    excerpt: "區塊鏈藝術媒體 c2x3 在 Matters 介紹 FAB DAO 首次發行的公益 NFT《百岳計畫 Project %》，寫到吳哲宇與黃豆泥共同創辦 FAB DAO，藝術家名單列出他負責「島嶼」系列。每位藏家代表 1%，每枚 NFT 等同一張捐款收據。",
    excerptEn: "The blockchain art outlet c2x3 introduces on Matters Project %, the first charity NFT release by FAB DAO, noting that Che-Yu Wu co-founded FAB DAO and listing him as the artist of its Island series; each collector stands for 1%, and each NFT works as a donation receipt.",
    date: "2022/07/15",
    url: "https://matters.town/a/fe3n38t5khdb",
    source: "Matters｜c2x3（區塊鏈藝術媒體）",
    sourceEn: "Matters · c2x3 (blockchain art media)",
    category: "press",
  },
  {
    id: 140,
    title: "Undervalued: Sail-o-bots, Dissolve, Poolsuite Passes, and More",
    titleEn: "Undervalued: Sail-o-bots, Dissolve, Poolsuite Passes, and More",
    excerpt: "nft now 每週專欄介紹被低估的 NFT 項目，其中一節寫 Sail-o-bots：2021 年 6 月 28 日在 Art Blocks 發行，源自 Che-Yu Wu 的生成作品 Strange Robots，後來被社群叫作「sea hams」，成了收藏圈的迷因。",
    excerptEn: "nft now's weekly column on undervalued NFT projects includes a section on Sail-o-bots: launched on Art Blocks on 28 June 2021 and based on Strange Robots, a generative project by Che-Yu Wu, the collection was nicknamed 'sea hams' by the community and became a meme among collectors.",
    date: "2022/07/01",
    url: "https://nftnow.com/collectibles/undervalued-sail-o-bots-dissolve-poolsuite-passes-and-more/",
    source: "nft now｜Langston Thomas",
    sourceEn: "nft now · Langston Thomas",
    category: "press",
  },
  {
    id: 139,
    title: "公益NFT自治組織FAB DAO將推出「百岳計畫%」，創建捐款永動機",
    titleEn: "Charity NFT DAO FAB DAO to Launch Project %, a Perpetual Donation Machine",
    excerpt: "鏈新聞介紹 FAB DAO 即將公售的公益 NFT《百岳計畫%》，由台灣五位生成式藝術家共創山景系列，讓捐款收據可以轉售。文中寫到創辦人黃豆泥的友人吳哲宇，他表示會把 Art Blocks 的 NFT 拍賣收入指定捐給 FAB DAO。",
    excerptEn: "ABMedia introduces Project %, the charity NFT that FAB DAO is about to put on public sale: a mountain series made by five Taiwanese generative artists that turns donation receipts into resellable works. It mentions Che-Yu Wu as a friend of FAB DAO's founder, and Wu says he will direct his NFT auction income from Art Blocks to FAB DAO.",
    date: "2022/06/30",
    url: "https://abmedia.io/20220630-charity-dao-fab-dao-project",
    source: "鏈新聞 ABMedia",
    sourceEn: "ABMedia",
    category: "press",
  },
  {
    id: 138,
    title: "【藝術文化】北藝中心開幕倒數 巨球接力投影視覺創作",
    titleEn: "Counting Down to the Taipei Performing Arts Center's Opening with Relay Projections on the Globe",
    excerpt: "自由時報記者凃盈如報導台北表演藝術中心的開幕倒數計畫：到 8 月 7 日開幕當天為止，每晚 19:00 到 22:00 在球劇場「巨球」外牆接力投影 30 組視覺藝術家與創作團隊的作品，吳哲宇在參與名單中。",
    excerptEn: "The Liberty Times reports on the Taipei Performing Arts Center's opening countdown: every night from 7 to 10 pm until the opening on 7 August, the outer wall of the Globe theatre carries a relay of projections by 30 visual artists and teams. Che-Yu Wu is on the list.",
    date: "2022/06/04",
    url: "https://art.ltn.com.tw/article/paper/1520925",
    source: "自由時報｜凃盈如",
    sourceEn: "Liberty Times · 凃盈如",
    category: "press",
  },
  {
    id: 137,
    title: "施振榮推動數位創作人才培育 盼双融域搭建新舞台",
    titleEn: "Stan Shih Promotes Digital Creative Talent, Hoping Ambi Space Becomes a New Stage",
    excerpt: "中央社根據智榮基金會新聞稿報導，施振榮趁吳哲宇由美返台，邀他在双融域辦個展，並在 5 月 27 日安排宏碁數位創作獎歷屆得獎人與他視訊交流。文中寫他 14 歲國二就參賽，如今站上國際舞台。",
    excerptEn: "Drawing on a release from the Stans Foundation, CNA reports that Stan Shih invited Che-Yu Wu, back from the US, to hold a solo show at Ambi Space, and arranged a video exchange on 27 May between past Acer Digital Creation Award winners and Wu, who first entered the competition at 14 and now works on the international stage.",
    date: "2022/05/30",
    url: "https://www.cna.com.tw/news/afe/202205300191.aspx",
    source: "中央社｜吳家豪",
    sourceEn: "Central News Agency · 吳家豪",
    category: "press",
  },
  {
    id: 136,
    title: "施振榮推動數位創作人才培育 盼双融域搭建新舞台",
    titleEn: "Stan Shih Backs Training for Digital Creators, Hoping AMBI SPACE ONE Will Become a New Stage",
    excerpt: "中央社依智榮基金會新聞稿報導，施振榮 5 月 27 日透過視訊，與宏碁數位創作獎歷屆得獎人及吳哲宇交流創作經驗。文中寫到吳哲宇 14 歲國二參賽，施振榮趁他由美返台期間，邀他在双融域辦個展。經濟日報刊出。",
    excerptEn: "Citing a release from the Stan Shih Foundation, CNA reports that on 27 May Stan Shih held a video exchange on creative experience between past winners of the Acer Digital Creation Award and Che-Yu Wu. It notes that Wu first entered at 14, and that Shih invited him to hold a solo exhibition at AMBI SPACE ONE during his visit home from the US. Published by the Economic Daily News.",
    date: "2022/05/30",
    url: "https://web.archive.org/web/20220614204237/https://money.udn.com/money/story/5612/6351537",
    source: "經濟日報（轉載自中央社）｜吳家豪",
    sourceEn: "Economic Daily News (from CNA) · 吳家豪",
    category: "press",
  },
  {
    id: 135,
    title: "吳哲宇NFT生成藝術個展《混沌實驗室》：一場音像藝術沉浸體驗，串連50件作品與聲音創作",
    titleEn: "Che-Yu Wu's NFT Generative Art Solo Show Chaos Lab: An Immersive Audiovisual Experience Linking 50 Works and Sound",
    excerpt: "500輯沈佩臻寫《混沌實驗室》在双融域登場，吳哲宇把 2020 至 2022 年的 50 件 NFT 生成作品化為音像演出，音樂融合古典與電音，現場演奏搭配即時影像。他說想用理性的程式創造感性的藝術，在沉浸場域給觀眾直覺的震撼。",
    excerptEn: "500 Times covers the opening of Chaos Lab at AMBI SPACE ONE: Che-Yu Wu turns 50 NFT generative works from 2020 to 2022 into an audiovisual performance, with music mixing classical and electronic and live playing driving real-time images. He says he wants to create emotional art through rational code and give visitors an intuitive jolt in an immersive space.",
    date: "2022/05/20",
    url: "https://500times.udn.com/wtimes/story/12672/6329101",
    source: "500輯｜沈佩臻",
    sourceEn: "500 Times (udn) · 沈佩臻",
    category: "press",
  },
  {
    id: 134,
    title: "Taiwanese generative artist to showcase viral NFT creations in Taipei 101",
    titleEn: "Taiwanese generative artist to showcase viral NFT creations in Taipei 101",
    excerpt: "Taiwan News 英文報導吳哲宇在台北 101 双融域的首次實體個展《混沌實驗室》。他說展名來自在紐約求學時的心境，島嶼、海浪等系列用古典樂、幾何與像素描寫那段起伏，這場展「會像 EDM 派對」。文中也寫施振榮在他 14 歲時就看見他的才華。",
    excerptEn: "Taiwan News covers Che-Yu Wu's first physical solo show, Chaos Lab, at Ambi Space One in Taipei 101. He says the title comes from his state of mind as a student in New York, and that series such as Island and Waves use classical music, geometry and pixels to portray those ups and downs. The show, he says, will be like an EDM party. Stan Shih first saw his talent when Wu was 14.",
    date: "2022/05/19",
    url: "https://www.taiwannews.com.tw/news/4543375",
    source: "Taiwan News｜Lyla Liu",
    sourceEn: "Taiwan News · Lyla Liu",
    category: "press",
  },
  {
    id: 133,
    title: "藝術家吳哲宇「混沌實驗室」首展 雙融域炫目開展",
    titleEn: "Artist Che-Yu Wu's Chaos Lab Opens in Dazzling Style at Ambi Space",
    excerpt: "自由時報記者寫吳哲宇的「混沌實驗室」精選 2020 至 2022 年的 50 件生成式演算作品，搭配古典與電音現場演奏，讓双融域像電音派對。他說這些作品多在紐約疫情期間完成，像瘋狂科學家把城市裡的壓抑情緒轉成圖像。",
    excerptEn: "A Liberty Times reporter writes that Che-Yu Wu's Chaos Lab gathers 50 generative works from 2020 to 2022 with live classical and electronic music, turning Ambi Space into something like an electronic dance party; he says most of the works were made in New York during the pandemic, like a mad scientist turning the city's pent-up feelings into images.",
    date: "2022/05/19",
    url: "https://art.ltn.com.tw/article/paper/1517965",
    source: "自由時報｜凃盈如",
    sourceEn: "Liberty Times · 凃盈如",
    category: "press",
  },
  {
    id: 132,
    title: "「台灣之光」吳哲宇生成藝術個展 引領走入NFT虛擬世界【央廣新聞】",
    titleEn: "'Pride of Taiwan' Che-Yu Wu's Generative Art Solo Exhibition Leads Visitors into the World of NFTs (Rti News)",
    excerpt: "中央廣播電臺的 91 秒新聞影片，報導吳哲宇 5 月 20 至 22 日在双融域 AMBI SPACE ONE 的生成藝術個展《混沌實驗室》，在科文双融支持下，透過互動式 NFT 程式，把影像擴張到沉浸式場域。",
    excerptEn: "A 91-second news video from Radio Taiwan International on Che-Yu Wu's generative art solo exhibition Chaos Lab at AMBI SPACE ONE from 20 to 22 May, supported by Ambi Culture, which uses interactive NFT code to extend the images into an immersive space.",
    date: "2022/05/19",
    url: "https://www.youtube.com/watch?v=8CP3Ht4eRyA",
    source: "Rti 中央廣播電臺（YouTube）",
    sourceEn: "Radio Taiwan International (Rti), YouTube",
    category: "press",
  },
  {
    id: 131,
    title: "「台灣之光」吳哲宇生成藝術個展  引領走入NFT虛擬世界",
    titleEn: "\"Pride of Taiwan\" Che-Yu Wu's Generative Art Solo Show Leads Visitors into the Virtual World of NFTs",
    excerpt: "央廣記者江昭倫報導《混沌實驗室》：吳哲宇集結 2020 至 2022 年的 50 件生成式作品，投進双融域五面投影的沉浸空間，40 分鐘展演的音樂也由他一手包辦。文中提到「Strange Robots」程式碼遭盜用，反而讓他在國際 NFT 圈打開知名度。",
    excerptEn: "RTI covers Chaos Lab: Che-Yu Wu gathers 50 generative works from 2020 to 2022 into the five-sided projection space of AMBI SPACE ONE, and composed the music for the 40-minute show himself. The story notes that the copying of his Strange Robots code ended up making his name in the international NFT scene.",
    date: "2022/05/19",
    url: "https://web.archive.org/web/20250327034801/https://www.rti.org.tw/news/view/id/2133415",
    source: "中央廣播電臺 Rti｜江昭倫",
    sourceEn: "Radio Taiwan International · 江昭倫",
    category: "press",
  },
  {
    id: 130,
    title: "NFT藝術家吳哲宇打造沉浸式體驗 (圖)",
    titleEn: "NFT Artist Che-Yu Wu Creates an Immersive Experience (Photo)",
    excerpt: "中央社在 Yahoo 新聞刊出的一則新聞照片：NFT 藝術家吳哲宇將在台舉辦個展，5 月 18 日舉行起跑記者會，首次把生成藝術透過互動式 NFT 程式，從影像擴張到沉浸式場域。照片由中央社實習記者蔡沛芸拍攝。",
    excerptEn: "A CNA news photo carried by Yahoo News Taiwan: NFT artist Che-Yu Wu is about to hold a solo exhibition in Taiwan, launched at a press event on 18 May, extending generative art through interactive NFT code from the screen into an immersive space for the first time. Photo by a CNA intern reporter.",
    date: "2022/05/18",
    url: "https://tw.news.yahoo.com/nft%E8%97%9D%E8%A1%93%E5%AE%B6%E5%90%B3%E5%93%B2%E5%AE%87%E6%89%93%E9%80%A0%E6%B2%89%E6%B5%B8%E5%BC%8F%E9%AB%94%E9%A9%97-%E5%9C%96-114954011.html",
    source: "Yahoo 新聞（轉載自中央社）｜蔡沛芸（攝影）",
    sourceEn: "Yahoo News Taiwan (from CNA) · Photo by 蔡沛芸",
    category: "press",
  },
  {
    id: 129,
    title: "通膨封城影響台廠 施振榮：調整體質彈性適應",
    titleEn: "Inflation and Lockdowns Hit Taiwanese Firms; Stan Shih: Strengthen Fundamentals and Stay Flexible",
    excerpt: "中央社這則施振榮談景氣的稿子，開頭交代受訪場合：吳哲宇自創的 NFT 生成藝術個展「混沌實驗室」首度與双融域及宏碁合作，施振榮在起跑記者會上受訪，談通膨與中國封城對台廠的影響。",
    excerptEn: "This CNA story on Stan Shih's view of the economy opens by explaining where he spoke: at the launch press conference for Chaos Lab, the NFT generative art solo exhibition Che-Yu Wu created, his first collaboration with Ambi Space and Acer, where Shih discussed how inflation and China's lockdowns affect Taiwanese companies.",
    date: "2022/05/18",
    url: "https://www.cna.com.tw/news/afe/202205180316.aspx",
    source: "中央社｜吳家豪",
    sourceEn: "Central News Agency · 吳家豪",
    category: "press",
  },
  {
    id: 128,
    title: "「吳哲宇生成藝術個展」双融域登場 帶觀眾走進NFT虛擬世界",
    titleEn: "Che-Yu Wu's Generative Art Solo Exhibition Opens at AMBI SPACE ONE, Taking Visitors into the World of NFTs",
    excerpt: "人間福報報導吳哲宇 5 月 20 至 22 日在双融域的個展《混沌實驗室》，集結 2020 至 2022 年 50 件生成式作品，以現場演奏即時影響程式視覺。施振榮說吳哲宇當年經歷過宏碁數位創作獎，吳哲宇則說這次用理性的程式創造感性的藝術。",
    excerptEn: "Merit Times reports on Che-Yu Wu's solo exhibition Chaos Lab at AMBI SPACE ONE from 20 to 22 May: 50 generative works made between 2020 and 2022, with live music shaping the code-driven visuals in real time. Stan Shih notes that Wu came up through the Acer Digital Creation Award, and Wu says the show uses rational code to make art that moves people.",
    date: "2022/05/18",
    url: "https://www.merit-times.com.tw/NewsPage.aspx?unid=787038",
    source: "人間福報｜曹麗蕙",
    sourceEn: "Merit Times · 曹麗蕙",
    category: "press",
  },
  {
    id: 127,
    title: "全球數位藝壇的台灣之光 吳哲宇「混沌實驗室」台北101登場",
    titleEn: "A Pride of Taiwan in Global Digital Art: Che-Yu Wu's Chaos Lab Opens at Taipei 101",
    excerpt: "自由時報記者凃盈如報導吳哲宇生成藝術個展《混沌實驗室》5 月 20 日至 22 日在台北 101 五樓双融域售票展出，從父母以 AutoCAD 做設計、他國高中四次拿下宏碁數位創作獎首獎寫起，也介紹週末的生成式 NFT 工作坊。",
    excerptEn: "The Liberty Times reports that Che-Yu Wu's generative art solo show Chaos Lab runs from 20 to 22 May at AMBI SPACE ONE on the fifth floor of Taipei 101. The story starts with his parents designing in AutoCAD and his four first prizes at the Acer Digital Creation Awards in school, and introduces the weekend generative NFT workshop.",
    date: "2022/05/18",
    url: "https://art.ltn.com.tw/article/breakingnews/3931218",
    source: "自由時報｜凃盈如",
    sourceEn: "Liberty Times · 凃盈如",
    category: "press",
  },
  {
    id: 126,
    title: "全台首創「虛擬NFT生成式藝術」來了　施振榮曝：每場都有變化！",
    titleEn: "Taiwan's First Virtual NFT Generative Art Show Arrives, and Stan Shih Says Every Performance Is Different",
    excerpt: "ETtoday 財經雲記者吳康瑋寫施振榮出席吳哲宇的《混沌實驗室》個展，說這是全台首次把 NFT 生成式藝術轉成實體沉浸式演出，現場演奏與樂段會即時影響程式視覺，每場都不一樣。他也提到吳哲宇是宏碁數位創作獎發掘的人才。",
    excerptEn: "ETtoday Finance covers Stan Shih at Che-Yu Wu's solo exhibition Chaos Lab. Shih calls it Taiwan's first translation of NFT generative art into a physical immersive performance, with live playing and musical passages shaping the visuals in real time so that no two shows are alike. He also notes that Wu was discovered through the Acer Digital Creation Awards.",
    date: "2022/05/18",
    url: "https://finance.ettoday.net/news/2253876",
    source: "ETtoday 財經雲｜吳康瑋",
    sourceEn: "ETtoday Finance · 吳康瑋",
    category: "press",
  },
  {
    id: 125,
    title: "双融域攜手宏碁 舉辦NFT藝術家吳哲宇個展",
    titleEn: "Ambi Space Teams Up with Acer for a Solo Exhibition by NFT Artist Che-Yu Wu",
    excerpt: "經濟日報報導吳哲宇的「混沌實驗室」個展 5 月 20 日至 22 日在台北 101 双融域 AMBI SPACE ONE 登場，由施振榮牽線促成。文中寫他以 2020 至 2022 年的演算作品為基底，自己用古典與電音譜曲，現場演奏、即時生成影像。",
    excerptEn: "Economic Daily News reports that Che-Yu Wu's solo exhibition Chaos Lab would run 20 to 22 May at Ambi Space One in Taipei 101, brokered by Stan Shih; it describes the show as built on his algorithmic works from 2020 to 2022, with music he composed himself in classical and electronic styles, played live as the images are generated in real time.",
    date: "2022/05/18",
    url: "https://web.archive.org/web/20220519201916/https://udn.com/news/story/7240/6322548",
    source: "聯合新聞網（經濟日報）｜吳凱中",
    sourceEn: "United Daily News (udn.com), Economic Daily News · 吳凱中",
    category: "press",
  },
  {
    id: 124,
    title: "【專訪】吳哲宇，「螢幕保護程式」也能賣出NFT天價？作品被盜反受矚目的數位生成藝術家！",
    titleEn: "Interview: Che-Yu Wu, the Generative Artist Whose Stolen Work Drew Attention, on How a 'Screensaver' Can Sell as an NFT for a Fortune",
    excerpt: "ELLE 專訪寫 27 歲的吳哲宇從交大電機到紐約大學，2020 年把生成藝術放上 NFT 平台，Strange Robots 程式碼被盜用、仿作賣出 50 個以太幣，反而讓他受到注意。文中也介紹 White Castle 漢堡、Soul Sea 與混沌實驗室個展。",
    excerptEn: "ELLE's interview follows 27-year-old Che-Yu Wu from electrical engineering at NCTU to NYU. In 2020 he began putting his generative art on NFT platforms, and when the code of Strange Robots was copied and the imitation sold for 50 ETH, the episode drew attention to him. The piece also introduces the White Castle burgers, SoulSea and his Chaos Lab exhibition.",
    date: "2022/05/16",
    url: "https://www.elle.com/tw/life/tech/g39901804/che-yu-wu-nft-artist/",
    source: "ELLE｜Dominique Chiang",
    sourceEn: "ELLE Taiwan · Dominique Chiang",
    category: "interview",
  },
  {
    id: 123,
    title: "我最終極的目標是影響力！NFT藝術的創作幕後談—— NFT數位藝術家吳哲宇(電機06)專訪",
    titleEn: "My Ultimate Goal Is Influence: Behind the Scenes of NFT Art — An Interview with NFT Digital Artist Che-Yu Wu (EE 06)",
    excerpt: "交大友聲專訪電機系校友吳哲宇，記他小學用 Flash、高中用程式做生命演化，在 Hahow 開課累計 1.5 萬學員。他談 NFT 讓數位作品的唯一性可以被驗證，自己專注互動型 NFT，也介紹福爾摩沙藝術銀行的構想。",
    excerptEn: "NCTU Alumni Voice interviews electrical engineering alumnus Che-Yu Wu, from Flash in primary school and code-based life evolution in high school to 15,000 students on Hahow. He explains how NFTs make the uniqueness of a digital work verifiable, why he focuses on interactive NFTs, and his plan for the Formosa Art Bank.",
    date: "2022/04/12",
    url: "https://nctu-alumni-voice.sec.nycu.edu.tw/?p=2389",
    source: "交大友聲",
    sourceEn: "NCTU Alumni Voice",
    category: "interview",
  },
  {
    id: 122,
    title: "不到30歲！他靠NFT翻身暴富成台灣身價破億數位藝術家",
    titleEn: "Not Yet 30: How NFTs Made Him a Taiwanese Digital Artist Worth Over NT$100 Million",
    excerpt: "Cheers 刊出天下雜誌的報導。2020 年紐約封城期間，吳哲宇在布魯克林的公寓創作，在學長鼓勵下發行 21 件 NFT，三個月後意外爆紅，已發行作品總交易額超過 1 億 6000 萬台幣。文中也寫他在 Hahow 開課吸引 1.5 萬名學生。",
    excerptEn: "Cheers runs a CommonWealth Magazine report. During New York's 2020 lockdown, Che-Yu Wu made work in his Brooklyn apartment and, encouraged by an alumnus, released 21 NFTs. Three months later they took off unexpectedly, and total trading on his releases has passed NT$160 million. The piece also notes that his Hahow courses drew 15,000 students.",
    date: "2022/04/11",
    url: "https://cheers.com.tw/article/article.action?id=5100763",
    source: "Cheers 快樂工作人（轉載自天下雜誌）｜林麗珊",
    sourceEn: "Cheers (from CommonWealth Magazine) · 林麗珊",
    category: "press",
  },
  {
    id: 121,
    title: "每幅NFT作品賣逾60萬…27歲小夥子，從沒沒無聞到受收藏家追捧　他是怎麼做到的？",
    titleEn: "Each NFT Sells for Over NT$600,000: How Did a 27-Year-Old Go from Unknown to Sought After by Collectors?",
    excerpt: "林宏文在今周刊專欄整理他在《陽明交大幫幫忙》節目訪問吳哲宇的內容：從小學寫遊戲、在 Hahow 開課累計 1.5 萬名學員，到 NFT 的三類創作與 White Castle 合作，也記下他對投資 NFT 的提醒「最近要小心，水很深」。",
    excerptEn: "A Business Today columnist writes up his own interview with Che-Yu Wu on the show NYCU Helps Out: from writing games in primary school and teaching 15,000 students on Hahow to his three kinds of NFT work and the White Castle collaboration, with Wu's warning on NFT investing: 'be careful lately, the water is deep'.",
    date: "2022/03/11",
    url: "https://www.businesstoday.com.tw/article/category/80394/post/202203110012/",
    source: "今周刊｜林宏文（轉載自鍶科技）",
    sourceEn: "Business Today · 林宏文 (republished from his site 鍶科技)",
    category: "interview",
  },
  {
    id: 120,
    title: "從乏人問津到交易額1.6億 台灣小子靠NFT一年身價破億",
    titleEn: "From No Buyers to NT$160 Million in Sales: A Young Taiwanese Artist Worth Over NT$100 Million After One Year of NFTs",
    excerpt: "《天下雜誌》743 期 Web3 專題，寫 2020 年紐約封城時在布魯克林公寓用程式碼創作的吳哲宇：他在學長鼓勵下發行 21 件 NFT，起初只有學長收藏一件，三個月後作品定價翻漲十倍。全文限訂戶閱讀。",
    excerptEn: "From CommonWealth Magazine's Web3 issue (no. 743): during New York's 2020 lockdown, Che-Yu Wu wrote generative art in his Brooklyn apartment. Encouraged by an alumnus, he released 21 NFTs; at first only that alumnus bought one, and three months later his prices had risen tenfold. The full article is for subscribers.",
    date: "2022/03/07",
    url: "https://cw.com.tw/article/5120326",
    source: "天下雜誌｜林麗珊",
    sourceEn: "CommonWealth Magazine · 林麗珊",
    category: "interview",
  },
  {
    id: 119,
    title: "INTERVIEW: CHE-YU WU",
    titleEn: "INTERVIEW: CHE-YU WU",
    excerpt: "ITSLIQUID 的 Luca Curci 在威尼斯 THE BODY LANGUAGE 2022 展期間訪問吳哲宇。他說創作時會設一小時計時器讓自己專注，用數學與程式把自然和科技接在一起，參展作品想在疫情造成的隔離裡探索更深的自我認識。",
    excerptEn: "Luca Curci of ITSLIQUID talks with Che-Yu Wu during THE BODY LANGUAGE 2022 in Venice. Wu says he sets an hour-long timer to stay focused while working, joins nature and technology through maths and code, and with the works in the show wants to explore a deeper sense of self amid the isolation the pandemic brought.",
    date: "2022/02/24",
    url: "https://www.itsliquid.com/interview-cheyuwu.html",
    source: "ITSLIQUID｜Luca Curci（訪談）",
    sourceEn: "ITSLIQUID · Interview by Luca Curci",
    category: "interview",
  },
  {
    id: 118,
    title: "NFT紅什麼？施振榮力推數位藝術家 霹靂也玩NFT收藏品",
    titleEn: "Why Are NFTs Hot? Stan Shih Champions a Digital Artist, and Pili Gets into NFT Collectibles Too",
    excerpt: "NOWnews 記者許家禎寫施振榮在新春線上拜年活動介紹吳哲宇，回顧他國二到高三連續五年參加宏碁數位創作獎、拿下四次首獎。吳哲宇說首次在台個展《混沌實驗室》會把演算藝術做成沉浸式互動體驗。後半篇轉談霹靂《PILI Fantasy》NFT。",
    excerptEn: "NOWnews reports on Stan Shih introducing Che-Yu Wu at a Lunar New Year online event, recalling five straight years at the Acer Digital Creation Awards from junior high to his final year of high school and four first prizes. Wu says his first solo show in Taiwan, Chaos Lab, will turn his algorithmic art into an immersive interactive experience. The second half turns to Pili's PILI Fantasy NFTs.",
    date: "2022/02/08",
    url: "https://www.nownews.com/news/5710042",
    source: "NOWnews 今日新聞｜許家禎",
    sourceEn: "NOWnews · 許家禎",
    category: "press",
  },
  {
    id: 117,
    title: "《電腦設備》26歲新秀財富自由 施振榮拚NFT創作育才",
    titleEn: "[Computer Equipment] A 26-Year-Old Rising Star Reaches Financial Freedom as Stan Shih Pushes to Nurture NFT Creators",
    excerpt: "時報資訊報導施振榮在新春線上拜年邀吳哲宇同台，說他「在元宇宙世界發現一匹千里馬」。文中回顧吳哲宇國二起連續五年參加宏碁數位創作獎、拿下四次首獎，也寫到他規劃在台首次個展「混沌實驗室」與發起福爾摩沙藝術銀行 DAO。",
    excerptEn: "China Times Information reports that Stan Shih invited Che-Yu Wu to join his online Lunar New Year greeting, saying he had 'found a thoroughbred in the metaverse'. It recalls Wu entering the Acer Digital Creation Award five years running from the eighth grade and winning first prize four times, and mentions his planned first solo show in Taiwan, Chaos Lab, and the Formosa Art Bank DAO he co-founded.",
    date: "2022/02/07",
    url: "https://www.chinatimes.com/realtimenews/20220207001764-261507",
    source: "中時新聞網（時報資訊）",
    sourceEn: "China Times (China Times Information)",
    category: "press",
  },
  {
    id: 116,
    title: "看好政府發行數位貨幣 施振榮：可能5年內普及",
    titleEn: "Upbeat on Government-Issued Digital Currency, Stan Shih Says It Could Be Widespread Within Five Years",
    excerpt: "施振榮連續第三年以視訊新春拜年，今年談元宇宙與 NFT，並邀吳哲宇參與。中央社寫到吳哲宇國二拿下第 5 屆宏碁數位創作獎國中組首獎，預計 4 月在双融域首度辦個展與台灣百岳 NFT 體驗展，也引述他對虛實整合的看法。",
    excerptEn: "For the third year running, Stan Shih gave his Lunar New Year greetings by video, this time talking about the metaverse and NFTs with Che-Yu Wu as a guest. CNA notes that Wu won the junior high first prize at the fifth Acer Digital Creation Award in his second year of junior high, that he planned his first solo exhibition in Taiwan and a Taiwan Hundred Peaks NFT experience at AMBI SPACE ONE in April, and quotes his view on bringing the virtual and the physical together.",
    date: "2022/02/07",
    url: "https://www.cna.com.tw/news/afe/202202070089.aspx",
    source: "中央社｜吳家豪",
    sourceEn: "Central News Agency (CNA) · 吳家豪",
    category: "press",
  },
  {
    id: 115,
    title: "不只村上龍、王家衛！認識世界10大最高排名NFT藝術家！",
    titleEn: "Not Just Murakami and Wong Kar-wai! Meet the World's Ten Top-Ranked NFT Artists",
    excerpt: "香港教育品牌 Preface 的部落格整理 NFT 藝術家，台灣一段寫吳哲宇：2016 年智慧城市黑客松評審團大獎得主，NFT 企劃總值約 1,300 顆以太幣，舊作「Strange Robots」程式碼遭盜用後被業界注意，也受 White Castle 邀請創作百週年 NFT 系列 Sliderverse。",
    excerptEn: "A blog post by the Hong Kong education brand Preface rounds up NFT artists. Its Taiwan entry covers Che-Yu Wu: jury prize winner at the 2016 Smart City Hackathon, NFT projects worth about 1,300 ETH, noticed by the industry after his old Strange Robots code was copied, and invited by White Castle to create Sliderverse, an NFT series for its centenary.",
    date: "2022/01/06",
    url: "https://www.preface.ai/blog/nft-%E8%97%9D%E8%A1%93%E5%AE%B6/",
    source: "Preface（香港）",
    sourceEn: "Preface (Hong Kong)",
    category: "press",
  },
  {
    id: 114,
    title: "施振榮伯樂識馬 吳哲宇國際舞台發光 施振榮：吳哲宇將與科文双融攜手首度在台開展，並培育NFT創作人才",
    titleEn: "Stan Shih Spots a Talent: Che-Yu Wu Shines Internationally, and Will Hold His First Taiwan Exhibition with AMBI and Nurture NFT Creators",
    excerpt: "智榮基金會發布的稿：施振榮在 2022 年新春線上拜年活動介紹吳哲宇，從他國二拿下第五屆宏碁數位創作獎國中組首獎談起，宣布他將與科文双融合作首次在台個展《混沌實驗室》，並發起台灣百岳計畫 NFT 體驗展與 FAB DAO。",
    excerptEn: "A release from the Stans Foundation: at his 2022 Lunar New Year online greeting, Stan Shih introduces Che-Yu Wu, starting from the junior high first prize he won at the fifth Acer Digital Creation Awards, and announces Wu's first solo exhibition in Taiwan, Chaos Lab, with AMBI, along with a Taiwan Hundred Peaks NFT exhibition and FAB DAO.",
    date: "2022",
    url: "https://stansfoundation.org/articles/378197",
    source: "智榮基金會",
    sourceEn: "Stans Foundation",
    category: "press",
  },
  {
    id: 113,
    title: "藝文內容走向元宇宙 施振榮鼓勵跨界共創",
    titleEn: "Arts Content Moves into the Metaverse: Stan Shih Encourages Cross-Sector Co-creation",
    excerpt: "民眾網整理陽明交大藝文界校友元宇宙座談，吳哲宇以 106 級校友、NFT 藝術家身分與談。他提到元宇宙除了虛擬世界，連結實體世界也是重要的落地應用，例如質押會員籍空投 NFT 兌換商品，或用演算法設計服飾、虛實整合販售。",
    excerptEn: "Mypeople recaps the NYCU arts alumni forum on the metaverse, where Che-Yu Wu spoke as a 2017 alumnus and NFT artist. He noted that beyond building virtual worlds, connecting to the physical world is an important application, such as airdropping NFTs to staked memberships for redemption, or designing fashion with algorithms and selling it both online and off.",
    date: "2022/01/25",
    url: "https://tw.news.yahoo.com/藝文內容走向元宇宙-施振榮鼓勵跨界共創-034324175.html",
    source: "Yahoo 新聞（轉載自民眾網）｜劉家瑜",
    sourceEn: "Yahoo News (from Mypeople 民眾網) · 劉家瑜",
    category: "press",
  },
  {
    id: 112,
    title: "【藝術文化】藝文領域的元宇宙機遇 科技與文化人對談",
    titleEn: "Arts and Culture: The Metaverse's Opportunities for the Arts, a Conversation Between Technology and Culture",
    excerpt: "自由時報寫施振榮邀陽明交大校友對談藝文元宇宙，旅美的吳哲宇以視訊參與。他說自己從國中開始創作，用編碼重構技法，就能大量生成同一風格、每張不同的數位版畫，NFT 讓藝術家與藏家直接連接，虛實整合會是下一步。",
    excerptEn: "The Liberty Times reports on a conversation Stan Shih convened with fellow NYCU alumni about the arts in the metaverse, with Che-Yu Wu joining by video from the US. He says he has been making work since junior high; by rebuilding a technique in code he can generate many digital prints in one style, each different, NFTs connect artists directly with collectors, and the meeting of virtual and physical comes next.",
    date: "2022/01/25",
    url: "https://art.ltn.com.tw/article/paper/1497670",
    source: "自由時報｜王瀅娟",
    sourceEn: "Liberty Times · 王瀅娟",
    category: "press",
  },
  {
    id: 111,
    title: "元宇宙新機會 施振榮：積極推動跨域合作",
    titleEn: "New Opportunities in the Metaverse: Stan Shih Calls for Active Cross-Disciplinary Collaboration",
    excerpt: "理財周刊報導陽明交大與文化科技發展協會合辦的藝文界元宇宙座談，吳哲宇以 106 級校友、NFT 藝術家身分與談。他說區塊鏈讓藝術家能出版數位正本，結合生成式藝術後版畫變成以程式創作，元宇宙也要能連結實體世界。",
    excerptEn: "Money Weekly reports on a metaverse forum for arts alumni co-hosted by NYCU and the Cultural Technology Development Association, where Che-Yu Wu speaks as a 2017 alumnus and NFT artist. He says blockchain lets artists publish digital originals, generative art turns printmaking into creation by code, and the metaverse also needs to connect with the physical world.",
    date: "2022/01/24",
    url: "https://www.moneyweekly.com.tw/ArticleData/Info/Article/76948",
    source: "理財周刊",
    sourceEn: "Money Weekly",
    category: "press",
  },
  {
    id: 110,
    title: "元宇宙新機會　施振榮：跨域合作內容才是King",
    titleEn: "New Opportunities in the Metaverse: Stan Shih Says Cross-Disciplinary Content Is King",
    excerpt: "蘋果日報報導施振榮發起的陽明交大藝文界校友元宇宙座談，吳哲宇以 NFT 藝術家身分與談。他說區塊鏈讓藝術家能發行數位正本，Art Blocks 上每一版都是演算法生成的動態作品，元宇宙也要連結實體世界，例如質押會員籍空投 NFT 兌換商品。",
    excerptEn: "Apple Daily reports on a metaverse forum of NYCU arts alumni convened by Stan Shih, where Che-Yu Wu speaks as an NFT artist. Blockchain lets artists publish digital originals, he says, and every edition on Art Blocks is a dynamic work generated by an algorithm. The metaverse also needs to connect to the physical world, for example by airdropping redeemable NFTs to staked members.",
    date: "2022/01/24",
    url: "https://web.archive.org/web/20220906021451/https://www.appledaily.com.tw/property/20220124/QP2SECB4CBGEFJ777R75CYATKM/",
    source: "蘋果日報｜陳俐妏",
    sourceEn: "Apple Daily · 陳俐妏",
    category: "press",
  },
  {
    id: 109,
    title: "《產業》藝文走向元宇宙 施振榮跨界追索",
    titleEn: "[Industry] Arts Move into the Metaverse as Stan Shih Looks Across Fields",
    excerpt: "時報資訊報導施振榮發起的陽明交大藝文界校友元宇宙座談，吳哲宇以 NFT 藝術家身分與談。他說區塊鏈讓藝術家能出版數位正本，結合生成式藝術後，傳統版畫變成用程式創作，像 Art Blocks 每一版都是演算法生成的動態作品。",
    excerptEn: "China Times Information reports on a metaverse forum of NYCU arts alumni convened by Stan Shih, where Che-Yu Wu spoke as an NFT artist. He said blockchain lets artists publish digital originals, and with generative art the traditional print edition becomes something made in code: on Art Blocks every edition is a dynamic work generated by an algorithm.",
    date: "2022/01/24",
    url: "https://www.chinatimes.com/realtimenews/20220124004643-260410",
    source: "中時新聞網（時報資訊）",
    sourceEn: "China Times (China Times Information)",
    category: "press",
  },
  {
    id: 108,
    title: "施振榮：以創新內容迎接元宇宙成長 積極推動跨域合作",
    titleEn: "Stan Shih: Meeting the Metaverse's Growth with Innovative Content and Cross-Disciplinary Collaboration",
    excerpt: "陽明交大與文化科技發展協會合辦的元宇宙座談，聯合新聞網列出與談校友，吳哲宇以 NFT 藝術家身分出席。報導寫他談區塊鏈讓藝術家能出版數位正本，結合生成式藝術，把傳統版畫變成用程式創作、每一版都不同的作品。",
    excerptEn: "At a metaverse forum co-hosted by NYCU and the Cultural Technology Development Association, udn.com lists the alumni speakers, with Che-Yu Wu taking part as an NFT artist. It reports him saying that blockchains let artists publish digital originals and, combined with generative art, turn the traditional print into works written as code, each edition different.",
    date: "2022/01/24",
    url: "https://web.archive.org/web/20220124172511/https://udn.com/news/story/7240/6056969",
    source: "聯合新聞網｜吳凱中",
    sourceEn: "United Daily News (udn.com) · 吳凱中",
    category: "press",
  },
  {
    id: 107,
    title: "Issue 49｜兩位台灣NFT先鋒藝術家：王新仁與吳哲宇",
    titleEn: "Issue 49 | Two Taiwanese NFT Pioneers: Wang Hsin-Jen and Che-Yu Wu",
    excerpt: "500輯專題寫兩位先後登上 Art Blocks 的台灣藝術家。吳哲宇一段從他的 Hahow 課寫起，記「Strange Robots」程式碼遭〈sail-o-bots〉盜用、他意外成為「火腿之父」，2021 年 11 月《Electriz》登上 Art Blocks 售罄，並在台灣成立 FAB DAO。",
    excerptEn: "A 500 Times feature on two Taiwanese artists who each reached Art Blocks. Che-Yu Wu's section starts from his Hahow courses, recounts how his Strange Robots code was copied for sail-o-bots and turned him into the accidental father of the ham meme, then notes that Electriz sold out on Art Blocks in November 2021 and that he founded FAB DAO in Taiwan.",
    date: "2022/01/21",
    url: "https://500times.udn.com/wtimes/story/120842/6050011",
    source: "500輯｜黃豆泥",
    sourceEn: "500 Times (udn) · 黃豆泥",
    category: "press",
  },
  {
    id: 106,
    title: "獨家〉闖進紐約的台灣之光，憑NFT實現財富自由的26歲無名小卒",
    titleEn: "Exclusive: A Taiwanese Talent in New York, the 26-Year-Old Unknown Who Found Financial Freedom Through NFTs",
    excerpt: "Yahoo 奇摩新聞轉載遠見雜誌的報導。26 歲的吳哲宇在紐約疫情期間「一天一創作」，舊作 Strange Robots 的程式碼被 Art Blocks 上的 sail-o-bots 盜用後受到注意，11 月登上 Art Blocks，也接到美國漢堡品牌 White Castle 的合作。母親林美櫻談他小時候學 Flash。",
    excerptEn: "Yahoo News Taiwan carries a Global Views Monthly report. During the pandemic in New York, 26-year-old Che-Yu Wu made one piece a day. After sail-o-bots on Art Blocks was found to use code from his earlier Strange Robots, he drew attention, released on Art Blocks in November and was approached by the American burger chain White Castle. His mother recalls him learning Flash as a child.",
    date: "2021/12/24",
    url: "https://tw.news.yahoo.com/%E7%8D%A8%E5%AE%B6-%E9%97%96%E9%80%B2%E7%B4%90%E7%B4%84%E7%9A%84%E5%8F%B0%E7%81%A3%E4%B9%8B%E5%85%89-%E6%86%91nft%E5%AF%A6%E7%8F%BE%E8%B2%A1%E5%AF%8C%E8%87%AA%E7%94%B1%E7%9A%8426%E6%AD%B2%E7%84%A1%E5%90%8D%E5%B0%8F%E5%8D%92-110300616.html",
    source: "Yahoo 奇摩新聞（轉載自遠見雜誌）｜林士蕙",
    sourceEn: "Yahoo News Taiwan (from Global Views Monthly) · 林士蕙",
    category: "press",
  },
  {
    id: 105,
    title: "White Castle joins NFT art trend, releases its own collection",
    titleEn: "White Castle joins NFT art trend, releases its own collection",
    excerpt: "Fox Business 報導 White Castle 為百年生日與 Doodle Labs 推出 NFT 系列《Sliderverse》，作品由媒體藝術家吳哲宇創作。White Castle 行銷長 Lynn Blashford 說，吳哲宇把多媒體技術與藝術結合成獨特的創作。",
    excerptEn: "Fox Business reports that White Castle teamed up with Doodle Labs for its 100th birthday on the Sliderverse NFT collection, created by media artist Che-Yu Wu; White Castle's chief marketing officer Lynn Blashford says he brilliantly combines multimedia technology and art into a unique creation.",
    date: "2021/12/21",
    url: "https://www.foxbusiness.com/lifestyle/white-castle-introduces-nft-art-collection",
    source: "Fox Business｜Michael Hollan",
    sourceEn: "Fox Business · Michael Hollan",
    category: "press",
  },
  {
    id: 104,
    title: "White Castle Just Jumped On The NFT Bandwagon",
    titleEn: "White Castle Just Jumped On The NFT Bandwagon",
    excerpt: "美食媒體 Mashed 報導 White Castle 為百週年與數位藝術家 Che-Yu Wu、Doodle Labs 合作，在以太坊發行 5,000 件 NFT，提到藏家可能從 Sail-o-bots 認得他，也介紹 Sliderverse 線上藝廊裡像電玩畫面的薯餅、洋蔥圈與漢堡。",
    excerptEn: "The food site Mashed reports that White Castle, marking its centenary, has teamed up with digital artist Che-Yu Wu and Doodle Labs to release 5,000 NFTs on Ethereum, notes that collectors may know him from the Sail-o-bots collection, and points readers to the Sliderverse gallery of video-game-like hash browns, onion rings and sliders.",
    date: "2021/12/20",
    url: "https://www.mashed.com/711987/white-castle-just-jumped-on-the-nft-bandwagon/",
    source: "Mashed｜Amy Hamblen",
    sourceEn: "Mashed · Amy Hamblen",
    category: "press",
  },
  {
    id: 103,
    title: "The Truth About White Castle’s NFT | Che-Yu Artist Interview",
    titleEn: "The Truth About White Castle’s NFT | Che-Yu Artist Interview",
    excerpt: "美國 NFT 節目 The Daily Bone Podcast 在 YouTube 上傳的英語訪談，長約 28 分鐘。標題點名藝術家吳哲宇，主題是美國漢堡連鎖 White Castle 推出的 NFT，以藝術家訪談的形式談這個系列。",
    excerptEn: "An English-language interview uploaded to YouTube by the American NFT show The Daily Bone Podcast, about 28 minutes long. The title names the artist Che-Yu Wu, and the subject is the NFT released by the American burger chain White Castle, discussed in an interview with the artist.",
    date: "2021/12/17",
    url: "https://www.youtube.com/watch?v=p2w8S4DM3Bg",
    source: "The Daily Bone Podcast（YouTube）",
    sourceEn: "The Daily Bone Podcast (YouTube)",
    category: "interview",
  },
  {
    id: 102,
    title: "White Castle Announces NFT Collaboration with Doodle Labs & Media Artist, Che-Yu Wu",
    titleEn: "White Castle Announces NFT Collaboration with Doodle Labs & Media Artist, Che-Yu Wu",
    excerpt: "Food Market 刊出白色城堡（White Castle）新聞稿的開頭：為慶祝品牌 100 週年，白色城堡與 Doodle Labs 合作，由數位媒體藝術家吳哲宇創作 5,000 件生成藝術 NFT，12 月在 Doodle Labs 發行，是第一個採用 Art Blocks 生成鑄造技術的品牌合作。",
    excerptEn: "Food Market runs the opening of White Castle's press release: to mark the brand's 100th birthday, White Castle has partnered with Doodle Labs on 5,000 generative art NFTs by digital media artist Che-Yu Wu, launching in December on Doodle Labs as the first brand partnership powered by Art Blocks' generative minting technology.",
    date: "2021/12/17",
    url: "https://www.foodmarket.com/News/A/1214787/White-Castle-Announces-NFT-Collaboration-with-Doodle-Labs--Media-Artist-Che-Yu-Wu",
    source: "Food Market（White Castle 新聞稿）",
    sourceEn: "Food Market (White Castle press release)",
    category: "press",
  },
  {
    id: 101,
    title: "White Castle Debuts Sliderverse Generative Art NFT Collection",
    titleEn: "White Castle Debuts Sliderverse Generative Art NFT Collection",
    excerpt: "美國便利商店產業媒體 CStore Decisions 報導漢堡連鎖 White Castle 慶祝百年，與 Doodle Labs 推出 5,001 件生成藝術 NFT《Sliderverse》，由數位媒體藝術家吳哲宇創作，12 月 17 日中午開賣。文中提到他以 Sail-o-Bots 系列聞名。",
    excerptEn: "CStore Decisions, a US convenience-store trade publication, reports that White Castle marked its 100th birthday with Doodle Labs by releasing Sliderverse, 5,001 generative art NFTs created by digital media artist Che-Yu Wu, going on sale at noon on 17 December; it notes he is known for the Sail-o-Bots collection.",
    date: "2021/12/17",
    url: "https://cstoredecisions.com/2021/12/17/white-castle-debuts-sliderverse-generative-art-nft-collection/",
    source: "CStore Decisions｜Thomas Mulloy",
    sourceEn: "CStore Decisions · Thomas Mulloy",
    category: "press",
  },
  {
    id: 100,
    title: "White Castle to release NFTs",
    titleEn: "White Castle to release NFTs",
    excerpt: "美國餐飲業媒體 QSR Web 依新聞稿報導，White Castle 與 Doodle Labs 推出 Che-Yu Wu 創作的 5,001 件生成藝術 NFT，12 月 17 日發售，是 Art Blocks 生成鑄造技術的第一個品牌合作，部分收益撥給員工救助與獎學金基金。",
    excerptEn: "Citing a press release, the US restaurant-trade site QSR Web reports that White Castle and Doodle Labs will release a collection of 5,001 generative art NFTs by Che-Yu Wu on 17 December, the first brand partnership powered by Art Blocks' generative minting technology, with part of the proceeds going to relief and scholarship funds for staff.",
    date: "2021/12/16",
    url: "https://www.qsrweb.com/news/white-castle-to-release-nfts/",
    source: "QSR Web",
    sourceEn: "QSR Web",
    category: "press",
  },
  {
    id: 99,
    title: "用程式碼畫畫，來自台灣的他靠 NFT 賺進 1.6 億新台幣",
    titleEn: "Painting with Code: A Taiwanese Artist Earns NT$160 Million from NFTs",
    excerpt: "科技報橘寫吳哲宇的 NFT 企劃總值約 1,300 顆以太幣、約合新台幣 1 億 6000 萬元，新作《Electriz》12 月 8 日在 Art Blocks 發售 900 張。文中也介紹生成式藝術與 Art Blocks，提到他 2020 年 5 月在 Hahow 開設互動藝術程式課。",
    excerptEn: "TechOrange reports that Che-Yu Wu's NFT projects are worth about 1,300 ETH, roughly NT$160 million, and that his new work Electriz went on sale on Art Blocks on 8 December in an edition of 900. The piece also explains generative art and Art Blocks, and notes the creative coding course he opened on Hahow in May 2020.",
    date: "2021/12/15",
    url: "https://techorange.com/2021/12/15/cheyuwu-nft/",
    source: "TechOrange 科技報橘｜Anice H.",
    sourceEn: "TechOrange · Anice H.",
    category: "press",
  },
  {
    id: 98,
    title: "NFT故事集：用程式碼畫畫賣出一億元的台灣人",
    titleEn: "NFT Stories: The Taiwanese Who Sold NT$100 Million Painting with Code",
    excerpt: "豆泥在 Matters 寫認識十多年的吳哲宇，從宏碁動畫創作獎、Hahow 課程寫到紐約求學的低潮。Art Blocks 上的海火腿 Sea Hams 被查出抄自他的 Strange Robots，社群把版稅轉給他，他成了「火腿之父」。文末寫兩人新成立的 FAB DAO。",
    excerptEn: "Writing on Matters, a friend of more than ten years profiles Che-Yu Wu, from the Acer animation awards and his Hahow courses to a hard stretch in New York. When Sea Hams on Art Blocks turned out to be copied from his Strange Robots, the community passed the royalties to him and he became the 'father of the hams'. The piece ends with FAB DAO, which the two have just founded.",
    date: "2021/12/05",
    url: "https://matters.town/a/hj9sjg295csi",
    source: "Matters｜豆泥",
    sourceEn: "Matters · 豆泥 (MashBean)",
    category: "press",
  },
  {
    id: 97,
    title: "Why Hams?",
    titleEn: "Why Hams?",
    excerpt: "Art Blocks 社群部落格 Floors Cafe 回顧 Sail-o-bots（綽號「火腿」）的來歷：2021 年 7 月 19 日社群發現它的程式碼抄自吳哲宇的 Strange Robots，仲裁後把過去與未來的版稅判給他，藏家與藝術家隨後買進火腿、轉送給他。",
    excerptEn: "Floors Cafe, an Art Blocks community blog, recounts the story of the Sail-o-bots, nicknamed 'hams': on 19 July 2021 the community learned their code had been ripped from Che-Yu Wu's Strange Robots, arbitration awarded him past and future royalties, and collectors and artists then bought hams and sent them to him.",
    date: "2021/08/01",
    url: "https://web.archive.org/web/20220116105704/https://blog.floors.cafe/why-hams/",
    source: "Floors Cafe｜gabep",
    sourceEn: "Floors Cafe · gabep",
    category: "press",
  },
  {
    id: 96,
    title: "EP26 - 程式語言與互動設計的火花（ 新媒體藝術家 - 吳哲宇 / 墨雨設計 ）",
    titleEn: "EP26: The Spark Between Programming and Interaction Design (New Media Artist Che-Yu Wu / Monoame Design)",
    excerpt: "自由接案 Podcast《不停》第 26 集在方格子的文字版。剛從紐約大學研究所畢業的吳哲宇，談小學用 Flash 做動畫、靠自學接下第一個網頁案、大三成立墨雨設計，以及有了兩門線上課程後，想發展自己的產品。",
    excerptEn: "The text page on Vocus for episode 26 of Bu Tin, a podcast about freelance life. Having just finished graduate school at NYU, Che-Yu Wu talks about making Flash animations in primary school, taking on his first website job on self-taught skills, founding Monoame Design in his third year, and wanting to build products of his own once his two online courses gave him a steady income.",
    date: "2020/07/04",
    url: "https://vocus.cc/article/5eff6ec2fd89780001c5a1ab",
    source: "方格子｜不停 Bu Tin",
    sourceEn: "Vocus · Bu Tin Podcast",
    category: "interview",
  },
  {
    id: 95,
    title: "EP26 - 程式語言與互動設計的火花（ 新媒體藝術家 - 吳哲宇 / 墨雨設計 ）",
    titleEn: "EP26 - Sparks Between Programming and Interaction Design (New Media Artist Che-Yu Wu / Monoame Design)",
    excerpt: "自由接案 Podcast《不停》EP26 的官網單集頁。摘要寫吳哲宇剛從紐約大學研究所畢業，經營墨雨設計，案子多半是人傳人介紹而來，大三成立工作室，兩門線上課程帶來穩定收入，接下來想發展自己的產品。",
    excerptEn: "The episode page for EP26 of Butin, a podcast about freelancing, on the show's website. The summary says Che-Yu Wu has just finished graduate school at NYU and runs Monoame Design, with most projects coming through referrals. He set up the studio in his third year of university, two online courses give him a steady income, and he now wants to build products of his own.",
    date: "2020/06/29",
    url: "https://www.butin.co/episode/s2ep26",
    source: "不停 Butin｜呂罰（主持）",
    sourceEn: "Butin Podcast · Hosted by 呂罰",
    category: "interview",
  },
  {
    id: 94,
    title: "用一點固執和無限新奇，開啟這場程式大冒險！——吳哲宇",
    titleEn: "With a Little Stubbornness and Endless Curiosity, the Coding Adventure Begins: Che-Yu Wu",
    excerpt: "Hahow 好學校部落格越洋電話訪問在紐約的吳哲宇。他從第一門網頁入門課，談到因 YouTube 頻道「老闆，來點寇汀吧」觀眾被數學卡住而開的特效課，再到在 NYU 當 Creative Coding 助教一年半後開的第三門課《互動藝術程式創作入門》。",
    excerptEn: "The Hahow blog calls Che-Yu Wu in New York. He traces his courses from the first introduction to web programming, through an effects course prompted by viewers of his YouTube channel getting stuck on the maths, to a third course, Introduction to Interactive Art Coding, launched after a year and a half as a Creative Coding teaching assistant at NYU.",
    date: "2020/04/27",
    url: "https://web.archive.org/web/20211026171742/https://blog.hahow.in/teacher-interview-creative-coding/",
    source: "Hahow 好學校 Blog｜Ani Syu（採訪撰稿）",
    sourceEn: "Hahow Blog · Interview and text by Ani Syu",
    category: "interview",
  },
  {
    id: 93,
    title: "大學倒光光，為什麼它吸引6萬學生？",
    titleEn: "As Universities Close, Why Does This Platform Draw 60,000 Students?",
    excerpt: "天下雜誌寫線上學習平台 Hahow 好學校，開課老師名單裡有「網頁設計界大神吳哲宇」。文中寫他交大電機系二年級就在 Hahow 開課，第一門課已有超過 4,000 人修讀，一段課常重錄四、五遍，也靠開課賺到赴美念書的學費。",
    excerptEn: "CommonWealth Magazine profiles the online learning platform Hahow, whose teachers include 'web design guru Che-Yu Wu'. It notes he began teaching on Hahow in his second year of electrical engineering at NCTU, that his first course had passed 4,000 students, that he often re-recorded a lesson four or five times, and that teaching paid for his studies in the US.",
    date: "2018/06/24",
    url: "https://www.cw.com.tw/article/5090677",
    source: "天下雜誌｜程晏鈴",
    sourceEn: "CommonWealth Magazine · 程晏鈴",
    category: "press",
  },
  {
    id: 92,
    title: "用 50 個小時，與 4,300 位同學一起「自己動畫互動網頁自己做」",
    titleEn: "Fifty Hours with 4,300 Classmates: Making Your Own Animated Interactive Web Pages",
    excerpt: "群眾觀點刊出郭丞哲的投稿，寫吳哲宇在 Hahow 的兩門動畫互動網頁課：第一門帶近 3,000 位同學，第二門集資上線一天湧入 500 人、不到一個月超過 1,300 人報名。文中也寫到他從視覺動畫切入，讓初學者先有成就感的課程設計。",
    excerptEn: "CrowdWatch runs a contributed piece on Che-Yu Wu's two animated interactive web courses on Hahow: the first taught nearly 3,000 students, and the crowdfunding for the second drew 500 backers on its first day and more than 1,300 sign-ups within a month. It also describes how his courses start from visual animation so beginners get a sense of achievement first.",
    date: "2017/06/13",
    url: "https://crowdwatch.tw/post/2735/",
    source: "群眾觀點｜郭丞哲",
    sourceEn: "CrowdWatch · 郭丞哲",
    category: "press",
  },
  {
    id: 91,
    title: "為何台灣人總要等「準備好了」才敢行動？或許我們從小教育就少了這一種態度......",
    titleEn: "Why Do Taiwanese Always Wait Until They Are \"Ready\" to Act? Perhaps Our Schooling Left Out This One Attitude...",
    excerpt: "Hahow 好學校在風傳媒發表「Hahow 好學校之夜」活動回顧，四位講者之一是當時就讀交大電機系四年級、創辦墨雨設計的吳哲宇。他說亞洲教育常要人先把事情做好、以後才能賺大錢，卻很少讓人想清楚自己喜歡還是討厭這件事。",
    excerptEn: "Hahow publishes its recap of Hahow School Night on The Storm Media. One of the four speakers is Che-Yu Wu, then a fourth-year electrical engineering student at NCTU and founder of Monoame Design. He says Asian schooling tells people to do a thing well so they can earn money later, yet rarely lets them work out whether they like or dislike it.",
    date: "2017/05/04",
    url: "https://www.storm.mg/lifestyle/251519",
    source: "風傳媒 風生活｜Hahow好學校",
    sourceEn: "The Storm Media (Lifestyle) · Hahow",
    category: "press",
  },
  {
    id: 90,
    title: "專訪吳哲宇：人生沒有完全準備好的時候，唯有不停進化才能騰空翱翔",
    titleEn: "Interview with Che-Yu Wu: You Are Never Fully Ready, Only by Evolving Can You Take Flight",
    excerpt: "Hahow 好學校部落格專訪還在讀大學的吳哲宇，他是墨雨設計創辦人，也是「動畫互動網頁入門」的老師，原本預計 300 分鐘的課最後錄成 1,700 多分鐘。他談大一才開始自學設計、把目標插在遠處逼自己進化，學到一個階段就不藏私分享。",
    excerptEn: "The Hahow blog interviews Che-Yu Wu while he is still at university: founder of Monoame Design and teacher of the Animated Interactive Web course, which was planned at 300 minutes and ended up running past 1,700. He talks about teaching himself design only from his first year, planting goals far ahead to force himself to evolve, and sharing everything once he reaches a new stage.",
    date: "2017/03/14",
    url: "https://web.archive.org/web/20220704085930/https://blog.hahow.in/interview-of-hahow-teacher-che-yu/",
    source: "Hahow 好學校 Blog｜黃浩珉",
    sourceEn: "Hahow Blog · 黃浩珉",
    category: "interview",
  },
  {
    id: 89,
    title: "技術宅的冬季浪漫　交大生自製動感聖誕樹",
    titleEn: "A Tech Geek's Winter Romance: NCTU Students Build a Music-Synced Christmas Tree",
    excerpt: "蘋果日報即時新聞寫交大電機系學生吳哲宇在 Dcard 發文，說他和同學用 Arduino 寫燈光控制程式、改造燈串，向系主任要來一棵 4.5 公尺高的聖誕樹，讓燈光跟著音樂閃爍。他也預告週三在圖書館前辦音樂秀。",
    excerptEn: "Apple Daily's breaking news desk reports that NCTU electrical engineering student Che-Yu Wu posted on Dcard about building a Christmas tree with classmates: they programmed the light control on an Arduino, rewired the light strings and got the department head to sponsor a 4.5-metre tree whose lights flash to music; he also announced a music show in front of the library that Wednesday.",
    date: "2014/12/22",
    url: "https://web.archive.org/web/20150115225535/http://www.appledaily.com.tw:80/realtimenews/article/fun/20141222/528393/%E6%8A%80%E8%A1%93%E5%AE%85%E7%9A%84%E5%86%AC%E5%AD%A3%E6%B5%AA%E6%BC%AB%E3%80%80%E4%BA%A4%E5%A4%A7%E7%94%9F%E8%87%AA%E8%A3%BD%E5%8B%95%E6%84%9F%E8%81%96%E8%AA%95%E6%A8%B9/",
    source: "蘋果日報｜即時新聞中心",
    sourceEn: "Apple Daily · Breaking news desk",
    category: "press",
  },
  {
    id: 88,
    title: "【為自己按讚】吳哲宇.林自均",
    titleEn: "Like Yourself: Che-Yu Wu and Lin Tzu-Chun",
    excerpt: "udn.tv 節目《為自己按讚》第一集，以「數位創作」為主題，受訪者是吳哲宇與林自均。影片全長約 25 分鐘，2013 年 10 月上傳到節目的 YouTube 頻道，說明欄只寫了集數、主題與兩人的名字。",
    excerptEn: "The first episode of the udn.tv programme Like Yourself, on the theme of digital creation, featuring Che-Yu Wu and Lin Tzu-Chun. The video runs about 25 minutes and was uploaded to the programme's YouTube channel in October 2013; its description gives only the episode number, the theme and the two names.",
    date: "2013/10/21",
    url: "https://www.youtube.com/watch?v=uWG3IgBa6-0",
    source: "udn.tv《為自己按讚》",
    sourceEn: "udn.tv, Like Yourself",
    category: "interview",
  },
  {
    id: 87,
    title: "宏碁數創獎 建中復興商工掄元",
    titleEn: "Acer Digital Creation Awards: Jianguo High School and Fu-Hsin Trade & Arts School Take the Top Prize",
    excerpt: "新唐人轉刊中央社稿：第 9 屆宏碁數位創作獎揭曉，評審團大獎由建國高中吳哲宇與復興商工陳楷中合作的動畫「Colorful Life Key」拿下，獎金新台幣 30 萬元。吳哲宇說做動畫是興趣，這次跨校合作是很棒的經驗。",
    excerptEn: "NTD reprints a CNA wire report on the 9th Acer Digital Creation Awards: the jury's grand prize of NT$300,000 went to Colorful Life Key, an animation by Che-Yu Wu of Jianguo High School and a student from Fu-Hsin Trade & Arts School. Wu said animation is his passion and working across schools was a great experience.",
    date: "2013/02/06",
    url: "https://www.ntdtv.com/b5/2013/02/06/a844245.html",
    source: "新唐人（轉載自中央社）｜羅秀文",
    sourceEn: "NTD Television (reprinted from CNA) · 羅秀文",
    category: "press",
  },
  {
    id: 86,
    title: "數位小王子吳哲宇連四年抱回宏碁獎",
    titleEn: "Digital Prince Che-Yu Wu Takes Home an Acer Award Four Years Running",
    excerpt: "聯合報「校園榮譽榜」寫建中二年級的吳哲宇從國二起連續四年參加宏碁數位創作獎、年年得獎。國二的「Computer vs. Power」和國三的「Dream Come True」都拿首獎，高一的「Touch New Future」抱回評審團超級大獎。他小學三年級開始自學 Flash 做影片。",
    excerptEn: "United Daily News' campus honour roll writes about Che-Yu Wu, a second-year student at Jianguo High School who has entered the Acer Digital Creation Awards every year since his second year of junior high and won each time. Computer vs. Power and Dream Come True both took first prize, and Touch New Future, made in his first year of high school, won the jury's grand prize. He began teaching himself Flash video in third grade.",
    date: "2012/02/15",
    url: "https://paper.udn.com/udnpaper/PIA0056/211159/web/",
    source: "聯合報｜沈育如",
    sourceEn: "United Daily News · 沈育如",
    category: "press",
  },
  {
    id: 85,
    title: "鼓勵數位創作 宏碁提供獎金150萬元",
    titleEn: "To Encourage Digital Creation, Acer Offers NT$1.5 Million in Prizes",
    excerpt: "央廣報導第八屆宏碁數位創作獎開跑記者會，寫到連續三屆拿下首獎的建國中學學生吳哲宇到場分享，投影幕播放他用上千張照片集結成的短片。他說創意來自放慢腳步，留意生活裡常被忽略的細節。",
    excerptEn: "Rti reports on the launch of the 8th Acer Digital Creation Award, where Che-Yu Wu, a Chien Kuo High School student who had won the top prize three years running, shared his work as a short film made from over a thousand photos played on screen; he said creativity comes from slowing down and noticing the overlooked details of daily life.",
    date: "2011/09/08",
    url: "https://tw.news.yahoo.com/鼓勵數位創作-宏碁提供獎金150萬元-093800165.html",
    source: "Yahoo 新聞（轉載自中央廣播電臺）｜李憶璇",
    sourceEn: "Yahoo News (from Radio Taiwan International) · 李憶璇",
    category: "press",
  },
  {
    id: 84,
    title: "【獵人名人堂】玩成夢想的獵人-吳哲宇",
    titleEn: "Hunter Hall of Fame: Che-Yu Wu, the Hunter Who Played His Way to a Dream",
    excerpt: "獎金獵人網站「獵人名人堂」的十題問答，由就讀建國中學的吳哲宇自己作答：列出三屆宏碁數位創作獎首獎等得獎紀錄，分享動畫比賽要顧好速度、驚奇與關鍵理念，也談到國二意外拿下首獎，成了他參賽的轉捩點。",
    excerptEn: "A ten-question Q&A in the Hall of Fame column of the Bonus Hunter competition site, answered by Che-Yu Wu himself while at Jianguo High School: he lists his awards, including first prizes at three editions of the Acer Digital Creation Award, says an animation entry needs good pacing, surprise and a central idea, and recalls how an unexpected first prize in his second year of junior high became a turning point.",
    date: "2011/07/24",
    url: "https://mypaper.pchome.com.tw/adc_hunter/post/1322326982",
    source: "獎金獵人（PChome 個人新聞台）",
    sourceEn: "Bonus Hunter (獎金獵人, PChome blog)",
    category: "interview",
  },
  {
    id: 83,
    title: "讓AI讀書算犯法？著作權法未鬆綁，主權AI訓練語料僅1%來自民間…台灣繁中語料庫難拓展制度哪卡關？",
    titleEn:
      "Is Letting AI Read a Crime? With Copyright Law Unchanged, Only 1% of Taiwan's Sovereign AI Corpus Comes from the Private Sector",
    excerpt:
      "今周刊追問台灣的繁中 AI 語料為什麼長不大：數發部語料庫 7,161 筆裡只有 111 筆來自民間，《著作權法》也還沒處理 AI 訓練。報導從吳哲宇發起的 Taiwan.md 寫起，這座想讓主流模型讀到台灣觀點的知識庫已收錄 1,123 篇文章，卻因為怕侵權而自我設限。",
    excerptEn:
      "Business Today asks why Taiwan's Traditional Chinese AI corpus struggles to grow: of 7,161 items in the digital ministry's corpus, only 111 come from the private sector, and copyright law has yet to address AI training. The report opens with Taiwan.md, the knowledge base Che-Yu Wu started so mainstream models can learn a Taiwanese perspective, now 1,123 articles strong but held back by fear of infringement.",
    date: "2026/10/14",
    url: "https://www.businesstoday.com.tw/article/category/183027/post/202610140002/",
    source: "今周刊｜陳子萱",
    sourceEn: "Business Today · 陳子萱",
    category: "press",
  },
  {
    id: 82,
    title: "廢棄物變藝術 科技演算看見城市碳足跡",
    titleEn:
      "Waste Turned into Art: Computation Reveals a City's Carbon Footprint",
    excerpt:
      "桃園有線新聞記者跟著環保局長走《桃園演算室》，寫到《大地與川脈的編織》把台灣 35 年的碳排資料、產業排放與桃園的減碳政策即時運算，織成一幅不斷變化的數位作品。",
    excerptEn:
      "A Taoyuan cable news reporter follows the head of the Environmental Protection Bureau through TAOYUAN RE:CODE and describes Woven Land, Woven River as 35 years of Taiwan's emission data, industrial emissions and Taoyuan's reduction policies, computed in real time into a digital work that never stops changing.",
    date: "2026/10/08",
    url: "https://www.thehubnews.net/archives/673156",
    source: "新頭條 TheHubNews｜桃園有線新聞 董雨菲",
    sourceEn: "TheHubNews · Taoyuan cable news, 董雨菲",
    category: "press",
  },
  {
    id: 81,
    title: "台灣設計展《桃園演算室》10/11將閉幕 桃園環保局推線上展間",
    titleEn:
      "TAOYUAN RE:CODE Closes on 11 October as the Taoyuan Environmental Protection Bureau Opens an Online Exhibition Room",
    excerpt:
      "閉展前，桃園市環保局宣布《桃園演算室》ARTOGO 線上展間上線，新聞稿再次寫到吳哲宇的 10 公尺環狀即時生成藝術《大地與川脈的編織》：資料化成流動的水紋與地景，觀眾在現場輸入的永續行動也成為作品演算的一部分。台灣好新聞、台灣新聞雲報等同日刊出。",
    excerptEn:
      "Ahead of the closing, the Taoyuan Environmental Protection Bureau opened an ARTOGO online exhibition room for TAOYUAN RE:CODE, and its release again described Che-Yu Wu's ten-metre ring of real-time generative art, Woven Land, Woven River: data turned into flowing ripples and landscape, with the sustainable actions visitors enter on site becoming part of the work's computation. Several other outlets ran it the same day.",
    date: "2026/10/08",
    url: "https://tyenews.com/2026/10/1415865/",
    source: "桃園電子報｜黃雅蘭 + 多家媒體",
    sourceEn: "Taoyuan News · 黃雅蘭, with other outlets",
    category: "press",
  },
  {
    id: 80,
    title: "台灣設計展倒數 《水之道》用影像與演算藝術重看日常用水",
    titleEn:
      "As the Taiwan Design Expo Counts Down, Life Around Water Looks Again at Everyday Water Through Image and Algorithmic Art",
    excerpt:
      "立報寫水之道的入口意象區由兩件作品構成：白輻射影像看整座城市的水，另一側曲面牆是吳哲宇的《Cymatics of Life》，把觀眾填寫的日常用水答案即時轉成水波曼陀羅，同步顯示在手機與曲面投影牆上，把人的生活習慣直接寫進畫面。",
    excerptEn:
      "Li Pao describes the entrance zone of Life Around Water as two works: Whitelight Motion looks at the water of a whole city, and on the other side Che-Yu Wu's Cymatics of Life turns visitors' answers about everyday water use into a Water Ripple Mandala shown at once on the phone and on the curved projection wall, writing people's habits straight into the image.",
    date: "2026/10/08",
    url: "https://www.limedia.tw/comm/74477/",
    source: "立報傳媒｜潘韜宇（綜合報導）",
    sourceEn: "Li Pao (Limedia) · 潘韜宇",
    category: "press",
  },
  {
    id: 79,
    title: "2026台灣設計展桃園「水之道」 展現水資源循環新生活",
    titleEn:
      "Life Around Water at the Taiwan Design Expo 2026 Shows Taoyuan's Water Coming Back into Use",
    excerpt:
      "閉展前三天，桃園市水務局發出水之道新聞稿，寫到展場入口以流動影像描繪水的旅程，吳哲宇的《Cymatics of Life》為每位觀眾即時生成自己的水波曼陀羅。桃園電子報、台灣好新聞同日刊出。",
    excerptEn:
      "Three days before the expo closed, the Taoyuan Department of Water Resources issued its own release on Life Around Water, describing an entrance of flowing images that trace water's journey and Che-Yu Wu's Cymatics of Life, which generates a Water Ripple Mandala live for each visitor. Taoyuan News and Taiwan Hot News ran it the same day.",
    date: "2026/10/08",
    url: "https://www.ettoday.net/news/20261008/3251649.htm",
    source: "ETtoday 新聞雲｜楊淑媛 + 多家媒體",
    sourceEn: "ETtoday · 楊淑媛, with other outlets",
    category: "press",
  },
  {
    id: 78,
    title: "2026台灣設計展《水之道 Life Around Water》登場 從水務治理到影像、聲音與演算藝術，走進桃園與水共生的日常",
    titleEn:
      "Life Around Water Opens at the Taiwan Design Expo 2026: From Water Governance to Image, Sound and Algorithmic Art",
    excerpt:
      "設計媒體黑秀網刊出樸實創意寫的水之道策展介紹，最後一段寫吳哲宇的《Cymatics of Life》：以音流學為概念，觀眾的答案化成參數與頻率，即時演算出自己的水波曼陀羅。每半小時，曲面牆展開一次定時演算展演。",
    excerptEn:
      "The design site HeyShow runs the curators' introduction to Life Around Water, whose closing section covers Che-Yu Wu's Cymatics of Life: built on the idea of cymatics, each visitor's answers become parameters and frequencies computed live into a Water Ripple Mandala of their own, and every half hour the curved screen stages a timed algorithmic performance.",
    date: "2026/10/06",
    url: "https://heyshow.com/2026/10/06/mobile51347/",
    source: "黑秀網 HeyShow｜樸實創意（策展方稿）",
    sourceEn: "HeyShow · text by the curators, Plain Design",
    category: "press",
  },
  {
    id: 77,
    title: "桃園其實很懂水！2026台灣設計展《水之道》看再生水如何變成一粒米",
    titleEn:
      "Taoyuan Knows Water: How Reclaimed Water Becomes a Grain of Rice at Life Around Water, Taiwan Design Expo 2026",
    excerpt:
      "Bella 儂儂的水之道導覽寫吳哲宇的《Cymatics of Life》：觀眾掃 QR Code 回答五道與日常用水有關的題目，答案化成參數與頻率，在手機上、也在約 12 公尺寬的曲面牆上長出自己的水波曼陀羅。每半小時，牆上跑一次約一分鐘的定時展演。",
    excerptEn:
      "Bella's guide to the Life Around Water zone describes Che-Yu Wu's Cymatics of Life: visitors scan a QR code and answer five questions about everyday water use, and the answers become parameters and frequencies that grow a Water Ripple Mandala of their own, on the phone and on a curved screen about twelve metres wide. Every half hour the wall runs a timed performance of about a minute.",
    date: "2026/10/05",
    url: "https://www.bella.tw/articles/design&gadget/60364/2026-taiwan-design-expo-life-around-water-taoyuan",
    source: "Bella 儂儂｜Stanley Kuo",
    sourceEn: "Bella · Stanley Kuo",
    category: "press",
  },
  {
    id: 76,
    title: "2026台灣設計展《水之道》 體驗一滴水的永續之旅！走進桃園與水共生的日常",
    titleEn: "Life Around Water at the Taiwan Design Expo 2026: Following a Drop of Water Through Taoyuan",
    excerpt:
      "微笑台灣「活動大聲公」刊出的水之道介紹，資料來源標桃園市政府水務局。最後一段寫吳哲宇的《Cymatics of Life》：觀眾的每一組答案化成不同的頻率，即時演算出自己的水波曼陀羅，眾人的參與匯成一片不斷變化的水之風景。",
    excerptEn:
      "Smile Taiwan's events column runs an introduction to Life Around Water, credited to the Taoyuan Department of Water Resources. Its closing section covers Che-Yu Wu's Cymatics of Life: each visitor's answers become a different frequency, computed live into a Water Ripple Mandala of their own, and everyone's participation gathers into a changing waterscape.",
    date: "2026/10/04",
    url: "https://smiletaiwan.cw.com.tw/article/9474",
    source: "微笑台灣｜桃園市政府水務局（資料來源）",
    sourceEn: "Smile Taiwan · Taoyuan Department of Water Resources (source)",
    category: "press",
  },
  {
    id: 75,
    title: "桃園演算室開展一周破萬人次「拉一下」感受日常碳排差異",
    titleEn: "TAOYUAN RE:CODE Passes Ten Thousand Visitors in Its First Week: Pull to Feel the Weight of Everyday Carbon",
    excerpt:
      "觸mii「品文化」寫 A9 桃園演算室開展一週，互動人次破萬，現場照片由姜霏拍攝。文中寫觀眾在 QR Code 輸入願意響應的永續行動，回應會即時融入吳哲宇的 10 公尺環狀即時生成藝術《大地與川脈的編織》，每一筆參與都成為作品的一部分。",
    excerptEn:
      "Truemii, the culture section of China Times, reports from TAOYUAN RE:CODE as interactions pass ten thousand in the first week. Visitors enter the sustainable actions they are willing to take through a QR code, and each response flows in real time into Che-Yu Wu's ten-metre ring of real-time generative art, Woven Land, Woven River: every contribution becomes part of the work.",
    date: "2026/10/03",
    url: "https://truemii.chinatimes.com/content/20261003001980-265008",
    source: "觸mii（中時新聞網）｜姜霏",
    sourceEn: "Truemii (China Times) · 姜霏",
    category: "press",
  },
  {
    id: 74,
    title: "走出這場展覽後，你願意刪掉什麼？｜從田野調查到數位淨零的感官轉譯 -《桃園演算室 TAOYUAN RE:CODE》策展紀實",
    titleEn:
      "After This Exhibition, What Would You Delete? From Field Research to a Sensory Translation of Digital Net Zero — Documentary on TAOYUAN RE:CODE",
    excerpt:
      "桃園市環保局頻道上傳的《桃園演算室》策展紀實。吳哲宇在片中談《大地與川脈的編織》：地形、都市跟人本身就是一種編織，碳排這麼多，織出來的圖案非常繁複、非常漂亮，讓人看見文明的繁盛，也想到背後要承擔的代價。",
    excerptEn:
      "A documentary on TAOYUAN RE:CODE released by the Taoyuan Department of Environmental Protection. Che-Yu Wu talks about Woven Land, Woven River: terrain, cities and people are already a kind of weaving, and with this much carbon the pattern woven comes out intricate and beautiful, showing a civilisation's abundance and the cost behind it.",
    date: "2026/10/02",
    url: "https://www.youtube.com/watch?v=TyaacPMO-iI",
    source: "桃園市政府環境保護局（YouTube 策展紀實）",
    sourceEn: "Taoyuan Department of Environmental Protection (YouTube documentary)",
    category: "press",
  },
  {
    id: 73,
    title: "滑手機也有碳排重量？2026台灣設計展《桃園演算室》登場：10公尺即時生成地景、廢棄尿布再生吊燈重構淨零日常",
    titleEn:
      "Does Scrolling Have a Carbon Weight? TAOYUAN RE:CODE at the Taiwan Design Expo 2026: A Ten-Metre Live-Generated Landscape and a Recycled-Diaper Chandelier",
    excerpt:
      "Dfun 雜誌「展覽現場」寫環保局 A9 桃園演算室，動態演算區一段介紹吳哲宇的即時生成藝術《大地與川脈的編織》：碳排結構、淨零政策與觀眾的減碳選擇，沿著環形螢幕演算成河川、水紋與埤塘般的地景。",
    excerptEn:
      "Dfun Magazine's exhibition report on the Environmental Protection Bureau's TAOYUAN RE:CODE pavilion; its dynamic computing section introduces Che-Yu Wu's real-time generative work Woven Land, Woven River, where emission structures, net-zero policy and visitors' choices are computed along the ring screen into a landscape of rivers, ripples and ponds.",
    date: "2026/09/28",
    url: "https://www.dfunmag.com.tw/book-595.html",
    source: "Dfun 雜誌｜Krystal C.（撰文）",
    sourceEn: "Dfun Magazine · Text by Krystal C.",
    category: "press",
  },
  {
    id: 72,
    title: "2026台灣設計展《水之道 Life Around Water》登場 從水務治理到影像、聲音與演算藝術，走進桃園與水共生的日常",
    titleEn:
      "Life Around Water Opens at the Taiwan Design Expo 2026: From Water Governance to Image, Sound and Algorithmic Art",
    excerpt:
      "桃園市政府在親子天下刊出的水務局 A10 水之道介紹，寫吳哲宇的《Cymatics of Life》：觀眾回答與水有關的問題，答案化成頻率，即時演算出自己的水波曼陀羅，投上曲面牆。每半小時，整面牆展開一次定時演算展演。",
    excerptEn:
      "An introduction to the Department of Water Resources' Life Around Water zone, placed by the Taoyuan City Government in Parenting, describing Che-Yu Wu's Cymatics of Life: visitors answer questions about water, the answers become frequencies, and each person's own Water Ripple Mandala is computed live onto the curved screen, which stages a timed algorithmic performance every half hour.",
    date: "2026/10/02",
    url: "https://www.parenting.com.tw/article/6002664",
    source: "親子天下｜桃園市政府（廣編）",
    sourceEn: "Parenting · Taoyuan City Government (sponsored)",
    category: "press",
  },
  {
    id: 71,
    title: "The Last Input 最後一次輸入：當一個世界誕生，你在場嗎？",
    titleEn: "The Last Input: When a World Is Born, Are You There?",
    excerpt:
      "文化部文化科技平台第三季專欄。以 C-LAB 臺灣聲響實驗室與 IRCAM 駐地演出《最後一次輸入》為例，談即時演算的世界、49.4 聲道立體聲場，以及讓聲音從模擬世界裡長出來的 visual audio。",
    excerptEn:
      "A third-season column on the Ministry of Culture’s cultural technology platform. Using The Last Input, a residency performance at C-LAB’s Taiwan Sound Lab with IRCAM, it looks at a world computed in real time, a 49.4-channel sound field, and visual audio: sound that grows out of a simulated world.",
    date: "2026/10/01",
    url: "https://tech.culture.tw/home/zh-tw/knowledge/154615",
    source: "文化部 文化科技平台（專欄）",
    sourceEn: "Ministry of Culture — Culture & Tech Platform (column)",
    category: "press",
  },
  {
    id: 70,
    title: "生命，是可以被數學描述的形狀——演算藝術家吳哲宇",
    titleEn: "Life Is a Shape That Can Be Described by Mathematics — Algorithmic Artist Che-Yu Wu",
    excerpt:
      "從高中寫的細胞模擬機、紐約時期的 L-System，到 Controlled Chaos、《大地與川脈的編織》與 Taiwan.md，最後回到多年前朋友問的那個問題：沒有程式以後，吳哲宇是誰？",
    excerptEn:
      "From the cell simulator he wrote in high school and the L-systems of his New York years to Controlled Chaos, Woven Land, Woven River and Taiwan.md, ending with the question a friend asked him years ago: without code, who is Che-Yu Wu?",
    date: "2026/09/25",
    url: "https://blink.tw/features/che-yu-wu/",
    source: "b.l!nk｜李姿穎（撰文）",
    sourceEn: "b.l!nk · Text by 李姿穎",
    category: "interview",
  },
  {
    id: 69,
    title: "寫程式愈來愈快，創作者反而更需要花時間讀書",
    titleEn: "As Coding Gets Faster, Artists Need More Time to Read",
    excerpt:
      "北科大曹筱玥主持的《AI練功場》第 28 集。吳哲宇從國中為了買筆電參加比賽寫程式講起，談紐約求學、台北 101 的兩次個展，從討厭 AI 講到把它放進《花的靈魂》與《瓶中的永恆花園》，最後談十月的 The Last Input。",
    excerptEn:
      "Episode 28 of AI Practicing, hosted by Tsao Hsiao-Yue of Taipei Tech. Che-Yu Wu starts with entering competitions as a teenager to earn a laptop, then talks about studying in New York, his two solo exhibitions at Taipei 101, going from disliking AI to building it into The Soul of Flowers and The Eternal Garden in a Bottle, and The Last Input in October.",
    date: "2026/09/27",
    url: "https://podcasts.apple.com/tw/podcast/id1885339893?i=1000791876713",
    source: "AI練功場 Podcast｜曹筱玥（主持）",
    sourceEn: "AI Practicing Podcast · Hosted by 曹筱玥",
    category: "interview",
  },
  {
    id: 68,
    title: "2026台灣設計展《桃園演算室》展現淨零城市想像",
    titleEn: "TAOYUAN RE:CODE at the Taiwan Design Expo 2026 Imagines a Net-Zero City",
    excerpt:
      "ETtoday 記者走訪環保局展區「桃園演算室」，在動態演算區寫到吳哲宇的即時生成藝術《大地與川脈的編織》。",
    excerptEn:
      "An ETtoday reporter visits the Environmental Protection Bureau's TAOYUAN RE:CODE pavilion and, in its dynamic computing zone, Che-Yu Wu's real-time generative work Woven Land, Woven River.",
    date: "2026/09/27",
    url: "https://www.ettoday.net/news/20260927/3244589.htm",
    source: "ETtoday 新聞雲｜楊淑媛",
    sourceEn: "ETtoday · 楊淑媛",
    category: "press",
  },
  {
    id: 67,
    title: "丟掉的尿布變吊燈？《桃園演算室》打破循環經濟想像極限",
    titleEn:
      "Used Diapers Turned into a Pendant Lamp: TAOYUAN RE:CODE Stretches What a Circular Economy Can Look Like",
    excerpt:
      "旅遊媒體台灣旅行趣介紹環保局展區「桃園演算室」，在動態演算區寫到吳哲宇的即時生成藝術《大地與川脈的編織》。",
    excerptEn:
      "The travel site ShareLife introduces the Environmental Protection Bureau's TAOYUAN RE:CODE pavilion and, in its dynamic computing zone, Che-Yu Wu's real-time generative work Woven Land, Woven River.",
    date: "2026/09/24",
    url: "https://taiwan.sharelife.tw/article_aid-40858.html",
    source: "台灣旅行趣 ShareLife",
    sourceEn: "ShareLife",
    category: "press",
  },
  {
    id: 66,
    title: "2026 台灣設計展「桃園流」9/24 登場！編輯開箱沉浸體驗、科技轉譯等 2 大主展區與衛星展區亮點",
    titleEn:
      "Taiwan Design Expo 2026 Opens: An Editor Walks Through the Two Main Zones and Satellite Venues",
    excerpt:
      "Shopping Design 編輯開箱台灣設計展，走進環保局展區「桃園演算室」時寫到《大地與川脈的編織》：一面把觀眾的選擇即時織進圖騰的牆。",
    excerptEn:
      "Shopping Design's editor walks through the Taiwan Design Expo and, in the Environmental Protection Bureau's TAOYUAN RE:CODE pavilion, describes Woven Land, Woven River as a totem wall that weaves in each visitor's choice as it happens.",
    date: "2026/09/24",
    url: "https://www.shoppingdesign.com.tw/post/view/13808",
    source: "Shopping Design｜鄭芝鈺",
    sourceEn: "Shopping Design · 鄭芝鈺",
    category: "press",
  },
  {
    id: 65,
    title: "編碼當代地景的永續實驗：2026 台灣設計展《桃園演算室》，在數據與循環材質中尋找人與環境的平衡",
    titleEn:
      "Encoding a Contemporary Landscape: TAOYUAN RE:CODE at the Taiwan Design Expo 2026, Between Data and Circular Materials",
    excerpt:
      "桃園市環保局在 MOT TIMES 明日誌發表的展區專文，以四種尺度的數據結構介紹吳哲宇的即時生成藝術《大地與川脈的編織》，附現場攝影。",
    excerptEn:
      "A feature on the TAOYUAN RE:CODE pavilion published by the Taoyuan Environmental Protection Bureau in MOT TIMES, describing the data behind Che-Yu Wu's real-time generative work Woven Land, Woven River in four scales, with photographs from the site.",
    date: "2026/09/24",
    url: "https://www.mottimes.com/article/detail/7021",
    source: "MOT TIMES 明日誌｜桃園市政府環境保護局",
    sourceEn: "MOT TIMES · Taoyuan City Government Environmental Protection Bureau",
    category: "press",
  },
  {
    id: 64,
    title: "碳排真的「有重量」！台灣設計展24組互動設施「秤」給你看",
    titleEn:
      "Carbon Really Has Weight: 24 Interactive Stations at the Taiwan Design Expo Put It on the Scale",
    excerpt:
      "台灣設計展環保局展區「桃園演算室」的報導，介紹動態演算區裡吳哲宇的即時生成藝術《大地與川脈的編織》；中華日報、點傳媒、大成報、台灣大紀元等同日刊出。",
    excerptEn:
      "A report on the Environmental Protection Bureau's TAOYUAN RE:CODE pavilion at the Taiwan Design Expo, introducing Che-Yu Wu's real-time generative work Woven Land, Woven River in its dynamic computing zone; several other Taiwanese outlets ran the story the same day.",
    date: "2026/09/23",
    url: "https://udn.com/news/story/7324/9772773",
    source: "聯合新聞網（聯合報）｜朱冠諭 + 多家媒體",
    sourceEn: "United Daily News (udn.com) · 朱冠諭, with other outlets",
    category: "press",
  },
  {
    id: 63,
    title:
      "酷，不等於被記住！AI 時代，如何創造「最有人類質感的體驗」──專訪新媒體藝術家吳哲宇",
    titleEn:
      "Cool Is Not the Same as Memorable: Creating the Most Human Experience in the AI Era — An Interview with New Media Artist Che-Yu Wu",
    excerpt:
      "當 AI 降低了創作的技術門檻，一段體驗憑什麼被記住？少一點對結果的執著，是否反而能讓作品走得更深、更遠？",
    excerptEn:
      "As AI lowers the technical barriers to creation, what makes an experience memorable? Could less attachment to outcomes allow a work to go deeper and farther?",
    date: "2026/08/21",
    url: "https://www.shoppingdesign.com.tw/post/view/13700",
    source: "Shopping Design（巨思文化）｜莊子謙（採訪·撰文）",
    sourceEn:
      "Shopping Design (Business Next Media) · Interview and article by 莊子謙",
    category: "interview",
  },
  {
    id: 62,
    thumb: "/static/img/101-photo-rex-1.jpeg",
    title: "萬物公式：程式碼能不能長出靈魂？",
    excerpt:
      "文化部文化科技平台專欄。從台北 101 個展回望機制、生命與演算法的靈魂問題。",
    date: "2026",
    url: "https://tech.culture.tw/home/zh-tw/knowledge/150699",
    source: "文化部 文化科技平台（專欄）",
    category: "press",
  },
  // Interviews & Podcasts (own voice in conversation)
  {
    id: 10,
    thumb: "/static/img/cheyuwu-2025.jpg",
    title: "AI 生成藝術的靈魂在人類",
    excerpt:
      "最完整的公開版自傳。從 FTX 崩盤到荒謬主義重生，從鐘錶匠到 AI 協作。",
    date: "2025",
    url: "https://www.inside.com.tw/feature/side-chat/39681-side-chat-e375",
    source: "INSIDE 塞掐 Side Chat E375",
    category: "interview",
    featured: true,
  },
  {
    id: 11,
    thumb: "/static/img/2023_cyw.JPG",
    title: "用演算法創造生命",
    excerpt:
      "和 Porsche 聊吳哲宇如何打破冰冷科技，用程式碼生成有溫度的數位世界。",
    date: "2024",
    url: "https://www.gq.com.tw/special/porsche-shadegreenmetallic-cheyuwu",
    source: "GQ × Porsche",
    category: "interview",
    featured: true,
  },
  {
    id: 12,
    title: "在數位世界創造永恆的生命與情感",
    thumb: "/static/img/240614 Flower of the Other Shore hor.jpg",
    excerpt: "生成式藝術是什麼？一個把程式碼當成畫筆的人的自我剖析。",
    date: "2024",
    url: "https://www.shoppingdesign.com.tw/podcast/view/138",
    source: "Shopping Design Podcast",
    category: "interview",
  },
  {
    id: 13,
    title: "純創作的 NFT 更搶手",
    thumb: "/static/img/nft_cover.jpg",
    excerpt: "為什麼不追市場、不做 PFP、堅持純藝術創作的 NFT 反而更有價值？",
    date: "2022",
    url: "https://podcasts.apple.com/podcast/id1441274280?i=1000551213155",
    source: "區塊勢 Podcast",
    category: "interview",
  },
  {
    id: 14,
    title: "程式語言與互動設計的火花",
    thumb: "/static/img/about_photo.jpg",
    excerpt: "聊自由接案、創業、從交大電機到 NYU 的跨領域冒險。",
    date: "2020",
    url: "https://www.youtube.com/watch?v=zpZiRHGDjTA",
    source: "不停 Butin Podcast",
    category: "interview",
  },
  // Press / Media coverage (third-party reporting)
  {
    id: 50,
    thumb: "/static/img/cheyuwu-2025.jpg",
    title: "Art Attack — Che-Yu Wu",
    excerpt:
      "International documentary: How a Taiwanese artist uses code to create life.",
    date: "2024",
    url: "https://www.youtube.com/watch?v=iER_eIIWs_8",
    source: "Taiwan Plus (International)",
    category: "press",
    featured: true,
  },
  {
    id: 51,
    thumb: "/static/img/101-photo-rex-3.jpeg",
    title: "科普名人堂 — 藝術與數學有關係嗎？",
    excerpt: "用數學和程式碼創造藝術：從碎形到粒子系統的美學探索。",
    date: "2024",
    url: "https://www.youtube.com/watch?v=ru0K60k4L9M",
    source: "TV — 科普名人堂",
    category: "press",
  },
  {
    id: 52,
    title: "陽明交大 1000 天",
    thumb: "/static/img/cheyuwu-2025.jpg",
    excerpt: "紀錄片：從學生到助理教授，在交大的創作與教學之路。",
    date: "2024",
    url: "https://youtu.be/52-a0o2thDw?si=97G8sLc8dHN4Yfol&t=232",
    source: "NYCU Documentary",
    category: "press",
  },
  {
    id: 53,
    title: "Algorithmic Bliss",
    thumb: "/static/img/200609 Casuality HD 1 signed-min.jpeg",
    excerpt: "Feature story on generative art practice and philosophy.",
    date: "2022",
    url: "https://neocha.com/magazine/algorithmic-bliss/",
    source: "Neocha Magazine",
    category: "press",
  },
  {
    id: 54,
    title: "闖進紐約的台灣之光",
    thumb: "/static/img/cheyuwu2024.jpg",
    excerpt: "從交大電機到 NYU 新媒體藝術，一個台灣工程師的跨領域轉型。",
    date: "2020",
    url: "https://www.gvm.com.tw/article/85552",
    source: "遠見雜誌",
    category: "press",
  },
  {
    id: 55,
    title: "吳哲宇 用程式創作永恆藝術",
    thumb: "/static/img/cheyuwu-2025.jpg",
    excerpt: "國語日報專訪：讓程式碼變成畫筆的藝術家。",
    date: "2024",
    url: "https://www.mdnkids.com/content.asp?Link_String_=22CL00000TQLVQM",
    source: "國語日報",
    category: "press",
  },
  {
    id: 56,
    title: "NFT 臺灣之光 ft. 吳哲宇",
    thumb: "/static/img/nft_cover.jpg",
    excerpt: "從生成藝術到 NFT 的創作之路，為什麼台灣藝術家能在國際發光。",
    date: "2023",
    url: "https://podcasts.apple.com/tw/podcast/ep112/id1527976064?i=1000642875351",
    source: "轉吧！創夢大叔 Podcast",
    category: "press",
  },
  {
    id: 57,
    thumb: "/static/img/101-photo-rex-2.jpeg",
    title: "萬物公式個展 — 台北101",
    excerpt:
      "全球最大 p5.js 生成藝術展覽：中央社、經濟日報、自由時報等聯合報導。",
    date: "2023",
    url: "https://www.cna.com.tw/news/acul/202310020281.aspx",
    source: "中央社 + 多家媒體",
    category: "press",
  },
  {
    id: 58,
    thumb:
      "https://s3.ap-northeast-1.amazonaws.com/strapi-files.monolab.world/prd/large_soulfish_ca9e2ba6f6.gif",
    title: "靈魂魚 × 宜蘭映像節",
    excerpt: "ELLE、美麗佳人、Vogue 聯合報導：數位生命的集體智慧。",
    date: "2023",
    url: "https://www.elle.com/tw/life/style/g46220181/",
    source: "ELLE / Marie Claire / Vogue",
    category: "press",
  },
  {
    id: 59,
    title: "Art Blocks — After Dinner Mints Ep29",
    thumb: "/static/img/nft_cover.jpg",
    excerpt:
      "English interview: Generative art philosophy, Electriz, and the Art Blocks ecosystem.",
    date: "2022",
    url: "https://www.youtube.com/watch?v=Qtj_AEq2j9M",
    source: "Art Blocks",
    category: "press",
  },
  {
    id: 60,
    title: "akaRadio EP18 — 生成式藝術創作特輯",
    thumb: "/static/img/about_photo.jpg",
    excerpt: "什麼是生成藝術？演算法如何成為創作的語言。",
    date: "2024",
    url: "https://podcasts.apple.com/tw/podcast/akaradio-ep18/id1710082021?i=1000652132320",
    source: "akaRadio Podcast",
    category: "press",
  },
  {
    id: 61,
    thumb: "/static/img/240614 Flower of the Other Shore hor.jpg",
    title: "LG × 永恆花境 科技藝術聯名",
    excerpt: "LG 官方合作：OLED 技術與生成藝術的跨界展覽。",
    date: "2025",
    url: "https://tech.udn.com/tech/story/123152/8847847",
    source: "UDN / Yahoo / 台灣英文新聞",
    category: "press",
  },
];

export const presentation = {
  277: { format: "article", kind: "institution", publisher: "PR Newswire", language: "en" },
  276: { format: "article", kind: "reporting", publisher: "聯合新聞網 UDN" },
  275: { format: "article", kind: "institution", publisher: "桃園市政府環境保護局" },
  274: { format: "article", kind: "reporting", publisher: "墨新聞 MORE News" },
  273: { format: "article", kind: "reporting", publisher: "台灣好新聞" },
  272: { format: "article", kind: "reporting", publisher: "台灣好新聞" },
  271: { format: "article", kind: "reporting", publisher: "桃園電子報" },
  270: { format: "article", kind: "institution", publisher: "HereNow" },
  269: { format: "article", kind: "institution", publisher: "DIO" },
  268: { format: "article", kind: "reporting", publisher: "b.l!nk" },
  267: { format: "article", kind: "reporting", publisher: "桃園電子報" },
  266: { format: "article", kind: "reporting", publisher: "Yahoo 新聞" },
  265: { format: "article", kind: "reporting", publisher: "台灣大紀元" },
  264: { format: "article", kind: "reporting", publisher: "民生電子報" },
  263: { format: "article", kind: "reporting", publisher: "大成報" },
  262: { format: "article", kind: "reporting", publisher: "點傳媒 NEWS586" },
  261: { format: "article", kind: "reporting", publisher: "台灣新聞雲報" },
  260: { format: "article", kind: "reporting", publisher: "中華日報" },
  259: { format: "article", kind: "institution", publisher: "桃園市政府環境保護局" },
  258: { format: "article", kind: "reporting", publisher: "Openbook 閱讀誌" },
  257: { format: "article", kind: "institution", publisher: "生成式 AI 年會" },
  256: { format: "article", kind: "reporting", publisher: "聯合新聞網 UDN" },
  255: { format: "article", kind: "interview", publisher: "未來城市＠天下" },
  254: { format: "article", kind: "reporting", publisher: "聯合新聞網 UDN" },
  253: { format: "article", kind: "institution", publisher: "Shopping Design" },
  252: { format: "article", kind: "reporting", publisher: "聯合新聞網 UDN" },
  251: { format: "audio", additionalFormats: ["film"], kind: "interview", publisher: "雜學校" },
  250: { format: "audio", kind: "interview", publisher: "寶博朋友說" },
  249: { format: "audio", additionalFormats: ["film"], kind: "interview", publisher: "寶島聯播網" },
  248: { format: "article", kind: "reporting", publisher: "中央社 CNA" },
  247: { format: "article", kind: "reporting", publisher: "自由時報" },
  246: { format: "article", kind: "reporting", publisher: "Yahoo 新聞" },
  245: { format: "article", kind: "reporting", publisher: "聯合新聞網 UDN" },
  244: { format: "article", kind: "reporting", publisher: "自由時報" },
  243: { format: "audio", kind: "interview", publisher: "寶博朋友說" },
  242: { format: "article", kind: "reporting", publisher: "經濟日報" },
  241: { format: "article", kind: "reporting", publisher: "聯合新聞網 UDN" },
  240: { format: "article", kind: "reporting", publisher: "中央社 CNA" },
  239: { format: "article", kind: "reporting", publisher: "聯合新聞網 UDN" },
  238: { format: "article", kind: "reporting", publisher: "聯合新聞網 UDN" },
  237: { format: "article", kind: "reporting", publisher: "自由時報" },
  236: { format: "article", kind: "reporting", publisher: "聯合新聞網 UDN" },
  235: { format: "article", kind: "reporting", publisher: "公視+" },
  234: { format: "article", kind: "reporting", publisher: "科學人" },
  233: { format: "article", kind: "reporting", publisher: "Lingua Sinica" },
  232: { format: "article", kind: "reporting", publisher: "FTNN 新聞網" },
  231: { format: "article", kind: "reporting", publisher: "中央社 CNA" },
  230: { format: "article", kind: "reporting", publisher: "中央社 CNA" },
  229: { format: "article", kind: "column", publisher: "上報" },
  228: { format: "article", kind: "reporting", publisher: "INSIDE" },
  227: { format: "article", kind: "reporting", publisher: "自由時報" },
  226: { format: "article", kind: "institution", publisher: "遠見雜誌" },
  225: { format: "film", kind: "interview", publisher: "人間衛視" },
  224: { format: "article", kind: "institution", publisher: "國立中山大學" },
  223: { format: "article", kind: "reporting", publisher: "INSIDE" },
  222: { format: "article", kind: "reporting", publisher: "蕃新聞" },
  221: { format: "film", additionalFormats: ["article"], kind: "reporting", publisher: "三立新聞網" },
  220: { format: "article", kind: "institution", publisher: "微笑台灣" },
  219: { format: "article", kind: "reporting", publisher: "Coffee Geography", language: "en" },
  218: { format: "article", kind: "reporting", publisher: "Shopping Design" },
  217: { format: "article", kind: "institution", publisher: "Starbucks Stories Asia" },
  216: { format: "article", kind: "reporting", publisher: "玩美Daily" },
  215: { format: "article", kind: "reporting", publisher: "TRAVELER Luxe 旅人誌" },
  214: { format: "article", kind: "reporting", publisher: "今周刊 Business Today" },
  213: { format: "article", kind: "reporting", publisher: "台灣英文新聞" },
  212: { format: "article", kind: "reporting", publisher: "Tatler Asia" },
  211: { format: "article", kind: "reporting", publisher: "Yahoo 新聞" },
  210: { format: "article", kind: "reporting", publisher: "台灣英文新聞" },
  209: { format: "article", kind: "reporting", publisher: "太報" },
  208: { format: "article", kind: "reporting", publisher: "House Voice" },
  207: { format: "audio", kind: "interview", publisher: "這題我不會" },
  206: { format: "article", kind: "institution", publisher: "JazzNews" },
  205: { format: "article", kind: "reporting", publisher: "台灣英文新聞" },
  204: { format: "article", kind: "institution", publisher: "LG 台灣" },
  203: { format: "film", kind: "institution", publisher: "TAxT 桃園科技藝術節" },
  202: { format: "article", kind: "reporting", publisher: "動區動趨" },
  201: { format: "article", kind: "institution", publisher: "公共電視" },
  200: { format: "article", kind: "institution", publisher: "經濟日報" },
  199: { format: "film", kind: "reporting", publisher: "TaiwanPlus", language: "en" },
  198: { format: "article", kind: "institution", publisher: "公視之友" },
  197: { format: "audio", additionalFormats: ["film"], kind: "interview", publisher: "轉吧！創夢大叔" },
  196: { format: "audio", additionalFormats: ["film"], kind: "reporting", publisher: "區塊勢" },
  195: { format: "audio", additionalFormats: ["film"], kind: "interview", publisher: "區塊勢" },
  194: { format: "article", kind: "reporting", publisher: "上報 Up Media" },
  193: { format: "article", kind: "reporting", publisher: "動區動趨 BlockTempo" },
  192: { format: "article", kind: "reporting", publisher: "Art-Tech Talks" },
  191: { format: "article", kind: "reporting", publisher: "ETtoday 旅遊雲" },
  190: { format: "article", kind: "reporting", publisher: "美麗佳人 Marie Claire" },
  189: { format: "article", kind: "reporting", publisher: "LINE TODAY" },
  188: { format: "article", kind: "reporting", publisher: "Vogue Taiwan" },
  187: { format: "article", kind: "institution", publisher: "中央社 好生活" },
  186: { format: "article", kind: "reporting", publisher: "Yahoo 奇摩新聞" },
  185: { format: "article", kind: "reporting", publisher: "工商時報" },
  184: { format: "article", kind: "reporting", publisher: "Shopping Design" },
  183: { format: "article", kind: "institution", publisher: "Shopping Design" },
  182: { format: "film", kind: "reporting", publisher: "Formosa English News", language: "en" },
  181: { format: "article", kind: "reporting", publisher: "動區動趨 BlockTempo" },
  180: { format: "article", kind: "reporting", publisher: "Taiwan News", language: "en" },
  179: { format: "article", kind: "reporting", publisher: "自由時報" },
  178: { format: "article", kind: "reporting", publisher: "華視新聞網" },
  177: { format: "film", kind: "reporting", publisher: "新唐人亞太台" },
  176: { format: "article", kind: "reporting", publisher: "人間福報" },
  175: { format: "article", kind: "reporting", publisher: "經濟日報" },
  174: { format: "article", kind: "institution", publisher: "星光娛樂流行網" },
  173: { format: "article", kind: "institution", publisher: "Porsche Taiwan" },
  172: { format: "article", kind: "reporting", publisher: "自由時報" },
  171: { format: "article", kind: "reporting", publisher: "中央社 CNA" },
  170: { format: "article", kind: "institution", publisher: "Unit London", language: "en" },
  169: { format: "article", kind: "reporting", publisher: "自由時報" },
  168: { format: "article", kind: "interview", publisher: "Tatler Asia" },
  167: { format: "article", kind: "institution", publisher: "NFT 網路新聞" },
  166: { format: "article", additionalFormats: ["film"], kind: "reporting", publisher: "數位時代" },
  165: { format: "article", kind: "reporting", publisher: "數位時代" },
  164: { format: "article", kind: "interview", publisher: "FOUNDO", language: "en" },
  163: { format: "article", kind: "reporting", publisher: "中央社 CNA" },
  162: { format: "article", kind: "reporting", publisher: "動區動趨" },
  161: { format: "article", kind: "interview", publisher: "Unit London" },
  160: { format: "audio", kind: "reporting", publisher: "ARTbience 藝術環境音" },
  159: { format: "article", kind: "reporting", publisher: "中央社 CNA" },
  158: { format: "article", kind: "institution", publisher: "INSIDE" },
  157: { format: "article", kind: "reporting", publisher: "自由時報" },
  156: { format: "article", kind: "institution", publisher: "中央社訊息平台" },
  155: { format: "article", kind: "reporting", publisher: "自由時報" },
  154: { format: "article", kind: "institution", publisher: "INSIDE" },
  153: { format: "article", kind: "reporting", publisher: "NOWnews 今日新聞" },
  152: { format: "article", kind: "institution", publisher: "VERSE" },
  151: { format: "audio", additionalFormats: ["article"], kind: "interview", publisher: "Unit London", language: "en" },
  150: { format: "article", kind: "reporting", publisher: "典藏ARTouch" },
  149: { format: "article", kind: "institution", publisher: "Contemporary Art Curator Magazine" },
  148: { format: "article", kind: "reporting", publisher: "數位荒原" },
  147: { format: "article", kind: "reporting", publisher: "Matters" },
  146: { format: "article", kind: "reporting", publisher: "方格子 vocus" },
  145: { format: "article", kind: "institution", publisher: "文化內容策進院 TAICCA" },
  144: { format: "article", kind: "reporting", publisher: "自由時報" },
  143: { format: "article", kind: "reporting", publisher: "央廣 Rti" },
  142: { format: "article", kind: "institution", publisher: "Ars Electronica", language: "en" },
  141: { format: "article", kind: "reporting", publisher: "Matters" },
  140: { format: "article", kind: "reporting", publisher: "nft now", language: "en" },
  139: { format: "article", kind: "reporting", publisher: "鏈新聞 ABMedia" },
  138: { format: "article", kind: "reporting", publisher: "自由時報" },
  137: { format: "article", kind: "reporting", publisher: "中央社 CNA" },
  136: { format: "article", kind: "reporting", publisher: "經濟日報" },
  135: { format: "article", kind: "reporting", publisher: "500輯" },
  134: { format: "article", kind: "reporting", publisher: "Taiwan News", language: "en" },
  133: { format: "article", kind: "reporting", publisher: "自由時報" },
  132: { format: "film", kind: "reporting", publisher: "Rti 中央廣播電臺" },
  131: { format: "article", kind: "reporting", publisher: "央廣 Rti" },
  130: { format: "article", kind: "reporting", publisher: "Yahoo 新聞" },
  129: { format: "article", kind: "reporting", publisher: "中央社 CNA" },
  128: { format: "article", kind: "reporting", publisher: "人間福報" },
  127: { format: "article", kind: "reporting", publisher: "自由時報" },
  126: { format: "article", kind: "reporting", publisher: "ETtoday 財經雲" },
  125: { format: "article", kind: "reporting", publisher: "聯合新聞網 UDN" },
  124: { format: "article", kind: "interview", publisher: "ELLE" },
  123: { format: "article", kind: "interview", publisher: "交大友聲" },
  122: { format: "article", kind: "reporting", publisher: "Cheers 快樂工作人" },
  121: { format: "article", kind: "interview", publisher: "今周刊 Business Today" },
  120: { format: "article", kind: "interview", publisher: "天下雜誌" },
  119: { format: "article", kind: "interview", publisher: "ITSLIQUID", language: "en" },
  118: { format: "article", kind: "reporting", publisher: "NOWnews 今日新聞" },
  117: { format: "article", kind: "reporting", publisher: "中時新聞網" },
  116: { format: "article", kind: "reporting", publisher: "中央社 CNA" },
  115: { format: "article", kind: "reporting", publisher: "Preface" },
  114: { format: "article", kind: "institution", publisher: "智榮基金會" },
  113: { format: "article", kind: "reporting", publisher: "民眾網" },
  112: { format: "article", kind: "reporting", publisher: "自由時報" },
  111: { format: "article", kind: "reporting", publisher: "理財周刊" },
  110: { format: "article", kind: "reporting", publisher: "蘋果日報" },
  109: { format: "article", kind: "reporting", publisher: "中時新聞網" },
  108: { format: "article", kind: "reporting", publisher: "聯合新聞網 UDN" },
  107: { format: "article", kind: "reporting", publisher: "500輯" },
  106: { format: "article", kind: "reporting", publisher: "Yahoo 奇摩新聞" },
  105: { format: "article", kind: "reporting", publisher: "Fox Business" },
  104: { format: "article", kind: "reporting", publisher: "Mashed", language: "en" },
  103: { format: "audio", additionalFormats: ["film"], kind: "interview", publisher: "The Daily Bone Podcast", language: "en" },
  102: { format: "article", kind: "institution", publisher: "Food Market", language: "en" },
  101: { format: "article", kind: "reporting", publisher: "CStore Decisions" },
  100: { format: "article", kind: "reporting", publisher: "QSR Web", language: "en" },
  99: { format: "article", kind: "reporting", publisher: "TechOrange 科技報橘" },
  98: { format: "article", kind: "reporting", publisher: "Matters" },
  97: { format: "article", kind: "reporting", publisher: "Floors Cafe" },
  96: { format: "article", additionalFormats: ["audio"], kind: "interview", publisher: "不停 Bu Tin" },
  95: { format: "audio", kind: "interview", publisher: "不停 Butin" },
  94: { format: "article", kind: "interview", publisher: "Hahow 好學校" },
  93: { format: "article", kind: "reporting", publisher: "天下雜誌" },
  92: { format: "article", kind: "reporting", publisher: "群眾觀點" },
  91: { format: "article", kind: "institution", publisher: "風傳媒" },
  90: { format: "article", kind: "interview", publisher: "Hahow 好學校" },
  89: { format: "article", kind: "reporting", publisher: "蘋果日報" },
  88: { format: "film", kind: "interview", publisher: "udn.tv" },
  87: { format: "article", kind: "reporting", publisher: "新唐人" },
  86: { format: "article", kind: "reporting", publisher: "聯合報" },
  85: { format: "article", kind: "reporting", publisher: "中央廣播電臺 Rti" },
  84: { format: "article", kind: "interview", publisher: "獎金獵人" },
  10: { format: "article", additionalFormats: ["film"], kind: "interview" },
  11: { format: "article", kind: "collaboration" },
  12: { format: "audio", kind: "interview" },
  13: { format: "audio", kind: "interview" },
  14: { format: "audio", kind: "interview" },
  50: { format: "film", kind: "reporting", language: "en" },
  51: { format: "film", kind: "interview" },
  52: { format: "film", kind: "institution", displayExcerpt: { zh: "陽明交大官方紀錄片，包含吳哲宇的創作與教學分享。" } },
  53: { format: "article", kind: "interview", language: "bilingual" },
  56: { format: "audio", kind: "interview" },
  59: { format: "film", kind: "interview", language: "en" }, // 縮圖：2026-10-01 起全站走 press-thumbs.mjs（該集 YouTube 縮圖）
  60: { format: "audio", kind: "interview" },
  57: {
    publisher: "中央社 CNA",
    displayExcerpt: {
      zh: "中央社報導吳哲宇在台北 101 的《萬物公式》展覽。",
      en: "CNA reports on Che-Yu Wu’s The Great Equation exhibition at Taipei 101.",
    },
  },
  58: {
    publisher: "ELLE",
    displayExcerpt: {
      zh: "ELLE 介紹宜蘭映像節及展出作品《靈魂魚》。",
      en: "ELLE introduces the Yilan festival and the exhibited work SoulFish.",
    },
  },
  61: {
    publisher: "UDN",
    displayTitle: {
      zh: "LG 透明 OLED 與互動藝術",
      en: "LG Transparent OLED and Interactive Art",
    },
    displayExcerpt: {
      zh: "UDN 報導 LG 透明 OLED 與吳哲宇作品的合作。",
      en: "UDN reports on the collaboration between LG transparent OLED and Che-Yu Wu’s work.",
    },
  },
  62: { format: "article", kind: "column" },
  64: { format: "article", kind: "reporting", publisher: "聯合新聞網 UDN" },
  65: { format: "article", kind: "institution", publisher: "MOT TIMES 明日誌" },
  66: { format: "article", kind: "reporting", publisher: "Shopping Design" },
  67: { format: "article", kind: "reporting", publisher: "台灣旅行趣 ShareLife" },
  68: { format: "article", kind: "reporting", publisher: "ETtoday 新聞雲" },
  69: { format: "audio", additionalFormats: ["film"], kind: "interview", publisher: "AI練功場" },
  70: { format: "article", kind: "interview", publisher: "b.l!nk" },
  71: { format: "article", kind: "column" },
  72: { format: "article", kind: "institution", publisher: "親子天下" },
  73: { format: "article", kind: "reporting", publisher: "Dfun 雜誌" },
  74: { format: "film", kind: "institution", publisher: "桃園市政府環境保護局" },
  75: { format: "article", kind: "reporting", publisher: "觸mii" },
  76: { format: "article", kind: "institution", publisher: "微笑台灣" },
  77: { format: "article", kind: "reporting", publisher: "Bella 儂儂" },
  78: { format: "article", kind: "institution", publisher: "黑秀網 HeyShow" },
  79: { format: "article", kind: "reporting", publisher: "ETtoday 新聞雲" },
  80: { format: "article", kind: "reporting", publisher: "立報傳媒" },
  81: { format: "article", kind: "reporting", publisher: "桃園電子報" },
  82: { format: "article", additionalFormats: ["film"], kind: "reporting", publisher: "新頭條 TheHubNews" },
  83: { format: "article", kind: "reporting", publisher: "今周刊 Business Today" },
  63: { format: "article", kind: "interview" },
};
// Faithful English translations of the existing display text; raw source fields stay unchanged.
const englishDisplay = {
  10: [
    "The Human Soul of AI-Generated Art",
    "The most complete public account of the artist’s life: from the collapse of FTX to a renewal through absurdism, and from watchmaker to AI collaboration.",
  ],
  11: [
    "Creating Life with Algorithms",
    "A conversation with Porsche about how Che-Yu Wu moves beyond cold technology to generate digital worlds with warmth through code.",
  ],
  12: [
    "Creating Eternal Life and Emotion in a Digital World",
    "What is generative art? A self-examination by an artist who uses code as a paintbrush.",
  ],
  13: [
    "Why Art-Focused NFTs Are More Sought After",
    "Why might NFTs focused on art gain value by resisting market trends and profile-picture projects?",
  ],
  14: [
    "The Spark Between Programming and Interaction Design",
    "A conversation about freelancing, starting a business, and crossing disciplines from electrical engineering at NCTU to NYU.",
  ],
  51: [
    "Science Hall of Fame: Is Art Related to Mathematics?",
    "Creating art with mathematics and code: an exploration of aesthetics from fractals to particle systems.",
  ],
  52: [
    "1,000 Days of NYCU",
    "An official NYCU documentary featuring Che-Yu Wu’s reflections on creation and teaching.",
  ],
  54: [
    "A Taiwanese Talent Makes His Way in New York",
    "From electrical engineering at NCTU to new media art at NYU: a Taiwanese engineer’s transition across disciplines.",
  ],
  55: [
    "Che-Yu Wu: Creating Eternal Art with Code",
    "Mandarin Daily News interviews an artist who turns code into a paintbrush.",
  ],
  56: [
    "A Taiwanese NFT Talent, Featuring Che-Yu Wu",
    "From generative art to NFTs: a creative journey and a conversation about why Taiwanese artists can shine internationally.",
  ],
  57: ["The Great Equation Solo Exhibition at Taipei 101", null],
  58: ["SoulFish at the Yilan Festival", null],
  60: [
    "akaRadio EP18: A Generative Art Special",
    "What is generative art? How algorithms become a language for creation.",
  ],
  62: [
    "The Great Equation: Can Code Grow a Soul?",
    "A column on the Ministry of Culture’s cultural technology platform. Looking back from the Taipei 101 solo exhibition at questions of mechanisms, life and the soul of algorithms.",
  ],
};
for (const [id, [title, excerpt]] of Object.entries(englishDisplay)) {
  const entry = (presentation[id] ||= {});
  entry.displayTitle = { ...entry.displayTitle, en: title };
  if (excerpt) entry.displayExcerpt = { ...entry.displayExcerpt, en: excerpt };
}
// Verified against each original publisher on 2026-09-09. Year-only remains year-only.
export const publicationDates = {
  277: "2021-12-16",
  276: "2026-10-14",
  275: "2026-10-08",
  274: "2026-10-08",
  273: "2026-10-08",
  272: "2026-10-08",
  271: "2026-10-08",
  270: "2026-10-07",
  269: "2026-10-06",
  268: "2026-09-30",
  267: "2026-09-23",
  266: "2026-09-23",
  265: "2026-09-23",
  264: "2026-09-23",
  263: "2026-09-23",
  262: "2026-09-23",
  261: "2026-09-23",
  260: "2026-09-23",
  259: "2026-09-23",
  258: "2026-09-10",
  257: "2026-08-28",
  256: "2026-08-10",
  255: "2026-08-07",
  254: "2026-08-02",
  253: "2026-07-07",
  252: "2026-06-28",
  251: "2026-05-22",
  250: "2026-05-06",
  249: "2026-05-05",
  248: "2026-05-01",
  247: "2026-05-01",
  246: "2026-04-30",
  245: "2026-04-30",
  244: "2026-04-30",
  243: "2026-04-29",
  242: "2026-04-27",
  241: "2026-04-27",
  240: "2026-04-27",
  239: "2026-04-27",
  238: "2026-04-22",
  237: "2026-04-22",
  236: "2026-04-09",
  235: "2026-04-02",
  234: "2026-04-01",
  233: "2026-03-24",
  232: "2026-03-22",
  231: "2026-03-20",
  230: "2026-03-19",
  229: "2026-03-19",
  228: "2026-03-18",
  227: "2026-03-18",
  226: "2026-02-11",
  225: "2026-01-13",
  224: "2026-03-26",
  223: "2017-06-16",
  222: "2025-11-01",
  221: "2025-10-22",
  220: "2025-08-02",
  219: "2025-07-30",
  218: "2025-07-28",
  217: "2025-07-25",
  216: "2025-07-25",
  215: "2025-07-25",
  214: "2025-07-25",
  213: "2025-07-25",
  212: "2025-07-23",
  211: "2025-07-06",
  210: "2025-07-03",
  209: "2025-07-02",
  208: "2025-07-24",
  207: "2025-05-20",
  206: "2024-12-20",
  205: "2024-12-17",
  204: "2024-12-16",
  203: "2024-09-22",
  202: "2024-07-11",
  201: "2024-06-30",
  200: "2024-06-28",
  199: "2024-06-21",
  198: "2024",
  197: "2024-03-27",
  196: "2022-08-03",
  195: "2024-03-25",
  194: "2024-01-07",
  193: "2024-01-01",
  192: "2023-12-28",
  191: "2023-12-25",
  190: "2023-12-22",
  189: "2023-12-21",
  188: "2023-12-21",
  187: "2023-12-20",
  186: "2023-12-20",
  185: "2023-12-20",
  184: "2023-12-05",
  183: "2023-11-30",
  182: "2023-10-12",
  181: "2023-10-04",
  180: "2023-10-04",
  179: "2023-10-03",
  178: "2023-10-02",
  177: "2023-10-02",
  176: "2023-10-02",
  175: "2023-10-02",
  174: "2023-10-02",
  173: "2023",
  172: "2023-08-26",
  171: "2023-08-26",
  170: "2023-08-09",
  169: "2023-07-14",
  168: "2023-05-21",
  167: "2023-05-19",
  166: "2023-03-23",
  165: "2023-03-21",
  164: "2023-03-15",
  163: "2023-01-30",
  162: "2023-01-02",
  161: "2023-02-28",
  160: "2022-10-17",
  159: "2022-11-23",
  158: "2022-11-17",
  157: "2022-11-12",
  156: "2022-11-10",
  155: "2022-11-06",
  154: "2022-11-04",
  153: "2022-11-03",
  152: "2022-11-02",
  151: "2022-10-21",
  150: "2022-10-18",
  149: "2022-10-18",
  148: "2022-09-17",
  147: "2022-09-16",
  146: "2022-09-03",
  145: "2022-08-26",
  144: "2022-08-27",
  143: "2022-08-26",
  142: "2022-08-19",
  141: "2022-07-15",
  140: "2022-07-01",
  139: "2022-06-30",
  138: "2022-06-04",
  137: "2022-05-30",
  136: "2022-05-30",
  135: "2022-05-20",
  134: "2022-05-19",
  133: "2022-05-19",
  132: "2022-05-19",
  131: "2022-05-19",
  130: "2022-05-18",
  129: "2022-05-18",
  128: "2022-05-18",
  127: "2022-05-18",
  126: "2022-05-18",
  125: "2022-05-18",
  124: "2022-05-16",
  123: "2022-04-12",
  122: "2022-04-11",
  121: "2022-03-11",
  120: "2022-03-07",
  119: "2022-02-24",
  118: "2022-02-08",
  117: "2022-02-07",
  116: "2022-02-07",
  115: "2022-01-06",
  114: "2022",
  113: "2022-01-25",
  112: "2022-01-25",
  111: "2022-01-24",
  110: "2022-01-24",
  109: "2022-01-24",
  108: "2022-01-24",
  107: "2022-01-21",
  106: "2021-12-24",
  105: "2021-12-21",
  104: "2021-12-20",
  103: "2021-12-17",
  102: "2021-12-17",
  101: "2021-12-17",
  100: "2021-12-16",
  99: "2021-12-15",
  98: "2021-12-05",
  97: "2021-08-01",
  96: "2020-07-04",
  95: "2020-06-29",
  94: "2020-04-27",
  93: "2018-06-24",
  92: "2017-06-13",
  91: "2017-05-04",
  90: "2017-03-14",
  89: "2014-12-22",
  88: "2013-10-21",
  87: "2013-02-06",
  86: "2012-02-15",
  85: "2011-09-08",
  84: "2011-07-24",
  83: "2026-10-14",
  82: "2026-10-08",
  81: "2026-10-08",
  80: "2026-10-08",
  79: "2026-10-08",
  78: "2026-10-06",
  77: "2026-10-05",
  76: "2026-10-04",
  75: "2026-10-03",
  74: "2026-10-02",
  73: "2026-09-28",
  72: "2026-10-02",
  71: "2026-10-01",
  70: "2026-09-25",
  69: "2026-09-27",
  68: "2026-09-27",
  67: "2026-09-24",
  66: "2026-09-24",
  65: "2026-09-24",
  64: "2026-09-23",
  63: "2026-08-21",
  62: "2026",
  10: "2025-09-29",
  11: "2023-10-27",
  12: "2024-03-26",
  13: "2022-02-15",
  14: "2020-06-28",
  50: "2024-06-21",
  51: "2024-03-09",
  52: "2024-05-09",
  53: "2022-03-17",
  54: "2021-12-24",
  55: "2024-12-21",
  56: "2024-01-25",
  57: "2023-10-02",
  58: "2023-12-27",
  59: "2021-12-08",
  60: "2024-04-11",
  61: "2025-07-03",
};
// 2026-10-15 SSOT 對齊鍵：每筆對應 Obsidian〈吳哲宇媒體資訊中心〉的代號（docs/PRESS.md）。
export const hubCodes = {
  277: "NF60",
  276: "TWMD20",
  275: "EX58",
  274: "EX54",
  273: "EX53",
  272: "EX48",
  271: "EX47",
  270: "EX55",
  269: "EX56",
  268: "EX57",
  267: "EX35",
  266: "EX33",
  265: "EX32",
  264: "EX31",
  263: "EX30",
  262: "EX29",
  261: "EX28",
  260: "EX27",
  259: "EX26",
  258: "TWMD19",
  257: "TWMD18",
  256: "EX106",
  255: "TWMD8",
  254: "EX105",
  253: "OT15",
  252: "EX104",
  251: "PD26",
  250: "PD10",
  249: "PD9",
  248: "OT14",
  247: "EX103",
  246: "EX102",
  245: "EX101",
  244: "EX100",
  243: "PD8",
  242: "OT13",
  241: "OT12",
  240: "OT11",
  239: "EX99",
  238: "EX98",
  237: "EX97",
  236: "OT10",
  235: "TWMD4",
  234: "OT9",
  233: "TWMD14",
  232: "TWMD13",
  231: "TWMD12",
  230: "TWMD10",
  229: "WR6",
  228: "TWMD2",
  227: "TWMD1",
  226: "BR23",
  225: "TV16",
  224: "OT8",
  223: "OC2",
  222: "EX96",
  221: "TV15",
  220: "BR18",
  219: "BR21",
  218: "BR17",
  217: "BR19",
  216: "BR15",
  215: "BR14",
  214: "BR13",
  213: "BR12",
  212: "BR11",
  211: "EX64",
  210: "EX63",
  209: "EX62",
  208: "BR16",
  207: "PD11",
  206: "EX60",
  205: "EX59",
  204: "EX2",
  203: "TV13",
  202: "NF59",
  201: "TV4",
  200: "TV10",
  199: "TV9",
  198: "TV8",
  197: "PD23",
  196: "PD22",
  195: "PD21",
  194: "EX7",
  193: "NF9",
  192: "EX8",
  191: "EX10",
  190: "EX4",
  189: "EX6",
  188: "EX12",
  187: "EX9",
  186: "EX14",
  185: "EX11",
  184: "EX86",
  183: "BR2",
  182: "EX85",
  181: "EX24",
  180: "EX23",
  179: "EX20",
  178: "EX81",
  177: "EX80",
  176: "EX21",
  175: "EX19",
  174: "EX83",
  173: "BR8",
  172: "EX92",
  171: "EX91",
  170: "INT8",
  169: "EX90",
  168: "INT7",
  167: "NF57",
  166: "PD20",
  165: "NF56",
  164: "BR7",
  163: "EX88",
  162: "NF55",
  161: "INT6",
  160: "PD13",
  159: "BR6",
  158: "NF53",
  157: "NF52",
  156: "NF51",
  155: "NF50",
  154: "NF49",
  153: "NF48",
  152: "NF47",
  151: "PD19",
  150: "NF16",
  149: "INT5",
  148: "NF46",
  147: "NF45",
  146: "NF43",
  145: "NF44",
  144: "NF42",
  143: "NF41",
  142: "NF40",
  141: "NF38",
  140: "NF37",
  139: "NF36",
  138: "EX87",
  137: "EX76",
  136: "EX16",
  135: "EX75",
  134: "EX74",
  133: "EX73",
  132: "EX72",
  131: "EX71",
  130: "EX70",
  129: "EX69",
  128: "EX68",
  127: "EX67",
  126: "EX17",
  125: "EX15",
  124: "NF6",
  123: "NF5",
  122: "NF3",
  121: "NF34",
  120: "NF2",
  119: "INT3",
  118: "NF33",
  117: "NF32",
  116: "NF31",
  115: "NF15",
  114: "NF14",
  113: "NF8",
  112: "NF30",
  111: "NF29",
  110: "NF27",
  109: "NF26",
  108: "NF25",
  107: "NF1",
  106: "NF24",
  105: "NF11",
  104: "NF23",
  103: "PD16",
  102: "NF22",
  101: "NF21",
  100: "NF19",
  99: "NF18",
  98: "NF7",
  97: "NF12",
  96: "PD15",
  95: "PD14",
  94: "GL3",
  93: "OC3",
  92: "OC1",
  91: "GL1",
  90: "GL2",
  89: "OT2",
  88: "TV5",
  87: "AW3",
  86: "AW1",
  85: "AW2",
  84: "AW5",
  83: "TWMD9",
  82: "EX51",
  81: "EX52",
  80: "EX50",
  79: "EX49",
  78: "EX46",
  77: "EX45",
  76: "EX44",
  75: "EX43",
  74: "EX42",
  73: "EX41",
  72: "EX40",
  71: "WR5",
  70: "NM4",
  69: "PD12",
  68: "EX39",
  67: "EX38",
  66: "EX36",
  65: "EX34",
  64: "EX25",
  63: "INT1",
  62: "WR4",
  61: "EX1",
  60: "PD5",
  59: "PD7",
  58: "EX3",
  57: "EX18",
  56: "PD3",
  55: "BR3",
  54: "NF4",
  53: "NF10",
  52: "TV1",
  51: "TV2",
  50: "TV3",
  14: "PD6",
  13: "PD2",
  12: "PD4",
  11: "BR1",
  10: "PD1",
};
// 2026-10-15 系列（哲宇：資料、報導都要容易被找到，搜尋要搜得到全部，只有呈現方式 aggregate）：
// 同一件事的多篇報導在資料裡各自一筆（各有原刊縮圖、各進全站搜尋），只有 /press 瀏覽時收成一個系列。
// key＝媒體資訊中心代表列代號；lead＝策展提名的代表（品質最高的那篇，可換）；members 含 lead。docs/PRESS.md。
export const pressSeries = {
  BR1: { lead: 11, members: [173, 11], title: {"zh": "2023 Porsche 金屬魅影綠企劃"} },
  BR23: { lead: 226, members: [226, 220, 219, 218, 217, 216, 215, 214, 213, 212, 208], title: {"zh": "星巴克典藏 DREAM PLAZA《咖啡幻夢》"} },
  EX1: { lead: 61, members: [211, 210, 209, 61], title: {"zh": "2025 LG 透明 OLED T 發表會"} },
  EX2: { lead: 204, members: [206, 205, 204], title: {"zh": "2024 LG《永恆花境》Diamond Towers"} },
  EX3: { lead: 58, members: [194, 192, 191, 190, 189, 188, 187, 186, 185, 58], title: {"zh": "2023 宜蘭映像節《靈魂魚》"} },
  EX71: { lead: 131, members: [137, 136, 135, 134, 133, 132, 131, 130, 129, 128, 127, 126, 125], title: {"zh": "2022 混沌實驗室個展"} },
  EX24: { lead: 181, members: [184, 182, 181, 180, 179, 178, 177, 176, 175, 174, 57], title: {"zh": "2023 萬物公式個展"} },
  EX42: { lead: 74, members: [275, 274, 273, 269, 268, 267, 266, 265, 264, 263, 262, 261, 260, 259, 82, 81, 75, 74, 73, 68, 67, 66, 65, 64], title: {"zh": "2026 台灣設計展《桃園演算室》《大地與川脈的編織》"} },
  EX45: { lead: 77, members: [272, 271, 270, 80, 79, 78, 77, 76, 72], title: {"zh": "2026 台灣設計展《水之道》《Cymatics of Life》"} },
  EX90: { lead: 169, members: [172, 171, 169], title: {"zh": "2023 灣聲樂團北流《臺瘋音樂會》"} },
  EX100: { lead: 244, members: [247, 246, 245, 244, 239, 238, 237], title: {"zh": "2026 新北市美術館《新美花嘿噴？》"} },
  EX106: { lead: 256, members: [256, 254], title: {"zh": "2026 台北板橋馥華艾美酒店《演算詩篇：馥光子午》"} },
  NF2: { lead: 120, members: [122, 120], title: {"zh": "2022 天下雜誌 743 期 NFT 專訪"} },
  NF4: { lead: 54, members: [106, 54], title: {"zh": "2021 遠見〈闖進紐約的台灣之光〉"} },
  NF29: { lead: 111, members: [113, 112, 111, 110, 109, 108], title: {"zh": "2022 陽明交大校友元宇宙座談（施振榮）"} },
  PD16: { lead: 103, members: [277, 105, 104, 103, 102, 101, 100], title: {"zh": "2021 White Castle × Sliderverse NFT"} },
  NF32: { lead: 117, members: [118, 117, 116, 114], title: {"zh": "2022 施振榮新春拜年「千里馬」"} },
  NF16: { lead: 150, members: [160, 150, 148, 147, 145, 144, 143, 142], title: {"zh": "2022 林茲電子藝術節台灣專場《百岳計畫》"} },
  NF36: { lead: 139, members: [196, 167, 166, 165, 162, 146, 141, 139], title: {"zh": "FAB DAO《百岳計畫》發起與後續報導（2022–2024）"} },
  NF52: { lead: 157, members: [158, 157, 156, 155, 154, 153, 152], title: {"zh": "2022 TCCF 未來內容展《百岳計畫》"} },
  OC1: { lead: 92, members: [223, 92], title: {"zh": "2017 群眾觀點 Hahow 課程報導"} },
  OT9: { lead: 234, members: [236, 234], title: {"zh": "2026 科學人 AI 先行專欄"} },
  OT11: { lead: 240, members: [248, 242, 241, 240], title: {"zh": "2026 宏碁 50 週年施振榮談育才"} },
  PD2: { lead: 13, members: [195, 13], title: {"zh": "區塊勢 EP150"} },
  PD3: { lead: 56, members: [197, 56], title: {"zh": "轉吧！創夢大叔 EP112"} },
  PD6: { lead: 14, members: [96, 95, 14], title: {"zh": "不停 EP26 程式語言與互動設計"} },
  TV3: { lead: 50, members: [199, 50], title: {"zh": "TaiwanPlus《Art Attack》吳哲宇單元"} },
  TV4: { lead: 201, members: [201, 200, 198], title: {"zh": "2024 公視《神木之森》特映會"} },
  TWMD2: { lead: 228, members: [233, 232, 231, 230, 228, 227], title: {"zh": "2026 Taiwan.md 上線"} },
  TWMD9: { lead: 83, members: [276, 83], title: {"zh": "2026 今周刊 AI 語料與著作權"} },
};
const seriesOf = {};
for (const [key, s] of Object.entries(pressSeries))
  for (const id of s.members) seriesOf[id] = key;
export const matchesFormat = (item, format) =>
  format === "all" ||
  item.format === format ||
  item.additionalFormats?.includes(format);
export const records = pressRecords
  .map((item) => ({
    ...item,
    format: "article",
    kind: "reporting",
    language: "unspecified",
    ...presentation[item.id],
    date: publicationDates[item.id],
    hub: hubCodes[item.id],
    series: seriesOf[item.id],
    seriesLead: seriesOf[item.id] ? pressSeries[seriesOf[item.id]].lead === item.id : false,
    // 每筆的縮圖一律是該篇報導自己的影像（press-thumbs.mjs）；原始 thumb 欄位保留但不再顯示。
    thumb: pressThumbs[item.id] ? pressThumbPath(item.id) : item.thumb,
    thumbFit: pressThumbs[item.id]?.fit || "cover",
    thumbCredit: pressThumbs[item.id]?.credit,
  }))
  .sort((a, b) => b.date.localeCompare(a.date) || b.id - a.id);
// 瀏覽時把系列收起來：代表在場就把同系列其他篇掛在代表底下；代表被篩掉時，其他篇照常各自出現。
export function aggregateSeries(items) {
  const present = new Set(items.map((i) => i.id));
  const out = [];
  for (const item of items) {
    const key = item.series;
    if (!key) {
      out.push(item);
      continue;
    }
    const leadId = pressSeries[key].lead;
    if (item.id === leadId) {
      const members = items.filter((m) => m.series === key && m.id !== leadId);
      out.push(
        members.length
          ? { ...item, seriesMembers: members, seriesTitle: pressSeries[key].title }
          : item,
      );
    } else if (!present.has(leadId)) out.push(item);
  }
  return out;
}
export function filterPress(
  items,
  { query = "", year = "", format = "all", kind = "all" } = {},
) {
  const terms = query.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
  return items.filter(
    (item) =>
      (!year || item.date.slice(0, 4) === String(year)) &&
      matchesFormat(item, format) &&
      (kind === "all" || item.kind === kind) &&
      terms.every((term) =>
        [
          item.title,
          item.titleEn,
          item.excerpt,
          item.excerptEn,
          item.source,
          item.sourceEn,
          ...Object.values(item.displayTitle || {}),
          ...Object.values(item.displayExcerpt || {}),
        ]
          .filter(Boolean)
          .join(" ")
          .toLocaleLowerCase()
          .includes(term),
      ),
  );
}
